const regionSeatLibs = [
  {
    i: 1,
    n: "中国",
    c: [
      {
        i: 81714,
        n: "安徽省",
        c: [
          {
            i: 81715,
            n: "合肥市",
            c: [
              {
                i: 81717,
                n: "瑶海区",
              },
              {
                i: 81834,
                n: "庐阳区",
              },
              {
                i: 81949,
                n: "蜀山区",
              },
              {
                i: 82064,
                n: "包河区",
              },
              {
                i: 768078,
                n: "巢湖市",
              },
              {
                i: 767494,
                n: "庐江县",
              },
              {
                i: 82189,
                n: "长丰县",
              },
              {
                i: 82509,
                n: "肥东县",
              },
              {
                i: 83059,
                n: "肥西县",
              },
            ],
          },
          {
            i: 83410,
            n: "芜湖市",
            c: [
              {
                i: 83412,
                n: "镜湖区",
              },
              {
                i: 83485,
                n: "弋江区",
              },
              {
                i: 83547,
                n: "鸠江区",
              },
              {
                i: 83674,
                n: "湾沚区",
              },
              {
                i: 83821,
                n: "繁昌区",
              },
              {
                i: 99876,
                n: "无为市",
              },
              {
                i: 83929,
                n: "南陵县",
              },
            ],
          },
          {
            i: 84117,
            n: "蚌埠市",
            c: [
              {
                i: 84119,
                n: "龙子湖区",
              },
              {
                i: 84203,
                n: "蚌山区",
              },
              {
                i: 84288,
                n: "禹会区",
              },
              {
                i: 84376,
                n: "淮上区",
              },
              {
                i: 84437,
                n: "怀远县",
              },
              {
                i: 84862,
                n: "五河县",
              },
              {
                i: 85115,
                n: "固镇县",
              },
            ],
          },
          {
            i: 85357,
            n: "淮南市",
            c: [
              {
                i: 85359,
                n: "大通区",
              },
              {
                i: 85434,
                n: "田家庵区",
              },
              {
                i: 85563,
                n: "谢家集区",
              },
              {
                i: 85677,
                n: "八公山区",
              },
              {
                i: 85730,
                n: "潘集区",
              },
              {
                i: 101182,
                n: "寿县",
              },
              {
                i: 85919,
                n: "凤台县",
              },
            ],
          },
          {
            i: 86235,
            n: "马鞍山市",
            c: [
              {
                i: 86237,
                n: "金家庄区",
              },
              {
                i: 86279,
                n: "花山区",
              },
              {
                i: 86334,
                n: "雨山区",
              },
              {
                i: 768079,
                n: "博望区",
              },
              {
                i: 86407,
                n: "当涂县",
              },
              {
                i: 100347,
                n: "和县",
              },
              {
                i: 768096,
                n: "含山县",
              },
            ],
          },
          {
            i: 86640,
            n: "淮北市",
            c: [
              {
                i: 86642,
                n: "杜集区",
              },
              {
                i: 86759,
                n: "相山区",
              },
              {
                i: 86873,
                n: "烈山区",
              },
              {
                i: 87006,
                n: "濉溪县",
              },
            ],
          },
          {
            i: 87460,
            n: "铜陵市",
            c: [
              {
                i: 87462,
                n: "铜官区",
              },
              {
                i: 87622,
                n: "义安区",
              },
              {
                i: 87573,
                n: "郊区",
              },
              {
                i: 88283,
                n: "枞阳县",
              },
            ],
          },
          {
            i: 87753,
            n: "安庆市",
            c: [
              {
                i: 87755,
                n: "迎江区",
              },
              {
                i: 87836,
                n: "大观区",
              },
              {
                i: 87929,
                n: "宜秀区",
              },
              {
                i: 89574,
                n: "桐城市",
              },
              {
                i: 88564,
                n: "潜山市",
              },
              {
                i: 88021,
                n: "怀宁县",
              },
              {
                i: 88767,
                n: "太湖县",
              },
              {
                i: 88967,
                n: "宿松县",
              },
              {
                i: 89212,
                n: "望江县",
              },
              {
                i: 89361,
                n: "岳西县",
              },
            ],
          },
          {
            i: 89828,
            n: "黄山市",
            c: [
              {
                i: 89830,
                n: "屯溪区",
              },
              {
                i: 89911,
                n: "黄山区",
              },
              {
                i: 90055,
                n: "徽州区",
              },
              {
                i: 90136,
                n: "歙县",
              },
              {
                i: 90892,
                n: "黟县",
              },
              {
                i: 90603,
                n: "休宁县",
              },
              {
                i: 90987,
                n: "祁门县",
              },
            ],
          },
          {
            i: 91164,
            n: "滁州市",
            c: [
              {
                i: 91166,
                n: "琅琊区",
              },
              {
                i: 91241,
                n: "南谯区",
              },
              {
                i: 93057,
                n: "天长市",
              },
              {
                i: 93462,
                n: "明光市",
              },
              {
                i: 91431,
                n: "来安县",
              },
              {
                i: 91755,
                n: "全椒县",
              },
              {
                i: 91999,
                n: "定远县",
              },
              {
                i: 92597,
                n: "凤阳县",
              },
            ],
          },
          {
            i: 93856,
            n: "阜阳市",
            c: [
              {
                i: 93858,
                n: "颍州区",
              },
              {
                i: 94060,
                n: "颍东区",
              },
              {
                i: 94196,
                n: "颍泉区",
              },
              {
                i: 96304,
                n: "界首市",
              },
              {
                i: 94329,
                n: "临泉县",
              },
              {
                i: 95203,
                n: "太和县",
              },
              {
                i: 95547,
                n: "阜南县",
              },
              {
                i: 95925,
                n: "颍上县",
              },
            ],
          },
          {
            i: 96503,
            n: "宿州市",
            c: [
              {
                i: 96505,
                n: "埇桥区",
              },
              {
                i: 97412,
                n: "砀山县",
              },
              {
                i: 98558,
                n: "灵璧县",
              },
              {
                i: 97821,
                n: "萧县",
              },
              {
                i: 98905,
                n: "泗县",
              },
            ],
          },
          {
            i: 99394,
            n: "巢湖市",
            c: [
              {
                i: 99396,
                n: "居巢区",
              },
              {
                i: 99619,
                n: "庐江县",
              },
              {
                i: 100221,
                n: "含山县",
              },
            ],
          },
          {
            i: 100497,
            n: "六安市",
            c: [
              {
                i: 100499,
                n: "金安区",
              },
              {
                i: 100858,
                n: "裕安区",
              },
              {
                i: 768113,
                n: "叶集区",
              },
              {
                i: 101833,
                n: "霍邱县",
              },
              {
                i: 102650,
                n: "舒城县",
              },
              {
                i: 103094,
                n: "金寨县",
              },
              {
                i: 103556,
                n: "霍山县",
              },
            ],
          },
          {
            i: 103717,
            n: "亳州市",
            c: [
              {
                i: 103719,
                n: "谯城区",
              },
              {
                i: 104425,
                n: "涡阳县",
              },
              {
                i: 104848,
                n: "蒙城县",
              },
              {
                i: 105199,
                n: "利辛县",
              },
            ],
          },
          {
            i: 105719,
            n: "池州市",
            c: [
              {
                i: 105721,
                n: "贵池区",
              },
              {
                i: 106049,
                n: "东至县",
              },
              {
                i: 106344,
                n: "石台县",
              },
              {
                i: 106490,
                n: "青阳县",
              },
            ],
          },
          {
            i: 106680,
            n: "宣城市",
            c: [
              {
                i: 106682,
                n: "宣州区",
              },
              {
                i: 107072,
                n: "广德市",
              },
              {
                i: 107563,
                n: "宁国市",
              },
              {
                i: 107235,
                n: "泾县",
              },
              {
                i: 106946,
                n: "郎溪县",
              },
              {
                i: 107392,
                n: "绩溪县",
              },
              {
                i: 107484,
                n: "旌德县",
              },
            ],
          },
        ],
      },
      {
        i: 74873,
        n: "北京市",
        c: [
          {
            i: 768109,
            n: "北京市",
            c: [
              {
                i: 75383,
                n: "朝阳区",
              },
              {
                i: 76468,
                n: "海淀区",
              },
              {
                i: 74875,
                n: "东城区",
              },
              {
                i: 75012,
                n: "西城区",
              },
              {
                i: 75172,
                n: "崇文区",
              },
              {
                i: 75265,
                n: "宣武区",
              },
              {
                i: 75976,
                n: "丰台区",
              },
              {
                i: 79113,
                n: "昌平区",
              },
              {
                i: 76330,
                n: "石景山区",
              },
              {
                i: 79579,
                n: "大兴区",
              },
              {
                i: 77433,
                n: "房山区",
              },
              {
                i: 78031,
                n: "通州区",
              },
              {
                i: 78596,
                n: "顺义区",
              },
              {
                i: 80553,
                n: "平谷区",
              },
              {
                i: 80223,
                n: "怀柔区",
              },
              {
                i: 77147,
                n: "门头沟区",
              },
              {
                i: 80873,
                n: "密云区",
              },
              {
                i: 81293,
                n: "延庆区",
              },
            ],
          },
        ],
      },
      {
        i: 2,
        n: "福建省",
        c: [
          {
            i: 3,
            n: "福州市",
            c: [
              {
                i: 5,
                n: "鼓楼区",
              },
              {
                i: 92,
                n: "台江区",
              },
              {
                i: 176,
                n: "仓山区",
              },
              {
                i: 373,
                n: "马尾区",
              },
              {
                i: 452,
                n: "晋安区",
              },
              {
                i: 2801,
                n: "长乐区",
              },
              {
                i: 2286,
                n: "福清市",
              },
              {
                i: 634,
                n: "闽侯县",
              },
              {
                i: 971,
                n: "连江县",
              },
              {
                i: 1266,
                n: "罗源县",
              },
              {
                i: 1474,
                n: "闽清县",
              },
              {
                i: 1782,
                n: "永泰县",
              },
              {
                i: 2068,
                n: "平潭县",
              },
            ],
          },
          {
            i: 3076,
            n: "厦门市",
            c: [
              {
                i: 3077,
                n: "市辖区",
              },
              {
                i: 3078,
                n: "思明区",
              },
              {
                i: 3190,
                n: "海沧区",
              },
              {
                i: 3236,
                n: "湖里区",
              },
              {
                i: 3297,
                n: "集美区",
              },
              {
                i: 3366,
                n: "同安区",
              },
              {
                i: 3510,
                n: "翔安区",
              },
            ],
          },
          {
            i: 3631,
            n: "莆田市",
            c: [
              {
                i: 3632,
                n: "市辖区",
              },
              {
                i: 3633,
                n: "城厢区",
              },
              {
                i: 3760,
                n: "涵江区",
              },
              {
                i: 3974,
                n: "荔城区",
              },
              {
                i: 4111,
                n: "秀屿区",
              },
              {
                i: 4323,
                n: "仙游县",
              },
            ],
          },
          {
            i: 4668,
            n: "三明市",
            c: [
              {
                i: 4670,
                n: "梅列区",
              },
              {
                i: 4724,
                n: "三元区",
              },
              {
                i: 5858,
                n: "沙县区",
              },
              {
                i: 6455,
                n: "永安市",
              },
              {
                i: 4809,
                n: "明溪县",
              },
              {
                i: 4914,
                n: "清流县",
              },
              {
                i: 5047,
                n: "宁化县",
              },
              {
                i: 5286,
                n: "大田县",
              },
              {
                i: 5581,
                n: "尤溪县",
              },
              {
                i: 6052,
                n: "将乐县",
              },
              {
                i: 6217,
                n: "泰宁县",
              },
              {
                i: 6344,
                n: "建宁县",
              },
            ],
          },
          {
            i: 6728,
            n: "泉州市",
            c: [
              {
                i: 6729,
                n: "市辖区",
              },
              {
                i: 6730,
                n: "鲤城区",
              },
              {
                i: 6819,
                n: "丰泽区",
              },
              {
                i: 6899,
                n: "洛江区",
              },
              {
                i: 6992,
                n: "泉港区",
              },
              {
                i: 8392,
                n: "石狮市",
              },
              {
                i: 8527,
                n: "晋江市",
              },
              {
                i: 8958,
                n: "南安市",
              },
              {
                i: 7102,
                n: "惠安县",
              },
              {
                i: 7414,
                n: "安溪县",
              },
              {
                i: 7911,
                n: "永春县",
              },
              {
                i: 8170,
                n: "德化县",
              },
              {
                i: 8391,
                n: "金门县",
              },
            ],
          },
          {
            i: 9403,
            n: "漳州市",
            c: [
              {
                i: 9405,
                n: "芗城区",
              },
              {
                i: 9579,
                n: "龙文区",
              },
              {
                i: 10454,
                n: "长泰区",
              },
              {
                i: 11216,
                n: "龙海区",
              },
              {
                i: 9637,
                n: "云霄县",
              },
              {
                i: 9848,
                n: "漳浦县",
              },
              {
                i: 10194,
                n: "诏安县",
              },
              {
                i: 10540,
                n: "东山县",
              },
              {
                i: 10625,
                n: "南靖县",
              },
              {
                i: 10835,
                n: "平和县",
              },
              {
                i: 11109,
                n: "华安县",
              },
            ],
          },
          {
            i: 11533,
            n: "南平市",
            c: [
              {
                i: 11534,
                n: "市辖区",
              },
              {
                i: 11535,
                n: "延平区",
              },
              {
                i: 13336,
                n: "建阳区",
              },
              {
                i: 12716,
                n: "邵武市",
              },
              {
                i: 13064,
                n: "建瓯市",
              },
              {
                i: 12918,
                n: "武夷山市",
              },
              {
                i: 11871,
                n: "顺昌县",
              },
              {
                i: 12030,
                n: "浦城县",
              },
              {
                i: 12350,
                n: "光泽县",
              },
              {
                i: 12456,
                n: "松溪县",
              },
              {
                i: 12574,
                n: "政和县",
              },
            ],
          },
          {
            i: 13562,
            n: "龙岩市",
            c: [
              {
                i: 13563,
                n: "市辖区",
              },
              {
                i: 13564,
                n: "新罗区",
              },
              {
                i: 14227,
                n: "永定区",
              },
              {
                i: 15392,
                n: "漳平市",
              },
              {
                i: 13912,
                n: "长汀县",
              },
              {
                i: 14533,
                n: "上杭县",
              },
              {
                i: 14898,
                n: "武平县",
              },
              {
                i: 15133,
                n: "连城县",
              },
            ],
          },
          {
            i: 15608,
            n: "宁德市",
            c: [
              {
                i: 15609,
                n: "市辖区",
              },
              {
                i: 15610,
                n: "蕉城区",
              },
              {
                i: 17238,
                n: "福安市",
              },
              {
                i: 17748,
                n: "福鼎市",
              },
              {
                i: 15934,
                n: "霞浦县",
              },
              {
                i: 16264,
                n: "古田县",
              },
              {
                i: 16568,
                n: "屏南县",
              },
              {
                i: 16737,
                n: "寿宁县",
              },
              {
                i: 16955,
                n: "周宁县",
              },
              {
                i: 17112,
                n: "柘荣县",
              },
            ],
          },
        ],
      },
      {
        i: 55845,
        n: "甘肃省",
        c: [
          {
            i: 55846,
            n: "兰州市",
            c: [
              {
                i: 55848,
                n: "城关区",
              },
              {
                i: 56044,
                n: "七里河区",
              },
              {
                i: 56200,
                n: "西固区",
              },
              {
                i: 56336,
                n: "安宁区",
              },
              {
                i: 56401,
                n: "红古区",
              },
              {
                i: 56465,
                n: "永登县",
              },
              {
                i: 56735,
                n: "皋兰县",
              },
              {
                i: 56817,
                n: "榆中县",
              },
            ],
          },
          {
            i: 57113,
            n: "嘉峪关市",
            c: [
              {
                i: 57114,
                n: "市辖区",
              },
            ],
          },
          {
            i: 57188,
            n: "金昌市",
            c: [
              {
                i: 57189,
                n: "市辖区",
              },
              {
                i: 57190,
                n: "金川区",
              },
              {
                i: 57252,
                n: "永昌县",
              },
            ],
          },
          {
            i: 57384,
            n: "白银市",
            c: [
              {
                i: 57385,
                n: "市辖区",
              },
              {
                i: 57386,
                n: "白银区",
              },
              {
                i: 57473,
                n: "平川区",
              },
              {
                i: 57569,
                n: "靖远县",
              },
              {
                i: 57770,
                n: "会宁县",
              },
              {
                i: 58092,
                n: "景泰县",
              },
            ],
          },
          {
            i: 58262,
            n: "天水市",
            c: [
              {
                i: 58264,
                n: "秦州区",
              },
              {
                i: 58751,
                n: "麦积区",
              },
              {
                i: 59179,
                n: "清水县",
              },
              {
                i: 59462,
                n: "秦安县",
              },
              {
                i: 60001,
                n: "甘谷县",
              },
              {
                i: 60428,
                n: "武山县",
              },
              {
                i: 60796,
                n: "张家川回族自治县",
              },
            ],
          },
          {
            i: 61085,
            n: "武威市",
            c: [
              {
                i: 61087,
                n: "凉州区",
              },
              {
                i: 61633,
                n: "民勤县",
              },
              {
                i: 61925,
                n: "古浪县",
              },
              {
                i: 62203,
                n: "天祝藏族自治县",
              },
            ],
          },
          {
            i: 62415,
            n: "张掖市",
            c: [
              {
                i: 62417,
                n: "甘州区",
              },
              {
                i: 62710,
                n: "肃南裕固族自治县",
              },
              {
                i: 62827,
                n: "民乐县",
              },
              {
                i: 63057,
                n: "临泽县",
              },
              {
                i: 63153,
                n: "高台县",
              },
              {
                i: 63309,
                n: "山丹县",
              },
            ],
          },
          {
            i: 63447,
            n: "平凉市",
            c: [
              {
                i: 63449,
                n: "崆峒区",
              },
              {
                i: 64279,
                n: "华亭市",
              },
              {
                i: 63737,
                n: "泾川县",
              },
              {
                i: 63978,
                n: "灵台县",
              },
              {
                i: 64182,
                n: "崇信县",
              },
              {
                i: 64418,
                n: "庄浪县",
              },
              {
                i: 64734,
                n: "静宁县",
              },
            ],
          },
          {
            i: 65157,
            n: "酒泉市",
            c: [
              {
                i: 65159,
                n: "肃州区",
              },
              {
                i: 65581,
                n: "玉门市",
              },
              {
                i: 65668,
                n: "敦煌市",
              },
              {
                i: 65340,
                n: "金塔县",
              },
              {
                i: 65445,
                n: "瓜州县",
              },
              {
                i: 65531,
                n: "肃北蒙古族自治县",
              },
              {
                i: 65563,
                n: "阿克塞哈萨克族自治县",
              },
            ],
          },
          {
            i: 65773,
            n: "庆阳市",
            c: [
              {
                i: 65774,
                n: "市辖区",
              },
              {
                i: 65775,
                n: "西峰区",
              },
              {
                i: 65904,
                n: "庆城县",
              },
              {
                i: 66079,
                n: "环县",
              },
              {
                i: 66354,
                n: "华池县",
              },
              {
                i: 66482,
                n: "合水县",
              },
              {
                i: 66580,
                n: "正宁县",
              },
              {
                i: 66686,
                n: "宁县",
              },
              {
                i: 66969,
                n: "镇原县",
              },
            ],
          },
          {
            i: 67206,
            n: "定西市",
            c: [
              {
                i: 67207,
                n: "市辖区",
              },
              {
                i: 67208,
                n: "安定区",
              },
              {
                i: 67547,
                n: "通渭县",
              },
              {
                i: 67898,
                n: "陇西县",
              },
              {
                i: 68142,
                n: "渭源县",
              },
              {
                i: 68379,
                n: "临洮县",
              },
              {
                i: 68729,
                n: "漳县",
              },
              {
                i: 68880,
                n: "岷县",
              },
            ],
          },
          {
            i: 69209,
            n: "陇南市",
            c: [
              {
                i: 69210,
                n: "市辖区",
              },
              {
                i: 69211,
                n: "武都区",
              },
              {
                i: 69952,
                n: "成县",
              },
              {
                i: 70229,
                n: "文县",
              },
              {
                i: 70562,
                n: "宕昌县",
              },
              {
                i: 70926,
                n: "康县",
              },
              {
                i: 71306,
                n: "西和县",
              },
              {
                i: 71717,
                n: "礼县",
              },
              {
                i: 72324,
                n: "徽县",
              },
              {
                i: 72595,
                n: "两当县",
              },
            ],
          },
          {
            i: 72730,
            n: "临夏回族自治州",
            c: [
              {
                i: 72731,
                n: "临夏市",
              },
              {
                i: 72810,
                n: "临夏县",
              },
              {
                i: 73057,
                n: "康乐县",
              },
              {
                i: 73226,
                n: "永靖县",
              },
              {
                i: 73393,
                n: "广河县",
              },
              {
                i: 73506,
                n: "和政县",
              },
              {
                i: 73643,
                n: "东乡族自治县",
              },
              {
                i: 73898,
                n: "积石山保安族东乡族撒拉族自治县",
              },
            ],
          },
          {
            i: 74067,
            n: "甘南藏族自治州",
            c: [
              {
                i: 74068,
                n: "合作市",
              },
              {
                i: 74125,
                n: "临潭县",
              },
              {
                i: 74284,
                n: "卓尼县",
              },
              {
                i: 74401,
                n: "舟曲县",
              },
              {
                i: 74634,
                n: "迭部县",
              },
              {
                i: 74700,
                n: "玛曲县",
              },
              {
                i: 74753,
                n: "碌曲县",
              },
              {
                i: 74790,
                n: "夏河县",
              },
            ],
          },
        ],
      },
      {
        i: 107712,
        n: "广东省",
        c: [
          {
            i: 107713,
            n: "广州市",
            c: [
              {
                i: 107714,
                n: "荔湾区",
              },
              {
                i: 107931,
                n: "越秀区",
              },
              {
                i: 108238,
                n: "海珠区",
              },
              {
                i: 108514,
                n: "天河区",
              },
              {
                i: 108724,
                n: "白云区",
              },
              {
                i: 109096,
                n: "黄埔区",
              },
              {
                i: 109163,
                n: "番禺区",
              },
              {
                i: 109505,
                n: "花都区",
              },
              {
                i: 109747,
                n: "南沙区",
              },
              {
                i: 109828,
                n: "萝岗区",
              },
              {
                i: 109892,
                n: "增城区",
              },
              {
                i: 110221,
                n: "从化区",
              },
            ],
          },
          {
            i: 112083,
            n: "深圳市",
            c: [
              {
                i: 112084,
                n: "罗湖区",
              },
              {
                i: 112210,
                n: "福田区",
              },
              {
                i: 112313,
                n: "南山区",
              },
              {
                i: 112420,
                n: "宝安区",
              },
              {
                i: 112608,
                n: "龙岗区",
              },
              {
                i: 768100,
                n: "龙华区",
              },
              {
                i: 112771,
                n: "盐田区",
              },
            ],
          },
          {
            i: 110501,
            n: "韶关市",
            c: [
              {
                i: 110502,
                n: "武江区",
              },
              {
                i: 110589,
                n: "浈江区",
              },
              {
                i: 110714,
                n: "曲江区",
              },
              {
                i: 111586,
                n: "乐昌市",
              },
              {
                i: 111832,
                n: "南雄市",
              },
              {
                i: 110836,
                n: "始兴县",
              },
              {
                i: 110976,
                n: "仁化县",
              },
              {
                i: 111111,
                n: "翁源县",
              },
              {
                i: 111423,
                n: "新丰县",
              },
              {
                i: 111294,
                n: "乳源瑶族自治县",
              },
            ],
          },
          {
            i: 112797,
            n: "珠海市",
            c: [
              {
                i: 112798,
                n: "香洲区",
              },
              {
                i: 112949,
                n: "斗门区",
              },
              {
                i: 113080,
                n: "金湾区",
              },
            ],
          },
          {
            i: 113125,
            n: "汕头市",
            c: [
              {
                i: 113126,
                n: "龙湖区",
              },
              {
                i: 113244,
                n: "金平区",
              },
              {
                i: 113422,
                n: "濠江区",
              },
              {
                i: 113490,
                n: "潮阳区",
              },
              {
                i: 113775,
                n: "潮南区",
              },
              {
                i: 114019,
                n: "澄海区",
              },
              {
                i: 114205,
                n: "南澳县",
              },
            ],
          },
          {
            i: 114247,
            n: "佛山市",
            c: [
              {
                i: 114248,
                n: "禅城区",
              },
              {
                i: 114394,
                n: "南海区",
              },
              {
                i: 114698,
                n: "顺德区",
              },
              {
                i: 114907,
                n: "三水区",
              },
              {
                i: 114992,
                n: "高明区",
              },
            ],
          },
          {
            i: 115077,
            n: "江门市",
            c: [
              {
                i: 115078,
                n: "蓬江区",
              },
              {
                i: 115227,
                n: "江海区",
              },
              {
                i: 115298,
                n: "新会区",
              },
              {
                i: 115540,
                n: "台山市",
              },
              {
                i: 115872,
                n: "开平市",
              },
              {
                i: 116160,
                n: "鹤山市",
              },
              {
                i: 116315,
                n: "恩平市",
              },
            ],
          },
          {
            i: 116502,
            n: "湛江市",
            c: [
              {
                i: 116503,
                n: "赤坎区",
              },
              {
                i: 116550,
                n: "霞山区",
              },
              {
                i: 116643,
                n: "坡头区",
              },
              {
                i: 116720,
                n: "麻章区",
              },
              {
                i: 117353,
                n: "廉江市",
              },
              {
                i: 117764,
                n: "雷州市",
              },
              {
                i: 118264,
                n: "吴川市",
              },
              {
                i: 116845,
                n: "遂溪县",
              },
              {
                i: 117128,
                n: "徐闻县",
              },
            ],
          },
          {
            i: 118472,
            n: "茂名市",
            c: [
              {
                i: 118473,
                n: "茂南区",
              },
              {
                i: 118702,
                n: "茂港区",
              },
              {
                i: 118813,
                n: "电白区",
              },
              {
                i: 119159,
                n: "高州市",
              },
              {
                i: 119680,
                n: "化州市",
              },
              {
                i: 120083,
                n: "信宜市",
              },
            ],
          },
          {
            i: 120491,
            n: "肇庆市",
            c: [
              {
                i: 120492,
                n: "端州区",
              },
              {
                i: 120585,
                n: "鼎湖区",
              },
              {
                i: 121625,
                n: "高要区",
              },
              {
                i: 121993,
                n: "四会市",
              },
              {
                i: 120676,
                n: "广宁县",
              },
              {
                i: 120872,
                n: "怀集县",
              },
              {
                i: 121216,
                n: "封开县",
              },
              {
                i: 121432,
                n: "德庆县",
              },
            ],
          },
          {
            i: 122170,
            n: "惠州市",
            c: [
              {
                i: 122171,
                n: "惠城区",
              },
              {
                i: 122452,
                n: "惠阳区",
              },
              {
                i: 122625,
                n: "博罗县",
              },
              {
                i: 123021,
                n: "惠东县",
              },
              {
                i: 123329,
                n: "龙门县",
              },
            ],
          },
          {
            i: 123530,
            n: "梅州市",
            c: [
              {
                i: 123531,
                n: "梅江区",
              },
              {
                i: 123630,
                n: "梅县区",
              },
              {
                i: 125385,
                n: "兴宁市",
              },
              {
                i: 124070,
                n: "大埔县",
              },
              {
                i: 124344,
                n: "丰顺县",
              },
              {
                i: 124643,
                n: "五华县",
              },
              {
                i: 125105,
                n: "平远县",
              },
              {
                i: 125261,
                n: "蕉岭县",
              },
            ],
          },
          {
            i: 125908,
            n: "汕尾市",
            c: [
              {
                i: 125909,
                n: "市辖区",
              },
              {
                i: 125910,
                n: "城区",
              },
              {
                i: 126478,
                n: "陆丰市",
              },
              {
                i: 126042,
                n: "海丰县",
              },
              {
                i: 126342,
                n: "陆河县",
              },
            ],
          },
          {
            i: 126854,
            n: "河源市",
            c: [
              {
                i: 126855,
                n: "源城区",
              },
              {
                i: 126926,
                n: "紫金县",
              },
              {
                i: 127245,
                n: "龙川县",
              },
              {
                i: 127623,
                n: "连平县",
              },
              {
                i: 127811,
                n: "和平县",
              },
              {
                i: 128068,
                n: "东源县",
              },
            ],
          },
          {
            i: 128373,
            n: "阳江市",
            c: [
              {
                i: 128374,
                n: "江城区",
              },
              {
                i: 128710,
                n: "阳东区",
              },
              {
                i: 128909,
                n: "阳春市",
              },
              {
                i: 128548,
                n: "阳西县",
              },
            ],
          },
          {
            i: 129281,
            n: "清远市",
            c: [
              {
                i: 129282,
                n: "清城区",
              },
              {
                i: 129833,
                n: "清新区",
              },
              {
                i: 130076,
                n: "英德市",
              },
              {
                i: 130402,
                n: "连州市",
              },
              {
                i: 129414,
                n: "佛冈县",
              },
              {
                i: 129511,
                n: "阳山县",
              },
              {
                i: 129692,
                n: "连山壮族瑶族自治县",
              },
              {
                i: 129754,
                n: "连南瑶族自治县",
              },
            ],
          },
          {
            i: 130588,
            n: "东莞市",
          },
          {
            i: 131230,
            n: "中山市",
          },
          {
            i: 131531,
            n: "潮州市",
            c: [
              {
                i: 131532,
                n: "湘桥区",
              },
              {
                i: 131647,
                n: "潮安区",
              },
              {
                i: 132195,
                n: "饶平县",
              },
            ],
          },
          {
            i: 132632,
            n: "揭阳市",
            c: [
              {
                i: 132633,
                n: "榕城区",
              },
              {
                i: 132808,
                n: "揭东区",
              },
              {
                i: 133770,
                n: "普宁市",
              },
              {
                i: 133072,
                n: "揭西县",
              },
              {
                i: 133420,
                n: "惠来县",
              },
            ],
          },
          {
            i: 134374,
            n: "云浮市",
            c: [
              {
                i: 134375,
                n: "云城区",
              },
              {
                i: 134938,
                n: "云安区",
              },
              {
                i: 135067,
                n: "罗定市",
              },
              {
                i: 134494,
                n: "新兴县",
              },
              {
                i: 134712,
                n: "郁南县",
              },
            ],
          },
        ],
      },
      {
        i: 135425,
        n: "广西壮族自治区",
        c: [
          {
            i: 135426,
            n: "南宁市",
            c: [
              {
                i: 135427,
                n: "市辖区",
              },
              {
                i: 135428,
                n: "兴宁区",
              },
              {
                i: 135509,
                n: "青秀区",
              },
              {
                i: 135623,
                n: "江南区",
              },
              {
                i: 135900,
                n: "良庆区",
              },
              {
                i: 135977,
                n: "邕宁区",
              },
              {
                i: 136057,
                n: "武鸣区",
              },
              {
                i: 135729,
                n: "西乡塘区",
              },
              {
                i: 136313,
                n: "隆安县",
              },
              {
                i: 136470,
                n: "马山县",
              },
              {
                i: 136635,
                n: "上林县",
              },
              {
                i: 136778,
                n: "宾阳县",
              },
              {
                i: 137031,
                n: "横县",
              },
            ],
          },
          {
            i: 137369,
            n: "柳州市",
            c: [
              {
                i: 137371,
                n: "城中区",
              },
              {
                i: 137403,
                n: "鱼峰区",
              },
              {
                i: 137470,
                n: "柳南区",
              },
              {
                i: 137552,
                n: "柳北区",
              },
              {
                i: 137648,
                n: "柳江区",
              },
              {
                i: 137806,
                n: "柳城县",
              },
              {
                i: 137956,
                n: "鹿寨县",
              },
              {
                i: 138097,
                n: "融安县",
              },
              {
                i: 138265,
                n: "融水苗族自治县",
              },
              {
                i: 138491,
                n: "三江侗族自治县",
              },
            ],
          },
          {
            i: 138674,
            n: "桂林市",
            c: [
              {
                i: 138676,
                n: "秀峰区",
              },
              {
                i: 138705,
                n: "叠彩区",
              },
              {
                i: 138739,
                n: "象山区",
              },
              {
                i: 138781,
                n: "七星区",
              },
              {
                i: 138832,
                n: "雁山区",
              },
              {
                i: 138878,
                n: "阳朔县",
              },
              {
                i: 139002,
                n: "临桂区",
              },
              {
                i: 140408,
                n: "荔浦市",
              },
              {
                i: 139181,
                n: "灵川县",
              },
              {
                i: 139335,
                n: "全州县",
              },
              {
                i: 139638,
                n: "兴安县",
              },
              {
                i: 139774,
                n: "永福县",
              },
              {
                i: 139883,
                n: "灌阳县",
              },
              {
                i: 140034,
                n: "龙胜各族自治县",
              },
              {
                i: 140170,
                n: "资源县",
              },
              {
                i: 140252,
                n: "平乐县",
              },
              {
                i: 140566,
                n: "恭城瑶族自治县",
              },
            ],
          },
          {
            i: 140700,
            n: "梧州市",
            c: [
              {
                i: 140701,
                n: "市辖区",
              },
              {
                i: 140702,
                n: "万秀区",
              },
              {
                i: 140748,
                n: "蝶山区",
              },
              {
                i: 140805,
                n: "长洲区",
              },
              {
                i: 768080,
                n: "龙圩区",
              },
              {
                i: 141458,
                n: "岑溪市",
              },
              {
                i: 141069,
                n: "藤县",
              },
              {
                i: 140846,
                n: "苍梧县",
              },
              {
                i: 141365,
                n: "蒙山县",
              },
            ],
          },
          {
            i: 141755,
            n: "北海市",
            c: [
              {
                i: 141756,
                n: "市辖区",
              },
              {
                i: 141757,
                n: "海城区",
              },
              {
                i: 141832,
                n: "银海区",
              },
              {
                i: 141886,
                n: "铁山港区",
              },
              {
                i: 141935,
                n: "合浦县",
              },
            ],
          },
          {
            i: 142227,
            n: "防城港市",
            c: [
              {
                i: 142228,
                n: "市辖区",
              },
              {
                i: 142229,
                n: "港口区",
              },
              {
                i: 142272,
                n: "防城区",
              },
              {
                i: 142572,
                n: "东兴市",
              },
              {
                i: 142451,
                n: "上思县",
              },
            ],
          },
          {
            i: 142618,
            n: "钦州市",
            c: [
              {
                i: 142619,
                n: "市辖区",
              },
              {
                i: 142620,
                n: "钦南区",
              },
              {
                i: 142810,
                n: "钦北区",
              },
              {
                i: 142999,
                n: "灵山县",
              },
              {
                i: 143434,
                n: "浦北县",
              },
            ],
          },
          {
            i: 143725,
            n: "贵港市",
            c: [
              {
                i: 143726,
                n: "市辖区",
              },
              {
                i: 143727,
                n: "港北区",
              },
              {
                i: 143853,
                n: "港南区",
              },
              {
                i: 144028,
                n: "覃塘区",
              },
              {
                i: 144491,
                n: "桂平市",
              },
              {
                i: 144184,
                n: "平南县",
              },
            ],
          },
          {
            i: 144949,
            n: "玉林市",
            c: [
              {
                i: 144950,
                n: "市辖区",
              },
              {
                i: 144951,
                n: "玉州区",
              },
              {
                i: 768081,
                n: "福绵区",
              },
              {
                i: 146192,
                n: "北流市",
              },
              {
                i: 145190,
                n: "容县",
              },
              {
                i: 145435,
                n: "陆川县",
              },
              {
                i: 145608,
                n: "博白县",
              },
              {
                i: 145964,
                n: "兴业县",
              },
            ],
          },
          {
            i: 146522,
            n: "百色市",
            c: [
              {
                i: 146524,
                n: "右江区",
              },
              {
                i: 146654,
                n: "田阳区",
              },
              {
                i: 146999,
                n: "平果市",
              },
              {
                i: 147395,
                n: "靖西市",
              },
              {
                i: 146821,
                n: "田东县",
              },
              {
                i: 147195,
                n: "德保县",
              },
              {
                i: 147706,
                n: "那坡县",
              },
              {
                i: 147846,
                n: "凌云县",
              },
              {
                i: 147965,
                n: "乐业县",
              },
              {
                i: 148062,
                n: "田林县",
              },
              {
                i: 148245,
                n: "西林县",
              },
              {
                i: 148350,
                n: "隆林各族自治县",
              },
            ],
          },
          {
            i: 148546,
            n: "贺州市",
            c: [
              {
                i: 148548,
                n: "八步区",
              },
              {
                i: 768115,
                n: "平桂区",
              },
              {
                i: 148870,
                n: "昭平县",
              },
              {
                i: 149041,
                n: "钟山县",
              },
              {
                i: 149210,
                n: "富川瑶族自治县",
              },
            ],
          },
          {
            i: 149378,
            n: "河池市",
            c: [
              {
                i: 149379,
                n: "市辖区",
              },
              {
                i: 149380,
                n: "金城江区",
              },
              {
                i: 150946,
                n: "宜州市",
              },
              {
                i: 149537,
                n: "南丹县",
              },
              {
                i: 149697,
                n: "天峨县",
              },
              {
                i: 149801,
                n: "凤山县",
              },
              {
                i: 149909,
                n: "东兰县",
              },
              {
                i: 150073,
                n: "罗城仫佬族自治县",
              },
              {
                i: 150226,
                n: "环江毛南族自治县",
              },
              {
                i: 150387,
                n: "巴马瑶族自治县",
              },
              {
                i: 150505,
                n: "都安瑶族自治县",
              },
              {
                i: 150773,
                n: "大化瑶族自治县",
              },
            ],
          },
          {
            i: 151173,
            n: "来宾市",
            c: [
              {
                i: 151174,
                n: "市辖区",
              },
              {
                i: 151175,
                n: "兴宾区",
              },
              {
                i: 151999,
                n: "合山市",
              },
              {
                i: 151462,
                n: "忻城县",
              },
              {
                i: 151605,
                n: "象州县",
              },
              {
                i: 151743,
                n: "武宣县",
              },
              {
                i: 151905,
                n: "金秀瑶族自治县",
              },
            ],
          },
          {
            i: 152035,
            n: "崇左市",
            c: [
              {
                i: 152036,
                n: "市辖区",
              },
              {
                i: 152037,
                n: "江州区",
              },
              {
                i: 152921,
                n: "凭祥市",
              },
              {
                i: 152161,
                n: "扶绥县",
              },
              {
                i: 152305,
                n: "宁明县",
              },
              {
                i: 152480,
                n: "龙州县",
              },
              {
                i: 152620,
                n: "大新县",
              },
              {
                i: 152781,
                n: "天等县",
              },
            ],
          },
        ],
      },
      {
        i: 152964,
        n: "贵州省",
        c: [
          {
            i: 152965,
            n: "贵阳市",
            c: [
              {
                i: 152966,
                n: "市辖区",
              },
              {
                i: 152967,
                n: "南明区",
              },
              {
                i: 153131,
                n: "云岩区",
              },
              {
                i: 153288,
                n: "花溪区",
              },
              {
                i: 153488,
                n: "乌当区",
              },
              {
                i: 153659,
                n: "白云区",
              },
              {
                i: 153755,
                n: "观山湖区",
              },
              {
                i: 154351,
                n: "清镇市",
              },
              {
                i: 153793,
                n: "开阳县",
              },
              {
                i: 153931,
                n: "息烽县",
              },
              {
                i: 154112,
                n: "修文县",
              },
            ],
          },
          {
            i: 154692,
            n: "六盘水市",
            c: [
              {
                i: 154693,
                n: "钟山区",
              },
              {
                i: 154825,
                n: "六枝特区",
              },
              {
                i: 155090,
                n: "水城区",
              },
              {
                i: 155497,
                n: "盘州市",
              },
            ],
          },
          {
            i: 156033,
            n: "遵义市",
            c: [
              {
                i: 156035,
                n: "红花岗区",
              },
              {
                i: 156168,
                n: "汇川区",
              },
              {
                i: 768105,
                n: "播州区",
              },
              {
                i: 157961,
                n: "赤水市",
              },
              {
                i: 158101,
                n: "仁怀市",
              },
              {
                i: 156576,
                n: "桐梓县",
              },
              {
                i: 156835,
                n: "绥阳县",
              },
              {
                i: 156971,
                n: "正安县",
              },
              {
                i: 157373,
                n: "凤冈县",
              },
              {
                i: 157474,
                n: "湄潭县",
              },
              {
                i: 157622,
                n: "余庆县",
              },
              {
                i: 157702,
                n: "习水县",
              },
              {
                i: 156269,
                n: "遵义县",
              },
              {
                i: 157141,
                n: "道真仡佬族苗族自治县",
              },
              {
                i: 157244,
                n: "务川仡佬族苗族自治县",
              },
            ],
          },
          {
            i: 158292,
            n: "安顺市",
            c: [
              {
                i: 158293,
                n: "市辖区",
              },
              {
                i: 158294,
                n: "西秀区",
              },
              {
                i: 158873,
                n: "平坝区",
              },
              {
                i: 159091,
                n: "普定县",
              },
              {
                i: 159427,
                n: "镇宁布依族苗族自治县",
              },
              {
                i: 159815,
                n: "关岭布依族苗族自治县",
              },
              {
                i: 160082,
                n: "紫云苗族布依族自治县",
              },
            ],
          },
          {
            i: 160324,
            n: "铜仁市",
            c: [
              {
                i: 160325,
                n: "碧江区",
              },
              {
                i: 163137,
                n: "万山区",
              },
              {
                i: 160515,
                n: "江口县",
              },
              {
                i: 160704,
                n: "石阡县",
              },
              {
                i: 160815,
                n: "思南县",
              },
              {
                i: 161780,
                n: "德江县",
              },
              {
                i: 160604,
                n: "玉屏侗族自治县",
              },
              {
                i: 162600,
                n: "松桃苗族自治县",
              },
              {
                i: 162167,
                n: "沿河土家族自治县",
              },
              {
                i: 161407,
                n: "印江土家族苗族自治县",
              },
            ],
          },
          {
            i: 165461,
            n: "毕节市",
            c: [
              {
                i: 165462,
                n: "七星关区",
              },
              {
                i: 166058,
                n: "大方县",
              },
              {
                i: 166484,
                n: "黔西县",
              },
              {
                i: 166928,
                n: "金沙县",
              },
              {
                i: 167535,
                n: "织金县",
              },
              {
                i: 168142,
                n: "纳雍县",
              },
              {
                i: 169322,
                n: "赫章县",
              },
              {
                i: 168665,
                n: "威宁彝族回族苗族自治县",
              },
            ],
          },
          {
            i: 163200,
            n: "黔西南布依族苗族自治州",
            c: [
              {
                i: 163201,
                n: "兴义市",
              },
              {
                i: 163618,
                n: "兴仁市",
              },
              {
                i: 163922,
                n: "普安县",
              },
              {
                i: 164107,
                n: "晴隆县",
              },
              {
                i: 164306,
                n: "贞丰县",
              },
              {
                i: 164608,
                n: "望谟县",
              },
              {
                i: 164938,
                n: "册亨县",
              },
              {
                i: 165147,
                n: "安龙县",
              },
            ],
          },
          {
            i: 169815,
            n: "黔东南苗族侗族自治州",
            c: [
              {
                i: 169816,
                n: "凯里市",
              },
              {
                i: 170066,
                n: "黄平县",
              },
              {
                i: 170331,
                n: "施秉县",
              },
              {
                i: 170402,
                n: "三穗县",
              },
              {
                i: 170576,
                n: "镇远县",
              },
              {
                i: 170715,
                n: "岑巩县",
              },
              {
                i: 170865,
                n: "天柱县",
              },
              {
                i: 171208,
                n: "锦屏县",
              },
              {
                i: 171434,
                n: "剑河县",
              },
              {
                i: 171756,
                n: "台江县",
              },
              {
                i: 171925,
                n: "黎平县",
              },
              {
                i: 172360,
                n: "榕江县",
              },
              {
                i: 172643,
                n: "从江县",
              },
              {
                i: 172968,
                n: "雷山县",
              },
              {
                i: 173137,
                n: "麻江县",
              },
              {
                i: 173238,
                n: "丹寨县",
              },
            ],
          },
          {
            i: 173413,
            n: "黔南布依族苗族自治州",
            c: [
              {
                i: 173414,
                n: "都匀市",
              },
              {
                i: 173595,
                n: "福泉市",
              },
              {
                i: 173689,
                n: "荔波县",
              },
              {
                i: 173805,
                n: "贵定县",
              },
              {
                i: 173939,
                n: "瓮安县",
              },
              {
                i: 174218,
                n: "独山县",
              },
              {
                i: 174496,
                n: "平塘县",
              },
              {
                i: 174643,
                n: "罗甸县",
              },
              {
                i: 174942,
                n: "长顺县",
              },
              {
                i: 175112,
                n: "龙里县",
              },
              {
                i: 175289,
                n: "惠水县",
              },
              {
                i: 175524,
                n: "三都水族自治县",
              },
            ],
          },
        ],
      },
      {
        i: 175820,
        n: "海南省",
        c: [
          {
            i: 175821,
            n: "海口市",
            c: [
              {
                i: 175823,
                n: "秀英区",
              },
              {
                i: 175919,
                n: "龙华区",
              },
              {
                i: 176036,
                n: "琼山区",
              },
              {
                i: 176228,
                n: "美兰区",
              },
            ],
          },
          {
            i: 176381,
            n: "三亚市",
            c: [
              {
                i: 176382,
                n: "市辖区",
              },
              {
                i: 768074,
                n: "海棠区",
              },
              {
                i: 768075,
                n: "吉阳区",
              },
              {
                i: 768076,
                n: "天涯区",
              },
              {
                i: 768077,
                n: "崖州区",
              },
            ],
          },
          {
            i: 768072,
            n: "三沙市",
          },
          {
            i: 177261,
            n: "儋州市",
            c: [
              {
                i: 177262,
                n: "那大镇",
              },
              {
                i: 177302,
                n: "和庆镇",
              },
              {
                i: 177316,
                n: "南丰镇",
              },
              {
                i: 177329,
                n: "大成镇",
              },
              {
                i: 177347,
                n: "雅星镇",
              },
              {
                i: 177366,
                n: "兰洋镇",
              },
              {
                i: 177385,
                n: "光村镇",
              },
              {
                i: 177398,
                n: "木棠镇",
              },
              {
                i: 177424,
                n: "海头镇",
              },
              {
                i: 177439,
                n: "峨蔓镇",
              },
              {
                i: 177453,
                n: "三都镇",
              },
              {
                i: 177463,
                n: "王五镇",
              },
              {
                i: 177473,
                n: "白马井镇",
              },
              {
                i: 177496,
                n: "中和镇",
              },
              {
                i: 177509,
                n: "排浦镇",
              },
              {
                i: 177518,
                n: "东成镇",
              },
              {
                i: 177539,
                n: "新州镇",
              },
              {
                i: 177572,
                n: "国营西培农场",
              },
              {
                i: 177664,
                n: "国营西华农场",
              },
              {
                i: 177731,
                n: "国营西庆农场",
              },
              {
                i: 177805,
                n: "国营西流农场",
              },
              {
                i: 177840,
                n: "国营西联农场",
              },
              {
                i: 177891,
                n: "国营蓝洋农场",
              },
              {
                i: 177927,
                n: "国营新盈农场",
              },
              {
                i: 177968,
                n: "国营八一农场东山分场",
              },
              {
                i: 177989,
                n: "国营八一农场金川分场",
              },
              {
                i: 178023,
                n: "国营八一农场长岭分场",
              },
              {
                i: 178061,
                n: "国营八一农场英岛分场",
              },
              {
                i: 178082,
                n: "国营八一农场春江分场",
              },
              {
                i: 178100,
                n: "国营八一农场强打管区",
              },
              {
                i: 178106,
                n: "国营龙山农场",
              },
              {
                i: 178124,
                n: "国营红岭农场",
              },
              {
                i: 178144,
                n: "洋浦经济开发区",
              },
              {
                i: 178163,
                n: "华南热作学院",
              },
            ],
          },
          {
            i: 176773,
            n: "省直辖县级行政单位",
            c: [
              {
                i: 176774,
                n: "五指山市",
              },
              {
                i: 176883,
                n: "琼海市",
              },
              {
                i: 178165,
                n: "文昌市",
              },
              {
                i: 178583,
                n: "万宁市",
              },
              {
                i: 179081,
                n: "东方市",
              },
              {
                i: 179374,
                n: "定安县",
              },
              {
                i: 179645,
                n: "屯昌县",
              },
              {
                i: 179992,
                n: "澄迈县",
              },
              {
                i: 180511,
                n: "临高县",
              },
              {
                i: 180859,
                n: "白沙黎族自治县",
              },
              {
                i: 181176,
                n: "昌江黎族自治县",
              },
              {
                i: 181335,
                n: "乐东黎族自治县",
              },
              {
                i: 181776,
                n: "陵水黎族自治县",
              },
              {
                i: 181993,
                n: "保亭黎族苗族自治县",
              },
              {
                i: 182279,
                n: "琼中黎族苗族自治县",
              },
              {
                i: 182745,
                n: "西沙群岛",
              },
              {
                i: 182748,
                n: "南沙群岛",
              },
              {
                i: 182751,
                n: "中沙群岛的岛礁及其海域",
              },
            ],
          },
        ],
      },
      {
        i: 182754,
        n: "河北省",
        c: [
          {
            i: 182755,
            n: "石家庄市",
            c: [
              {
                i: 182756,
                n: "市辖区",
              },
              {
                i: 182757,
                n: "长安区",
              },
              {
                i: 182862,
                n: "桥东区",
              },
              {
                i: 182940,
                n: "桥西区",
              },
              {
                i: 183063,
                n: "新华区",
              },
              {
                i: 183171,
                n: "井陉矿区",
              },
              {
                i: 183233,
                n: "裕华区",
              },
              {
                i: 183871,
                n: "栾城区",
              },
              {
                i: 187048,
                n: "藁城区",
              },
              {
                i: 187730,
                n: "鹿泉区",
              },
              {
                i: 186673,
                n: "辛集市",
              },
              {
                i: 187312,
                n: "晋州市",
              },
              {
                i: 187547,
                n: "新乐市",
              },
              {
                i: 183334,
                n: "井陉县",
              },
              {
                i: 183674,
                n: "正定县",
              },
              {
                i: 184066,
                n: "行唐县",
              },
              {
                i: 184412,
                n: "灵寿县",
              },
              {
                i: 184711,
                n: "高邑县",
              },
              {
                i: 184824,
                n: "深泽县",
              },
              {
                i: 184957,
                n: "赞皇县",
              },
              {
                i: 185182,
                n: "无极县",
              },
              {
                i: 185411,
                n: "平山县",
              },
              {
                i: 186152,
                n: "元氏县",
              },
              {
                i: 186380,
                n: "赵县",
              },
            ],
          },
          {
            i: 187965,
            n: "唐山市",
            c: [
              {
                i: 187966,
                n: "市辖区",
              },
              {
                i: 187967,
                n: "路南区",
              },
              {
                i: 188137,
                n: "路北区",
              },
              {
                i: 188325,
                n: "古冶区",
              },
              {
                i: 188526,
                n: "开平区",
              },
              {
                i: 188702,
                n: "丰南区",
              },
              {
                i: 189226,
                n: "丰润区",
              },
              {
                i: 192520,
                n: "曹妃甸区",
              },
              {
                i: 189881,
                n: "滦州市",
              },
              {
                i: 192699,
                n: "遵化市",
              },
              {
                i: 193407,
                n: "迁安市",
              },
              {
                i: 190421,
                n: "滦南县",
              },
              {
                i: 191049,
                n: "乐亭县",
              },
              {
                i: 191620,
                n: "迁西县",
              },
              {
                i: 192064,
                n: "玉田县",
              },
            ],
          },
          {
            i: 193972,
            n: "秦皇岛市",
            c: [
              {
                i: 193974,
                n: "海港区",
              },
              {
                i: 194198,
                n: "山海关区",
              },
              {
                i: 194356,
                n: "北戴河区",
              },
              {
                i: 195310,
                n: "抚宁区",
              },
              {
                i: 194823,
                n: "昌黎县",
              },
              {
                i: 195939,
                n: "卢龙县",
              },
              {
                i: 194397,
                n: "青龙满族自治县",
              },
            ],
          },
          {
            i: 196500,
            n: "邯郸市",
            c: [
              {
                i: 196501,
                n: "市辖区",
              },
              {
                i: 196502,
                n: "邯山区",
              },
              {
                i: 196610,
                n: "丛台区",
              },
              {
                i: 196701,
                n: "复兴区",
              },
              {
                i: 196773,
                n: "峰峰矿区",
              },
              {
                i: 199344,
                n: "肥乡区",
              },
              {
                i: 199617,
                n: "永年区",
              },
              {
                i: 201897,
                n: "武安市",
              },
              {
                i: 196999,
                n: "邯郸县",
              },
              {
                i: 197251,
                n: "临漳县",
              },
              {
                i: 197691,
                n: "成安县",
              },
              {
                i: 197935,
                n: "大名县",
              },
              {
                i: 198607,
                n: "涉县",
              },
              {
                i: 198933,
                n: "磁县",
              },
              {
                i: 200088,
                n: "邱县",
              },
              {
                i: 200961,
                n: "魏县",
              },
              {
                i: 200321,
                n: "鸡泽县",
              },
              {
                i: 200498,
                n: "广平县",
              },
              {
                i: 200675,
                n: "馆陶县",
              },
              {
                i: 201544,
                n: "曲周县",
              },
            ],
          },
          {
            i: 202444,
            n: "邢台市",
            c: [
              {
                i: 202446,
                n: "襄都区",
              },
              {
                i: 202562,
                n: "信都区",
              },
              {
                i: 204281,
                n: "任泽区",
              },
              {
                i: 204485,
                n: "南和区",
              },
              {
                i: 207251,
                n: "南宫市",
              },
              {
                i: 207731,
                n: "沙河市",
              },
              {
                i: 202681,
                n: "邢台县",
              },
              {
                i: 203312,
                n: "临城县",
              },
              {
                i: 203541,
                n: "内丘县",
              },
              {
                i: 203862,
                n: "柏乡县",
              },
              {
                i: 203990,
                n: "隆尧县",
              },
              {
                i: 204716,
                n: "宁晋县",
              },
              {
                i: 205099,
                n: "巨鹿县",
              },
              {
                i: 205401,
                n: "新河县",
              },
              {
                i: 205577,
                n: "广宗县",
              },
              {
                i: 205799,
                n: "平乡县",
              },
              {
                i: 206600,
                n: "清河县",
              },
              {
                i: 206936,
                n: "临西县",
              },
              {
                i: 206060,
                n: "威县",
              },
            ],
          },
          {
            i: 208054,
            n: "保定市",
            c: [
              {
                i: 208055,
                n: "市辖区",
              },
              {
                i: 208056,
                n: "竞秀区",
              },
              {
                i: 208228,
                n: "莲池区",
              },
              {
                i: 208340,
                n: "南市区",
              },
              {
                i: 208448,
                n: "满城区",
              },
              {
                i: 208676,
                n: "清苑区",
              },
              {
                i: 209498,
                n: "徐水区",
              },
              {
                i: 213756,
                n: "定州市",
              },
              {
                i: 213303,
                n: "涿州市",
              },
              {
                i: 214299,
                n: "安国市",
              },
              {
                i: 214514,
                n: "高碑店市",
              },
              {
                i: 208967,
                n: "涞水县",
              },
              {
                i: 209274,
                n: "阜平县",
              },
              {
                i: 209834,
                n: "定兴县",
              },
              {
                i: 210506,
                n: "高阳县",
              },
              {
                i: 210696,
                n: "容城县",
              },
              {
                i: 210832,
                n: "涞源县",
              },
              {
                i: 211143,
                n: "望都县",
              },
              {
                i: 211302,
                n: "安新县",
              },
              {
                i: 212024,
                n: "曲阳县",
              },
              {
                i: 212668,
                n: "顺平县",
              },
              {
                i: 212921,
                n: "博野县",
              },
              {
                i: 210132,
                n: "唐县",
              },
              {
                i: 211527,
                n: "易县",
              },
              {
                i: 212416,
                n: "蠡县",
              },
              {
                i: 213063,
                n: "雄县",
              },
            ],
          },
          {
            i: 214981,
            n: "张家口市",
            c: [
              {
                i: 214982,
                n: "市辖区",
              },
              {
                i: 214983,
                n: "桥东区",
              },
              {
                i: 215062,
                n: "桥西区",
              },
              {
                i: 215139,
                n: "宣化区",
              },
              {
                i: 215252,
                n: "下花园区",
              },
              {
                i: 219449,
                n: "崇礼区",
              },
              {
                i: 218076,
                n: "万全区",
              },
              {
                i: 215648,
                n: "张北县",
              },
              {
                i: 216069,
                n: "康保县",
              },
              {
                i: 216416,
                n: "沽源县",
              },
              {
                i: 216683,
                n: "尚义县",
              },
              {
                i: 216876,
                n: "蔚县",
              },
              {
                i: 217460,
                n: "阳原县",
              },
              {
                i: 217782,
                n: "怀安县",
              },
              {
                i: 218270,
                n: "怀来县",
              },
              {
                i: 218590,
                n: "涿鹿县",
              },
              {
                i: 218990,
                n: "赤城县",
              },
            ],
          },
          {
            i: 219677,
            n: "承德市",
            c: [
              {
                i: 219679,
                n: "双桥区",
              },
              {
                i: 219804,
                n: "双滦区",
              },
              {
                i: 219868,
                n: "鹰手营子矿区",
              },
              {
                i: 220674,
                n: "平泉市",
              },
              {
                i: 219898,
                n: "承德县",
              },
              {
                i: 220355,
                n: "兴隆县",
              },
              {
                i: 221034,
                n: "滦平县",
              },
              {
                i: 221286,
                n: "隆化县",
              },
              {
                i: 221679,
                n: "丰宁满族自治县",
              },
              {
                i: 222026,
                n: "宽城满族自治县",
              },
              {
                i: 222255,
                n: "围场满族蒙古族自治县",
              },
            ],
          },
          {
            i: 222616,
            n: "沧州市",
            c: [
              {
                i: 222618,
                n: "新华区",
              },
              {
                i: 222686,
                n: "运河区",
              },
              {
                i: 226612,
                n: "泊头市",
              },
              {
                i: 227338,
                n: "任丘市",
              },
              {
                i: 227823,
                n: "黄骅市",
              },
              {
                i: 228267,
                n: "河间市",
              },
              {
                i: 222799,
                n: "沧县",
              },
              {
                i: 223337,
                n: "青县",
              },
              {
                i: 225945,
                n: "献县",
              },
              {
                i: 223712,
                n: "东光县",
              },
              {
                i: 224178,
                n: "海兴县",
              },
              {
                i: 224393,
                n: "盐山县",
              },
              {
                i: 224860,
                n: "肃宁县",
              },
              {
                i: 225126,
                n: "南皮县",
              },
              {
                i: 225454,
                n: "吴桥县",
              },
              {
                i: 226477,
                n: "孟村回族自治县",
              },
            ],
          },
          {
            i: 228914,
            n: "廊坊市",
            c: [
              {
                i: 228915,
                n: "市辖区",
              },
              {
                i: 228916,
                n: "安次区",
              },
              {
                i: 229238,
                n: "广阳区",
              },
              {
                i: 231600,
                n: "霸州市",
              },
              {
                i: 232012,
                n: "三河市",
              },
              {
                i: 229492,
                n: "固安县",
              },
              {
                i: 229929,
                n: "永清县",
              },
              {
                i: 230339,
                n: "香河县",
              },
              {
                i: 230661,
                n: "大城县",
              },
              {
                i: 231076,
                n: "文安县",
              },
              {
                i: 231482,
                n: "大厂回族自治县",
              },
            ],
          },
          {
            i: 232454,
            n: "衡水市",
            c: [
              {
                i: 232455,
                n: "市辖区",
              },
              {
                i: 232456,
                n: "桃城区",
              },
              {
                i: 236730,
                n: "冀州区",
              },
              {
                i: 237152,
                n: "深州市",
              },
              {
                i: 232872,
                n: "枣强县",
              },
              {
                i: 233443,
                n: "武邑县",
              },
              {
                i: 233998,
                n: "武强县",
              },
              {
                i: 234243,
                n: "饶阳县",
              },
              {
                i: 234448,
                n: "安平县",
              },
              {
                i: 234687,
                n: "故城县",
              },
              {
                i: 235240,
                n: "景县",
              },
              {
                i: 236109,
                n: "阜城县",
              },
            ],
          },
        ],
      },
      {
        i: 237641,
        n: "河南省",
        c: [
          {
            i: 237642,
            n: "郑州市",
            c: [
              {
                i: 237644,
                n: "中原区",
              },
              {
                i: 237814,
                n: "二七区",
              },
              {
                i: 237965,
                n: "管城回族区",
              },
              {
                i: 238106,
                n: "金水区",
              },
              {
                i: 238344,
                n: "上街区",
              },
              {
                i: 238400,
                n: "惠济区",
              },
              {
                i: 239948,
                n: "新郑市",
              },
              {
                i: 238924,
                n: "巩义市",
              },
              {
                i: 239271,
                n: "荥阳市",
              },
              {
                i: 239583,
                n: "新密市",
              },
              {
                i: 240314,
                n: "登封市",
              },
              {
                i: 238468,
                n: "中牟县",
              },
            ],
          },
          {
            i: 240649,
            n: "开封市",
            c: [
              {
                i: 240651,
                n: "龙亭区",
              },
              {
                i: 240712,
                n: "顺河回族区",
              },
              {
                i: 240788,
                n: "鼓楼区",
              },
              {
                i: 240839,
                n: "禹王台区",
              },
              {
                i: 240904,
                n: "金明区",
              },
              {
                i: 242455,
                n: "祥符区",
              },
              {
                i: 240980,
                n: "杞县",
              },
              {
                i: 241594,
                n: "通许县",
              },
              {
                i: 241916,
                n: "尉氏县",
              },
              {
                i: 242816,
                n: "兰考县",
              },
            ],
          },
          {
            i: 243298,
            n: "洛阳市",
            c: [
              {
                i: 243299,
                n: "市辖区",
              },
              {
                i: 243300,
                n: "老城区",
              },
              {
                i: 243358,
                n: "西工区",
              },
              {
                i: 243434,
                n: "廛河回族区",
              },
              {
                i: 243484,
                n: "涧西区",
              },
              {
                i: 243630,
                n: "吉利区",
              },
              {
                i: 243670,
                n: "洛龙区",
              },
              {
                i: 246385,
                n: "偃师市",
              },
              {
                i: 243823,
                n: "孟津县",
              },
              {
                i: 244061,
                n: "新安县",
              },
              {
                i: 244379,
                n: "栾川县",
              },
              {
                i: 244607,
                n: "嵩县",
              },
              {
                i: 244949,
                n: "汝阳县",
              },
              {
                i: 245180,
                n: "宜阳县",
              },
              {
                i: 245577,
                n: "洛宁县",
              },
              {
                i: 245992,
                n: "伊川县",
              },
            ],
          },
          {
            i: 246751,
            n: "平顶山市",
            c: [
              {
                i: 246752,
                n: "市辖区",
              },
              {
                i: 246753,
                n: "新华区",
              },
              {
                i: 246866,
                n: "卫东区",
              },
              {
                i: 246940,
                n: "石龙区",
              },
              {
                i: 246961,
                n: "湛河区",
              },
              {
                i: 249199,
                n: "汝州市",
              },
              {
                i: 248972,
                n: "舞钢市",
              },
              {
                i: 247406,
                n: "叶县",
              },
              {
                i: 248583,
                n: "郏县",
              },
              {
                i: 247069,
                n: "宝丰县",
              },
              {
                i: 248003,
                n: "鲁山县",
              },
            ],
          },
          {
            i: 249675,
            n: "安阳市",
            c: [
              {
                i: 249676,
                n: "市辖区",
              },
              {
                i: 249677,
                n: "文峰区",
              },
              {
                i: 249843,
                n: "北关区",
              },
              {
                i: 249921,
                n: "殷都区",
              },
              {
                i: 250015,
                n: "龙安区",
              },
              {
                i: 252707,
                n: "林州市",
              },
              {
                i: 250170,
                n: "安阳县",
              },
              {
                i: 250800,
                n: "汤阴县",
              },
              {
                i: 252157,
                n: "内黄县",
              },
              {
                i: 251115,
                n: "滑县",
              },
            ],
          },
          {
            i: 253298,
            n: "鹤壁市",
            c: [
              {
                i: 253299,
                n: "市辖区",
              },
              {
                i: 253300,
                n: "鹤山区",
              },
              {
                i: 253389,
                n: "山城区",
              },
              {
                i: 253498,
                n: "淇滨区",
              },
              {
                i: 253606,
                n: "浚县",
              },
              {
                i: 254113,
                n: "淇县",
              },
            ],
          },
          {
            i: 254296,
            n: "新乡市",
            c: [
              {
                i: 254298,
                n: "红旗区",
              },
              {
                i: 254409,
                n: "卫滨区",
              },
              {
                i: 254468,
                n: "凤泉区",
              },
              {
                i: 254518,
                n: "牧野区",
              },
              {
                i: 257234,
                n: "卫辉市",
              },
              {
                i: 257610,
                n: "辉县市",
              },
              {
                i: 256616,
                n: "长垣市",
              },
              {
                i: 254618,
                n: "新乡县",
              },
              {
                i: 254803,
                n: "获嘉县",
              },
              {
                i: 255038,
                n: "原阳县",
              },
              {
                i: 255629,
                n: "延津县",
              },
              {
                i: 255991,
                n: "封丘县",
              },
            ],
          },
          {
            i: 258171,
            n: "焦作市",
            c: [
              {
                i: 258172,
                n: "市辖区",
              },
              {
                i: 258173,
                n: "解放区",
              },
              {
                i: 258233,
                n: "中站区",
              },
              {
                i: 258293,
                n: "马村区",
              },
              {
                i: 258379,
                n: "山阳区",
              },
              {
                i: 260170,
                n: "沁阳市",
              },
              {
                i: 260515,
                n: "孟州市",
              },
              {
                i: 258460,
                n: "修武县",
              },
              {
                i: 258698,
                n: "博爱县",
              },
              {
                i: 258955,
                n: "武陟县",
              },
              {
                i: 259339,
                n: "温县",
              },
            ],
          },
          {
            i: 260814,
            n: "濮阳市",
            c: [
              {
                i: 260815,
                n: "市辖区",
              },
              {
                i: 260816,
                n: "华龙区",
              },
              {
                i: 262976,
                n: "濮阳县",
              },
              {
                i: 261119,
                n: "清丰县",
              },
              {
                i: 261651,
                n: "南乐县",
              },
              {
                i: 262596,
                n: "台前县",
              },
              {
                i: 261986,
                n: "范县",
              },
            ],
          },
          {
            i: 264000,
            n: "许昌市",
            c: [
              {
                i: 264002,
                n: "魏都区",
              },
              {
                i: 264117,
                n: "建安区",
              },
              {
                i: 265439,
                n: "禹州市",
              },
              {
                i: 266123,
                n: "长葛市",
              },
              {
                i: 264585,
                n: "鄢陵县",
              },
              {
                i: 264980,
                n: "襄城县",
              },
            ],
          },
          {
            i: 266517,
            n: "漯河市",
            c: [
              {
                i: 266519,
                n: "源汇区",
              },
              {
                i: 266655,
                n: "郾城区",
              },
              {
                i: 266861,
                n: "召陵区",
              },
              {
                i: 267096,
                n: "舞阳县",
              },
              {
                i: 267508,
                n: "临颍县",
              },
            ],
          },
          {
            i: 267887,
            n: "三门峡市",
            c: [
              {
                i: 267889,
                n: "湖滨区",
              },
              {
                i: 268247,
                n: "陕州区",
              },
              {
                i: 268919,
                n: "义马市",
              },
              {
                i: 268967,
                n: "灵宝市",
              },
              {
                i: 267989,
                n: "渑池县",
              },
              {
                i: 268532,
                n: "卢氏县",
              },
            ],
          },
          {
            i: 269442,
            n: "南阳市",
            c: [
              {
                i: 269444,
                n: "宛城区",
              },
              {
                i: 269786,
                n: "卧龙区",
              },
              {
                i: 273983,
                n: "邓州市",
              },
              {
                i: 270103,
                n: "南召县",
              },
              {
                i: 270470,
                n: "方城县",
              },
              {
                i: 271054,
                n: "西峡县",
              },
              {
                i: 271375,
                n: "镇平县",
              },
              {
                i: 271828,
                n: "内乡县",
              },
              {
                i: 272141,
                n: "淅川县",
              },
              {
                i: 272679,
                n: "社旗县",
              },
              {
                i: 272941,
                n: "唐河县",
              },
              {
                i: 273472,
                n: "新野县",
              },
              {
                i: 273751,
                n: "桐柏县",
              },
            ],
          },
          {
            i: 274594,
            n: "商丘市",
            c: [
              {
                i: 274596,
                n: "梁园区",
              },
              {
                i: 274923,
                n: "睢阳区",
              },
              {
                i: 278835,
                n: "永城市",
              },
              {
                i: 275318,
                n: "民权县",
              },
              {
                i: 276465,
                n: "宁陵县",
              },
              {
                i: 276844,
                n: "柘城县",
              },
              {
                i: 277375,
                n: "虞城县",
              },
              {
                i: 278065,
                n: "夏邑县",
              },
              {
                i: 275887,
                n: "睢县",
              },
            ],
          },
          {
            i: 279630,
            n: "信阳市",
            c: [
              {
                i: 279631,
                n: "市辖区",
              },
              {
                i: 279632,
                n: "浉河区",
              },
              {
                i: 279903,
                n: "平桥区",
              },
              {
                i: 280237,
                n: "罗山县",
              },
              {
                i: 280559,
                n: "光山县",
              },
              {
                i: 281151,
                n: "商城县",
              },
              {
                i: 281543,
                n: "固始县",
              },
              {
                i: 282191,
                n: "潢川县",
              },
              {
                i: 282500,
                n: "淮滨县",
              },
              {
                i: 280930,
                n: "新县",
              },
              {
                i: 282812,
                n: "息县",
              },
            ],
          },
          {
            i: 283179,
            n: "周口市",
            c: [
              {
                i: 283180,
                n: "市辖区",
              },
              {
                i: 283181,
                n: "川汇区",
              },
              {
                i: 287919,
                n: "项城市",
              },
              {
                i: 283333,
                n: "扶沟县",
              },
              {
                i: 283761,
                n: "西华县",
              },
              {
                i: 284256,
                n: "商水县",
              },
              {
                i: 284866,
                n: "沈丘县",
              },
              {
                i: 285459,
                n: "郸城县",
              },
              {
                i: 285997,
                n: "淮阳县",
              },
              {
                i: 286520,
                n: "太康县",
              },
              {
                i: 287333,
                n: "鹿邑县",
              },
            ],
          },
          {
            i: 288419,
            n: "驻马店市",
            c: [
              {
                i: 288420,
                n: "市辖区",
              },
              {
                i: 288421,
                n: "驿城区",
              },
              {
                i: 288604,
                n: "西平县",
              },
              {
                i: 288840,
                n: "上蔡县",
              },
              {
                i: 289324,
                n: "平舆县",
              },
              {
                i: 289563,
                n: "正阳县",
              },
              {
                i: 289881,
                n: "确山县",
              },
              {
                i: 290103,
                n: "泌阳县",
              },
              {
                i: 290527,
                n: "汝南县",
              },
              {
                i: 290826,
                n: "遂平县",
              },
              {
                i: 291047,
                n: "新蔡县",
              },
            ],
          },
          {
            i: 768082,
            n: "省直辖县级行政单位",
            c: [
              {
                i: 259614,
                n: "济源市",
              },
            ],
          },
        ],
      },
      {
        i: 291426,
        n: "黑龙江省",
        c: [
          {
            i: 291427,
            n: "哈尔滨市",
            c: [
              {
                i: 291429,
                n: "道里区",
              },
              {
                i: 291603,
                n: "南岗区",
              },
              {
                i: 291776,
                n: "道外区",
              },
              {
                i: 291962,
                n: "平房区",
              },
              {
                i: 292008,
                n: "松北区",
              },
              {
                i: 292070,
                n: "香坊区",
              },
              {
                i: 292248,
                n: "呼兰区",
              },
              {
                i: 292451,
                n: "阿城区",
              },
              {
                i: 293824,
                n: "双城区",
              },
              {
                i: 294180,
                n: "尚志市",
              },
              {
                i: 294432,
                n: "五常市",
              },
              {
                i: 292679,
                n: "依兰县",
              },
              {
                i: 292861,
                n: "方正县",
              },
              {
                i: 292967,
                n: "宾县",
              },
              {
                i: 293206,
                n: "巴彦县",
              },
              {
                i: 293379,
                n: "木兰县",
              },
              {
                i: 293497,
                n: "通河县",
              },
              {
                i: 293673,
                n: "延寿县",
              },
            ],
          },
          {
            i: 294766,
            n: "齐齐哈尔市",
            c: [
              {
                i: 294767,
                n: "市辖区",
              },
              {
                i: 294768,
                n: "龙沙区",
              },
              {
                i: 294842,
                n: "建华区",
              },
              {
                i: 294899,
                n: "铁锋区",
              },
              {
                i: 294993,
                n: "昂昂溪区",
              },
              {
                i: 295033,
                n: "富拉尔基区",
              },
              {
                i: 295132,
                n: "碾子山区",
              },
              {
                i: 295167,
                n: "梅里斯达斡尔族区",
              },
              {
                i: 296574,
                n: "讷河市",
              },
              {
                i: 295231,
                n: "龙江县",
              },
              {
                i: 295417,
                n: "依安县",
              },
              {
                i: 295628,
                n: "泰来县",
              },
              {
                i: 295757,
                n: "甘南县",
              },
              {
                i: 295911,
                n: "富裕县",
              },
              {
                i: 296024,
                n: "克山县",
              },
              {
                i: 296195,
                n: "克东县",
              },
              {
                i: 296364,
                n: "拜泉县",
              },
            ],
          },
          {
            i: 296807,
            n: "鸡西市",
            c: [
              {
                i: 296808,
                n: "市辖区",
              },
              {
                i: 296809,
                n: "鸡冠区",
              },
              {
                i: 296871,
                n: "恒山区",
              },
              {
                i: 296935,
                n: "滴道区",
              },
              {
                i: 296980,
                n: "梨树区",
              },
              {
                i: 297009,
                n: "城子河区",
              },
              {
                i: 297049,
                n: "麻山区",
              },
              {
                i: 297247,
                n: "虎林市",
              },
              {
                i: 297480,
                n: "密山市",
              },
              {
                i: 297075,
                n: "鸡东县",
              },
            ],
          },
          {
            i: 297701,
            n: "鹤岗市",
            c: [
              {
                i: 297702,
                n: "市辖区",
              },
              {
                i: 297703,
                n: "向阳区",
              },
              {
                i: 297726,
                n: "工农区",
              },
              {
                i: 297751,
                n: "南山区",
              },
              {
                i: 297780,
                n: "兴安区",
              },
              {
                i: 297804,
                n: "东山区",
              },
              {
                i: 297884,
                n: "兴山区",
              },
              {
                i: 297905,
                n: "萝北县",
              },
              {
                i: 298056,
                n: "绥滨县",
              },
            ],
          },
          {
            i: 298208,
            n: "双鸭山市",
            c: [
              {
                i: 298209,
                n: "市辖区",
              },
              {
                i: 298210,
                n: "尖山区",
              },
              {
                i: 298260,
                n: "岭东区",
              },
              {
                i: 298299,
                n: "四方台区",
              },
              {
                i: 298333,
                n: "宝山区",
              },
              {
                i: 298379,
                n: "集贤县",
              },
              {
                i: 298602,
                n: "友谊县",
              },
              {
                i: 298702,
                n: "宝清县",
              },
              {
                i: 298934,
                n: "饶河县",
              },
            ],
          },
          {
            i: 299119,
            n: "大庆市",
            c: [
              {
                i: 299120,
                n: "市辖区",
              },
              {
                i: 299121,
                n: "萨尔图区",
              },
              {
                i: 299176,
                n: "龙凤区",
              },
              {
                i: 299223,
                n: "让胡路区",
              },
              {
                i: 299306,
                n: "红岗区",
              },
              {
                i: 299347,
                n: "大同区",
              },
              {
                i: 299448,
                n: "肇州县",
              },
              {
                i: 299580,
                n: "肇源县",
              },
              {
                i: 299762,
                n: "林甸县",
              },
              {
                i: 299870,
                n: "杜尔伯特蒙古族自治县",
              },
            ],
          },
          {
            i: 299997,
            n: "伊春市",
            c: [
              {
                i: 299998,
                n: "市辖区",
              },
              {
                i: 299999,
                n: "伊春区",
              },
              {
                i: 300048,
                n: "南岔区",
              },
              {
                i: 300136,
                n: "友好区",
              },
              {
                i: 300183,
                n: "西林区",
              },
              {
                i: 300201,
                n: "翠峦区",
              },
              {
                i: 300236,
                n: "新青区",
              },
              {
                i: 300275,
                n: "美溪区",
              },
              {
                i: 300313,
                n: "金山屯区",
              },
              {
                i: 300349,
                n: "五营区",
              },
              {
                i: 300381,
                n: "乌马河区",
              },
              {
                i: 300419,
                n: "汤旺河区",
              },
              {
                i: 300462,
                n: "带岭区",
              },
              {
                i: 300501,
                n: "乌伊岭区",
              },
              {
                i: 300535,
                n: "红星区",
              },
              {
                i: 300565,
                n: "上甘岭区",
              },
              {
                i: 300722,
                n: "铁力市",
              },
              {
                i: 300599,
                n: "嘉荫县",
              },
            ],
          },
          {
            i: 300907,
            n: "佳木斯市",
            c: [
              {
                i: 300909,
                n: "向阳区",
              },
              {
                i: 300987,
                n: "前进区",
              },
              {
                i: 301036,
                n: "东风区",
              },
              {
                i: 301091,
                n: "郊区",
              },
              {
                i: 301933,
                n: "同江市",
              },
              {
                i: 302138,
                n: "富锦市",
              },
              {
                i: 301818,
                n: "抚远市",
              },
              {
                i: 301250,
                n: "桦南县",
              },
              {
                i: 301517,
                n: "桦川县",
              },
              {
                i: 301653,
                n: "汤原县",
              },
            ],
          },
          {
            i: 302482,
            n: "七台河市",
            c: [
              {
                i: 302483,
                n: "市辖区",
              },
              {
                i: 302484,
                n: "新兴区",
              },
              {
                i: 302538,
                n: "桃山区",
              },
              {
                i: 302582,
                n: "茄子河区",
              },
              {
                i: 302669,
                n: "勃利县",
              },
            ],
          },
          {
            i: 302887,
            n: "牡丹江市",
            c: [
              {
                i: 302888,
                n: "市辖区",
              },
              {
                i: 302889,
                n: "东安区",
              },
              {
                i: 302935,
                n: "阳明区",
              },
              {
                i: 302994,
                n: "爱民区",
              },
              {
                i: 303049,
                n: "西安区",
              },
              {
                i: 303540,
                n: "绥芬河市",
              },
              {
                i: 303570,
                n: "海林市",
              },
              {
                i: 303815,
                n: "宁安市",
              },
              {
                i: 304112,
                n: "穆棱市",
              },
              {
                i: 303119,
                n: "东宁县",
              },
              {
                i: 303272,
                n: "林口县",
              },
            ],
          },
          {
            i: 304374,
            n: "黑河市",
            c: [
              {
                i: 304376,
                n: "爱辉区",
              },
              {
                i: 304547,
                n: "嫩江市",
              },
              {
                i: 304831,
                n: "逊克县",
              },
              {
                i: 304947,
                n: "孙吴县",
              },
              {
                i: 305087,
                n: "北安市",
              },
              {
                i: 305282,
                n: "五大连池市",
              },
            ],
          },
          {
            i: 305535,
            n: "绥化市",
            c: [
              {
                i: 305536,
                n: "市辖区",
              },
              {
                i: 305537,
                n: "北林区",
              },
              {
                i: 306694,
                n: "安达市",
              },
              {
                i: 306872,
                n: "肇东市",
              },
              {
                i: 307122,
                n: "海伦市",
              },
              {
                i: 305749,
                n: "望奎县",
              },
              {
                i: 305892,
                n: "兰西县",
              },
              {
                i: 306030,
                n: "青冈县",
              },
              {
                i: 306258,
                n: "庆安县",
              },
              {
                i: 306392,
                n: "明水县",
              },
              {
                i: 306523,
                n: "绥棱县",
              },
            ],
          },
          {
            i: 307447,
            n: "大兴安岭地区",
            c: [
              {
                i: 307448,
                n: "加格达奇区",
              },
              {
                i: 307494,
                n: "松岭区",
              },
              {
                i: 307510,
                n: "新林区",
              },
              {
                i: 307535,
                n: "呼中区",
              },
              {
                i: 307551,
                n: "呼玛县",
              },
              {
                i: 307628,
                n: "塔河县",
              },
              {
                i: 307671,
                n: "漠河县",
              },
            ],
          },
        ],
      },
      {
        i: 307715,
        n: "湖北省",
        c: [
          {
            i: 307716,
            n: "武汉市",
            c: [
              {
                i: 307717,
                n: "市辖区",
              },
              {
                i: 307718,
                n: "江岸区",
              },
              {
                i: 307924,
                n: "江汉区",
              },
              {
                i: 308053,
                n: "汉口区",
              },
              {
                i: 308207,
                n: "汉阳区",
              },
              {
                i: 308358,
                n: "武昌区",
              },
              {
                i: 308571,
                n: "青山区",
              },
              {
                i: 308692,
                n: "洪山区",
              },
              {
                i: 308965,
                n: "东西湖区",
              },
              {
                i: 309114,
                n: "汉南区",
              },
              {
                i: 309186,
                n: "蔡甸区",
              },
              {
                i: 309596,
                n: "江夏区",
              },
              {
                i: 310019,
                n: "黄陂区",
              },
              {
                i: 310694,
                n: "新洲区",
              },
            ],
          },
          {
            i: 311356,
            n: "黄石市",
            c: [
              {
                i: 311358,
                n: "黄石港区",
              },
              {
                i: 311408,
                n: "西塞山区",
              },
              {
                i: 311473,
                n: "下陆区",
              },
              {
                i: 311525,
                n: "铁山区",
              },
              {
                i: 311906,
                n: "大冶市",
              },
              {
                i: 311549,
                n: "阳新县",
              },
            ],
          },
          {
            i: 312328,
            n: "十堰市",
            c: [
              {
                i: 312329,
                n: "市辖区",
              },
              {
                i: 312330,
                n: "茅箭区",
              },
              {
                i: 312410,
                n: "张湾区",
              },
              {
                i: 312524,
                n: "郧阳区",
              },
              {
                i: 314243,
                n: "丹江口市",
              },
              {
                i: 312891,
                n: "郧西县",
              },
              {
                i: 313251,
                n: "竹山县",
              },
              {
                i: 313528,
                n: "竹溪县",
              },
              {
                i: 313909,
                n: "房县",
              },
            ],
          },
          {
            i: 314530,
            n: "宜昌市",
            c: [
              {
                i: 314531,
                n: "市辖区",
              },
              {
                i: 314532,
                n: "西陵区",
              },
              {
                i: 314636,
                n: "伍家岗区",
              },
              {
                i: 314691,
                n: "点军区",
              },
              {
                i: 314750,
                n: "猇亭区",
              },
              {
                i: 314775,
                n: "夷陵区",
              },
              {
                i: 315762,
                n: "宜都市",
              },
              {
                i: 315933,
                n: "当阳市",
              },
              {
                i: 316120,
                n: "枝江市",
              },
              {
                i: 315018,
                n: "远安县",
              },
              {
                i: 315144,
                n: "兴山县",
              },
              {
                i: 315267,
                n: "秭归县",
              },
              {
                i: 315472,
                n: "长阳土家族自治县",
              },
              {
                i: 315645,
                n: "五峰土家族自治县",
              },
            ],
          },
          {
            i: 316350,
            n: "襄阳市",
            c: [
              {
                i: 316351,
                n: "市辖区",
              },
              {
                i: 316352,
                n: "襄城区",
              },
              {
                i: 316537,
                n: "樊城区",
              },
              {
                i: 316733,
                n: "襄州区",
              },
              {
                i: 318077,
                n: "老河口市",
              },
              {
                i: 318354,
                n: "枣阳市",
              },
              {
                i: 318952,
                n: "宜城市",
              },
              {
                i: 317199,
                n: "南漳县",
              },
              {
                i: 317500,
                n: "谷城县",
              },
              {
                i: 317799,
                n: "保康县",
              },
            ],
          },
          {
            i: 319186,
            n: "鄂州市",
            c: [
              {
                i: 319188,
                n: "梁子湖区",
              },
              {
                i: 319280,
                n: "华容区",
              },
              {
                i: 319404,
                n: "鄂城区",
              },
            ],
          },
          {
            i: 319597,
            n: "荆门市",
            c: [
              {
                i: 319599,
                n: "东宝区",
              },
              {
                i: 319811,
                n: "掇刀区",
              },
              {
                i: 319917,
                n: "京山市",
              },
              {
                i: 320732,
                n: "钟祥市",
              },
              {
                i: 320414,
                n: "沙洋县",
              },
            ],
          },
          {
            i: 321323,
            n: "孝感市",
            c: [
              {
                i: 321324,
                n: "市辖区",
              },
              {
                i: 321325,
                n: "孝南区",
              },
              {
                i: 323049,
                n: "应城市",
              },
              {
                i: 323489,
                n: "安陆市",
              },
              {
                i: 323912,
                n: "汉川市",
              },
              {
                i: 321872,
                n: "孝昌县",
              },
              {
                i: 322343,
                n: "大悟县",
              },
              {
                i: 322737,
                n: "云梦县",
              },
            ],
          },
          {
            i: 324609,
            n: "荆州市",
            c: [
              {
                i: 324611,
                n: "沙市区",
              },
              {
                i: 324821,
                n: "荆州区",
              },
              {
                i: 325459,
                n: "监利市",
              },
              {
                i: 326597,
                n: "石首市",
              },
              {
                i: 326949,
                n: "洪湖市",
              },
              {
                i: 327504,
                n: "松滋市",
              },
              {
                i: 325025,
                n: "公安县",
              },
              {
                i: 326339,
                n: "江陵县",
              },
            ],
          },
          {
            i: 327798,
            n: "黄冈市",
            c: [
              {
                i: 327799,
                n: "市辖区",
              },
              {
                i: 327800,
                n: "黄州区",
              },
              {
                i: 331316,
                n: "麻城市",
              },
              {
                i: 332090,
                n: "武穴市",
              },
              {
                i: 327946,
                n: "团风县",
              },
              {
                i: 328259,
                n: "红安县",
              },
              {
                i: 328700,
                n: "罗田县",
              },
              {
                i: 329141,
                n: "英山县",
              },
              {
                i: 329474,
                n: "浠水县",
              },
              {
                i: 330160,
                n: "蕲春县",
              },
              {
                i: 330763,
                n: "黄梅县",
              },
            ],
          },
          {
            i: 332446,
            n: "咸宁市",
            c: [
              {
                i: 332447,
                n: "市辖区",
              },
              {
                i: 332448,
                n: "咸安区",
              },
              {
                i: 333503,
                n: "赤壁市",
              },
              {
                i: 332769,
                n: "嘉鱼县",
              },
              {
                i: 332880,
                n: "通城县",
              },
              {
                i: 333078,
                n: "崇阳县",
              },
              {
                i: 333287,
                n: "通山县",
              },
            ],
          },
          {
            i: 333702,
            n: "随州市",
            c: [
              {
                i: 333703,
                n: "市辖区",
              },
              {
                i: 333704,
                n: "曾都区",
              },
              {
                i: 334339,
                n: "广水市",
              },
              {
                i: 768084,
                n: "随县",
              },
            ],
          },
          {
            i: 334770,
            n: "恩施土家族苗族自治州",
            c: [
              {
                i: 334771,
                n: "恩施市",
              },
              {
                i: 334994,
                n: "利川市",
              },
              {
                i: 335590,
                n: "建始县",
              },
              {
                i: 336008,
                n: "巴东县",
              },
              {
                i: 336512,
                n: "宣恩县",
              },
              {
                i: 336804,
                n: "咸丰县",
              },
              {
                i: 337004,
                n: "来凤县",
              },
              {
                i: 337209,
                n: "鹤峰县",
              },
            ],
          },
          {
            i: 337430,
            n: "省直辖行政单位",
            c: [
              {
                i: 337431,
                n: "仙桃市",
              },
              {
                i: 338224,
                n: "潜江市",
              },
              {
                i: 338708,
                n: "天门市",
              },
              {
                i: 339575,
                n: "神农架林区",
              },
            ],
          },
        ],
      },
      {
        i: 339656,
        n: "湖南省",
        c: [
          {
            i: 339657,
            n: "长沙市",
            c: [
              {
                i: 339659,
                n: "芙蓉区",
              },
              {
                i: 339744,
                n: "天心区",
              },
              {
                i: 339831,
                n: "岳麓区",
              },
              {
                i: 339951,
                n: "开福区",
              },
              {
                i: 340098,
                n: "雨花区",
              },
              {
                i: 340523,
                n: "望城区",
              },
              {
                i: 340762,
                n: "宁乡市",
              },
              {
                i: 341221,
                n: "浏阳市",
              },
              {
                i: 340230,
                n: "长沙县",
              },
            ],
          },
          {
            i: 341672,
            n: "株洲市",
            c: [
              {
                i: 341674,
                n: "荷塘区",
              },
              {
                i: 341759,
                n: "芦淞区",
              },
              {
                i: 341830,
                n: "石峰区",
              },
              {
                i: 341920,
                n: "天元区",
              },
              {
                i: 341986,
                n: "渌口区",
              },
              {
                i: 343556,
                n: "醴陵市",
              },
              {
                i: 342360,
                n: "攸县",
              },
              {
                i: 342912,
                n: "茶陵县",
              },
              {
                i: 343323,
                n: "炎陵县",
              },
            ],
          },
          {
            i: 343985,
            n: "湘潭市",
            c: [
              {
                i: 343986,
                n: "市辖区",
              },
              {
                i: 343987,
                n: "雨湖区",
              },
              {
                i: 344116,
                n: "岳塘区",
              },
              {
                i: 345099,
                n: "湘乡市",
              },
              {
                i: 345878,
                n: "韶山市",
              },
              {
                i: 344285,
                n: "湘潭县",
              },
            ],
          },
          {
            i: 345952,
            n: "衡阳市",
            c: [
              {
                i: 345953,
                n: "市辖区",
              },
              {
                i: 345954,
                n: "珠晖区",
              },
              {
                i: 346074,
                n: "雁峰区",
              },
              {
                i: 346153,
                n: "石鼓区",
              },
              {
                i: 346232,
                n: "蒸湘区",
              },
              {
                i: 346313,
                n: "南岳区",
              },
              {
                i: 350073,
                n: "耒阳市",
              },
              {
                i: 350784,
                n: "常宁市",
              },
              {
                i: 346355,
                n: "衡阳县",
              },
              {
                i: 347320,
                n: "衡南县",
              },
              {
                i: 348174,
                n: "衡山县",
              },
              {
                i: 348536,
                n: "衡东县",
              },
              {
                i: 349142,
                n: "祁东县",
              },
            ],
          },
          {
            i: 351593,
            n: "邵阳市",
            c: [
              {
                i: 351595,
                n: "双清区",
              },
              {
                i: 351725,
                n: "大祥区",
              },
              {
                i: 351870,
                n: "北塔区",
              },
              {
                i: 351936,
                n: "邵东市",
              },
              {
                i: 357263,
                n: "武冈市",
              },
              {
                i: 352972,
                n: "新邵县",
              },
              {
                i: 353671,
                n: "邵阳县",
              },
              {
                i: 354366,
                n: "隆回县",
              },
              {
                i: 355399,
                n: "洞口县",
              },
              {
                i: 356019,
                n: "绥宁县",
              },
              {
                i: 356416,
                n: "新宁县",
              },
              {
                i: 356942,
                n: "城步苗族自治县",
              },
            ],
          },
          {
            i: 357788,
            n: "岳阳市",
            c: [
              {
                i: 357790,
                n: "岳阳楼区",
              },
              {
                i: 358005,
                n: "云溪区",
              },
              {
                i: 358102,
                n: "君山区",
              },
              {
                i: 360679,
                n: "汨罗市",
              },
              {
                i: 361193,
                n: "临湘市",
              },
              {
                i: 358221,
                n: "岳阳县",
              },
              {
                i: 358849,
                n: "华容县",
              },
              {
                i: 359377,
                n: "湘阴县",
              },
              {
                i: 359846,
                n: "平江县",
              },
            ],
          },
          {
            i: 361534,
            n: "常德市",
            c: [
              {
                i: 361535,
                n: "市辖区",
              },
              {
                i: 361536,
                n: "武陵区",
              },
              {
                i: 361727,
                n: "鼎城区",
              },
              {
                i: 365896,
                n: "津市市",
              },
              {
                i: 362433,
                n: "安乡县",
              },
              {
                i: 362766,
                n: "汉寿县",
              },
              {
                i: 363375,
                n: "澧县",
              },
              {
                i: 363882,
                n: "临澧县",
              },
              {
                i: 364241,
                n: "桃源县",
              },
              {
                i: 365158,
                n: "石门县",
              },
            ],
          },
          {
            i: 366030,
            n: "张家界市",
            c: [
              {
                i: 366031,
                n: "市辖区",
              },
              {
                i: 366032,
                n: "永定区",
              },
              {
                i: 366435,
                n: "武陵源区",
              },
              {
                i: 366485,
                n: "慈利县",
              },
              {
                i: 367201,
                n: "桑植县",
              },
            ],
          },
          {
            i: 367799,
            n: "益阳市",
            c: [
              {
                i: 367800,
                n: "市辖区",
              },
              {
                i: 367801,
                n: "资阳区",
              },
              {
                i: 368039,
                n: "赫山区",
              },
              {
                i: 371197,
                n: "沅江市",
              },
              {
                i: 368611,
                n: "南县",
              },
              {
                i: 369150,
                n: "桃江县",
              },
              {
                i: 369990,
                n: "安化县",
              },
            ],
          },
          {
            i: 371667,
            n: "郴州市",
            c: [
              {
                i: 371669,
                n: "北湖区",
              },
              {
                i: 371865,
                n: "苏仙区",
              },
              {
                i: 374828,
                n: "资兴市",
              },
              {
                i: 372119,
                n: "桂阳县",
              },
              {
                i: 372660,
                n: "宜章县",
              },
              {
                i: 373054,
                n: "永兴县",
              },
              {
                i: 373444,
                n: "嘉禾县",
              },
              {
                i: 373743,
                n: "临武县",
              },
              {
                i: 374066,
                n: "汝城县",
              },
              {
                i: 374404,
                n: "桂东县",
              },
              {
                i: 374581,
                n: "安仁县",
              },
            ],
          },
          {
            i: 375137,
            n: "永州市",
            c: [
              {
                i: 375138,
                n: "市辖区",
              },
              {
                i: 375139,
                n: "零陵区",
              },
              {
                i: 375697,
                n: "冷水滩区",
              },
              {
                i: 376075,
                n: "祁阳县",
              },
              {
                i: 377069,
                n: "东安县",
              },
              {
                i: 377626,
                n: "双牌县",
              },
              {
                i: 377841,
                n: "道县",
              },
              {
                i: 378445,
                n: "江永县",
              },
              {
                i: 378695,
                n: "宁远县",
              },
              {
                i: 379412,
                n: "蓝山县",
              },
              {
                i: 379810,
                n: "新田县",
              },
              {
                i: 380215,
                n: "江华瑶族自治县",
              },
            ],
          },
          {
            i: 380758,
            n: "怀化市",
            c: [
              {
                i: 380759,
                n: "市辖区",
              },
              {
                i: 380760,
                n: "鹤城区",
              },
              {
                i: 384796,
                n: "洪江市",
              },
              {
                i: 380903,
                n: "中方县",
              },
              {
                i: 381150,
                n: "沅陵县",
              },
              {
                i: 381672,
                n: "辰溪县",
              },
              {
                i: 382162,
                n: "溆浦县",
              },
              {
                i: 382896,
                n: "会同县",
              },
              {
                i: 383283,
                n: "麻阳苗族自治县",
              },
              {
                i: 383632,
                n: "新晃侗族自治县",
              },
              {
                i: 383966,
                n: "芷江侗族自治县",
              },
              {
                i: 384305,
                n: "靖州苗族侗族自治县",
              },
              {
                i: 384518,
                n: "通道侗族自治县",
              },
            ],
          },
          {
            i: 385214,
            n: "娄底市",
            c: [
              {
                i: 385215,
                n: "市辖区",
              },
              {
                i: 385216,
                n: "娄星区",
              },
              {
                i: 387617,
                n: "冷水江市",
              },
              {
                i: 387846,
                n: "涟源市",
              },
              {
                i: 385463,
                n: "双峰县",
              },
              {
                i: 386398,
                n: "新化县",
              },
            ],
          },
          {
            i: 388832,
            n: "湘西土家族苗族自治州",
            c: [
              {
                i: 388833,
                n: "吉首市",
              },
              {
                i: 389020,
                n: "泸溪县",
              },
              {
                i: 389188,
                n: "凤凰县",
              },
              {
                i: 389572,
                n: "花垣县",
              },
              {
                i: 389897,
                n: "保靖县",
              },
              {
                i: 390126,
                n: "古丈县",
              },
              {
                i: 390288,
                n: "永顺县",
              },
              {
                i: 390646,
                n: "龙山县",
              },
            ],
          },
        ],
      },
      {
        i: 391143,
        n: "吉林省",
        c: [
          {
            i: 391144,
            n: "长春市",
            c: [
              {
                i: 391146,
                n: "南关区",
              },
              {
                i: 391287,
                n: "宽城区",
              },
              {
                i: 391466,
                n: "朝阳区",
              },
              {
                i: 391571,
                n: "二道区",
              },
              {
                i: 391732,
                n: "绿园区",
              },
              {
                i: 391827,
                n: "双阳区",
              },
              {
                i: 392377,
                n: "九台区",
              },
              {
                i: 392686,
                n: "榆树市",
              },
              {
                i: 393119,
                n: "德惠市",
              },
              {
                i: 396156,
                n: "公主岭市",
              },
              {
                i: 391985,
                n: "农安县",
              },
            ],
          },
          {
            i: 393450,
            n: "吉林市",
            c: [
              {
                i: 393451,
                n: "市辖区",
              },
              {
                i: 393452,
                n: "昌邑区",
              },
              {
                i: 393662,
                n: "龙潭区",
              },
              {
                i: 393845,
                n: "船营区",
              },
              {
                i: 393977,
                n: "丰满区",
              },
              {
                i: 394245,
                n: "蛟河市",
              },
              {
                i: 394583,
                n: "桦甸市",
              },
              {
                i: 394798,
                n: "舒兰市",
              },
              {
                i: 395070,
                n: "磐石市",
              },
              {
                i: 394079,
                n: "永吉县",
              },
            ],
          },
          {
            i: 395385,
            n: "四平市",
            c: [
              {
                i: 395386,
                n: "市辖区",
              },
              {
                i: 395387,
                n: "铁西区",
              },
              {
                i: 395453,
                n: "铁东区",
              },
              {
                i: 396644,
                n: "双辽市",
              },
              {
                i: 395568,
                n: "梨树县",
              },
              {
                i: 395937,
                n: "伊通满族自治县",
              },
            ],
          },
          {
            i: 396899,
            n: "辽源市",
            c: [
              {
                i: 396900,
                n: "市辖区",
              },
              {
                i: 396901,
                n: "龙山区",
              },
              {
                i: 396973,
                n: "西安区",
              },
              {
                i: 397028,
                n: "东丰县",
              },
              {
                i: 397278,
                n: "东辽县",
              },
            ],
          },
          {
            i: 397547,
            n: "通化市",
            c: [
              {
                i: 397548,
                n: "市辖区",
              },
              {
                i: 397549,
                n: "东昌区",
              },
              {
                i: 397631,
                n: "二道江区",
              },
              {
                i: 398318,
                n: "梅河口市",
              },
              {
                i: 398673,
                n: "集安市",
              },
              {
                i: 397684,
                n: "通化县",
              },
              {
                i: 397904,
                n: "辉南县",
              },
              {
                i: 398067,
                n: "柳河县",
              },
            ],
          },
          {
            i: 398841,
            n: "白山市",
            c: [
              {
                i: 398842,
                n: "市辖区",
              },
              {
                i: 398843,
                n: "浑江区",
              },
              {
                i: 398955,
                n: "江源区",
              },
              {
                i: 399507,
                n: "临江市",
              },
              {
                i: 399051,
                n: "抚松县",
              },
              {
                i: 399258,
                n: "靖宇县",
              },
              {
                i: 399407,
                n: "长白朝鲜族自治县",
              },
            ],
          },
          {
            i: 399649,
            n: "松原市",
            c: [
              {
                i: 399650,
                n: "市辖区",
              },
              {
                i: 399651,
                n: "宁江区",
              },
              {
                i: 400594,
                n: "扶余市",
              },
              {
                i: 400122,
                n: "长岭县",
              },
              {
                i: 400411,
                n: "乾安县",
              },
              {
                i: 399827,
                n: "前郭尔罗斯蒙古族自治县",
              },
            ],
          },
          {
            i: 401038,
            n: "白城市",
            c: [
              {
                i: 401039,
                n: "市辖区",
              },
              {
                i: 401040,
                n: "洮北区",
              },
              {
                i: 401686,
                n: "洮南市",
              },
              {
                i: 401962,
                n: "大安市",
              },
              {
                i: 401288,
                n: "镇赉县",
              },
              {
                i: 401472,
                n: "通榆县",
              },
            ],
          },
          {
            i: 402247,
            n: "延边朝鲜族自治州",
            c: [
              {
                i: 402248,
                n: "延吉市",
              },
              {
                i: 402355,
                n: "图们市",
              },
              {
                i: 402433,
                n: "敦化市",
              },
              {
                i: 402892,
                n: "珲春市",
              },
              {
                i: 403075,
                n: "龙井市",
              },
              {
                i: 403204,
                n: "和龙市",
              },
              {
                i: 403355,
                n: "汪清县",
              },
              {
                i: 403630,
                n: "安图县",
              },
            ],
          },
        ],
      },
      {
        i: 403889,
        n: "江苏省",
        c: [
          {
            i: 403890,
            n: "南京市",
            c: [
              {
                i: 403891,
                n: "市辖区",
              },
              {
                i: 403892,
                n: "玄武区",
              },
              {
                i: 403976,
                n: "白下区",
              },
              {
                i: 404052,
                n: "秦淮区",
              },
              {
                i: 404111,
                n: "建邺区",
              },
              {
                i: 404176,
                n: "鼓楼区",
              },
              {
                i: 404281,
                n: "下关区",
              },
              {
                i: 404345,
                n: "浦口区",
              },
              {
                i: 404554,
                n: "栖霞区",
              },
              {
                i: 404724,
                n: "雨花台区",
              },
              {
                i: 404804,
                n: "江宁区",
              },
              {
                i: 405040,
                n: "六合区",
              },
              {
                i: 405291,
                n: "溧水区",
              },
              {
                i: 405423,
                n: "高淳区",
              },
            ],
          },
          {
            i: 405615,
            n: "无锡市",
            c: [
              {
                i: 405616,
                n: "市辖区",
              },
              {
                i: 768102,
                n: "梁溪区",
              },
              {
                i: 405617,
                n: "崇安区",
              },
              {
                i: 405666,
                n: "南长区",
              },
              {
                i: 405729,
                n: "北塘区",
              },
              {
                i: 405793,
                n: "锡山区",
              },
              {
                i: 405925,
                n: "惠山区",
              },
              {
                i: 406074,
                n: "滨湖区",
              },
              {
                i: 768101,
                n: "新吴区",
              },
              {
                i: 406321,
                n: "江阴市",
              },
              {
                i: 406684,
                n: "宜兴市",
              },
            ],
          },
          {
            i: 407074,
            n: "徐州市",
            c: [
              {
                i: 407076,
                n: "鼓楼区",
              },
              {
                i: 407184,
                n: "云龙区",
              },
              {
                i: 407326,
                n: "贾汪区",
              },
              {
                i: 407487,
                n: "泉山区",
              },
              {
                i: 408366,
                n: "铜山区",
              },
              {
                i: 409130,
                n: "新沂市",
              },
              {
                i: 409413,
                n: "邳州市",
              },
              {
                i: 407575,
                n: "丰县",
              },
              {
                i: 407960,
                n: "沛县",
              },
              {
                i: 408711,
                n: "睢宁县",
              },
            ],
          },
          {
            i: 409936,
            n: "常州市",
            c: [
              {
                i: 409937,
                n: "常州市区",
              },
              {
                i: 409938,
                n: "天宁区",
              },
              {
                i: 410046,
                n: "钟楼区",
              },
              {
                i: 410142,
                n: "戚墅堰区",
              },
              {
                i: 410169,
                n: "新北区",
              },
              {
                i: 410355,
                n: "武进区",
              },
              {
                i: 411240,
                n: "金坛区",
              },
              {
                i: 410874,
                n: "溧阳市",
              },
            ],
          },
          {
            i: 411435,
            n: "苏州市",
            c: [
              {
                i: 411436,
                n: "市辖区",
              },
              {
                i: 411437,
                n: "姑苏区",
              },
              {
                i: 411703,
                n: "虎丘区",
              },
              {
                i: 411817,
                n: "吴中区",
              },
              {
                i: 412024,
                n: "相城区",
              },
              {
                i: 413070,
                n: "吴江区",
              },
              {
                i: 412149,
                n: "常熟市",
              },
              {
                i: 412474,
                n: "张家港市",
              },
              {
                i: 412758,
                n: "昆山市",
              },
              {
                i: 413394,
                n: "太仓市",
              },
            ],
          },
          {
            i: 413570,
            n: "南通市",
            c: [
              {
                i: 413571,
                n: "市辖区",
              },
              {
                i: 413572,
                n: "崇川区",
              },
              {
                i: 415214,
                n: "通州区",
              },
              {
                i: 415675,
                n: "海门区",
              },
              {
                i: 413835,
                n: "海安市",
              },
              {
                i: 414419,
                n: "启东市",
              },
              {
                i: 414825,
                n: "如皋市",
              },
              {
                i: 414094,
                n: "如东县",
              },
            ],
          },
          {
            i: 416015,
            n: "连云港市",
            c: [
              {
                i: 416016,
                n: "市辖区",
              },
              {
                i: 416017,
                n: "连云区",
              },
              {
                i: 416229,
                n: "海州区",
              },
              {
                i: 416287,
                n: "赣榆区",
              },
              {
                i: 416771,
                n: "东海县",
              },
              {
                i: 417185,
                n: "灌云县",
              },
              {
                i: 417600,
                n: "灌南县",
              },
            ],
          },
          {
            i: 417852,
            n: "淮安市",
            c: [
              {
                i: 417854,
                n: "清江浦区",
              },
              {
                i: 417935,
                n: "淮安区",
              },
              {
                i: 418325,
                n: "淮阴区",
              },
              {
                i: 419113,
                n: "洪泽区",
              },
              {
                i: 418705,
                n: "涟水县",
              },
              {
                i: 419251,
                n: "盱眙县",
              },
              {
                i: 419531,
                n: "金湖县",
              },
            ],
          },
          {
            i: 419692,
            n: "盐城市",
            c: [
              {
                i: 419694,
                n: "亭湖区",
              },
              {
                i: 419922,
                n: "盐都区",
              },
              {
                i: 422163,
                n: "大丰区",
              },
              {
                i: 421661,
                n: "东台市",
              },
              {
                i: 420186,
                n: "响水县",
              },
              {
                i: 420374,
                n: "滨海县",
              },
              {
                i: 420701,
                n: "阜宁县",
              },
              {
                i: 421067,
                n: "射阳县",
              },
              {
                i: 421397,
                n: "建湖县",
              },
            ],
          },
          {
            i: 422449,
            n: "扬州市",
            c: [
              {
                i: 422450,
                n: "市辖区",
              },
              {
                i: 422451,
                n: "广陵区",
              },
              {
                i: 422525,
                n: "邗江区",
              },
              {
                i: 422722,
                n: "维扬区",
              },
              {
                i: 423730,
                n: "江都区",
              },
              {
                i: 423134,
                n: "仪征市",
              },
              {
                i: 423369,
                n: "高邮市",
              },
              {
                i: 422835,
                n: "宝应县",
              },
            ],
          },
          {
            i: 424112,
            n: "镇江市",
            c: [
              {
                i: 424113,
                n: "市辖区",
              },
              {
                i: 424114,
                n: "京口区",
              },
              {
                i: 424289,
                n: "润州区",
              },
              {
                i: 424380,
                n: "丹徒区",
              },
              {
                i: 424486,
                n: "丹阳市",
              },
              {
                i: 424801,
                n: "扬中市",
              },
              {
                i: 424927,
                n: "句容市",
              },
            ],
          },
          {
            i: 425168,
            n: "泰州市",
            c: [
              {
                i: 425170,
                n: "海陵区",
              },
              {
                i: 425341,
                n: "高港区",
              },
              {
                i: 426853,
                n: "姜堰区",
              },
              {
                i: 425420,
                n: "兴化市",
              },
              {
                i: 426147,
                n: "靖江市",
              },
              {
                i: 426411,
                n: "泰兴市",
              },
            ],
          },
          {
            i: 427235,
            n: "宿迁市",
            c: [
              {
                i: 427236,
                n: "市辖区",
              },
              {
                i: 427237,
                n: "宿城区",
              },
              {
                i: 427455,
                n: "宿豫区",
              },
              {
                i: 427678,
                n: "沭阳县",
              },
              {
                i: 428192,
                n: "泗阳县",
              },
              {
                i: 428471,
                n: "泗洪县",
              },
            ],
          },
        ],
      },
      {
        i: 428836,
        n: "江西省",
        c: [
          {
            i: 428837,
            n: "南昌市",
            c: [
              {
                i: 428838,
                n: "市辖区",
              },
              {
                i: 428839,
                n: "东湖区",
              },
              {
                i: 428968,
                n: "西湖区",
              },
              {
                i: 429193,
                n: "湾里区",
              },
              {
                i: 429857,
                n: "新建区",
              },
              {
                i: 429125,
                n: "青云谱区",
              },
              {
                i: 429255,
                n: "青山湖区",
              },
              {
                i: 429475,
                n: "南昌县",
              },
              {
                i: 430289,
                n: "安义县",
              },
              {
                i: 430426,
                n: "进贤县",
              },
            ],
          },
          {
            i: 430763,
            n: "景德镇市",
            c: [
              {
                i: 430764,
                n: "市辖区",
              },
              {
                i: 430765,
                n: "昌江区",
              },
              {
                i: 430888,
                n: "珠山区",
              },
              {
                i: 431198,
                n: "乐平市",
              },
              {
                i: 430979,
                n: "浮梁县",
              },
            ],
          },
          {
            i: 431560,
            n: "萍乡市",
            c: [
              {
                i: 431561,
                n: "市辖区",
              },
              {
                i: 431562,
                n: "安源区",
              },
              {
                i: 431711,
                n: "湘东区",
              },
              {
                i: 431876,
                n: "莲花县",
              },
              {
                i: 432050,
                n: "上栗县",
              },
              {
                i: 432232,
                n: "芦溪县",
              },
            ],
          },
          {
            i: 432398,
            n: "九江市",
            c: [
              {
                i: 432400,
                n: "濂溪区",
              },
              {
                i: 432546,
                n: "浔阳区",
              },
              {
                i: 432654,
                n: "柴桑区",
              },
              {
                i: 434645,
                n: "瑞昌市",
              },
              {
                i: 768116,
                n: "共青城市",
              },
              {
                i: 433842,
                n: "庐山市",
              },
              {
                i: 432805,
                n: "武宁县",
              },
              {
                i: 433022,
                n: "修水县",
              },
              {
                i: 433458,
                n: "永修县",
              },
              {
                i: 433707,
                n: "德安县",
              },
              {
                i: 433949,
                n: "都昌县",
              },
              {
                i: 434280,
                n: "湖口县",
              },
              {
                i: 434438,
                n: "彭泽县",
              },
            ],
          },
          {
            i: 434871,
            n: "新余市",
            c: [
              {
                i: 434872,
                n: "市辖区",
              },
              {
                i: 434873,
                n: "渝水区",
              },
              {
                i: 435215,
                n: "分宜县",
              },
            ],
          },
          {
            i: 435382,
            n: "鹰潭市",
            c: [
              {
                i: 435383,
                n: "市辖区",
              },
              {
                i: 435384,
                n: "月湖区",
              },
              {
                i: 435654,
                n: "贵溪市",
              },
              {
                i: 435463,
                n: "余江县",
              },
            ],
          },
          {
            i: 435938,
            n: "赣州市",
            c: [
              {
                i: 435940,
                n: "章贡区",
              },
              {
                i: 436098,
                n: "赣县区",
              },
              {
                i: 439691,
                n: "南康区",
              },
              {
                i: 439434,
                n: "瑞金市",
              },
              {
                i: 437329,
                n: "龙南市",
              },
              {
                i: 436410,
                n: "信丰县",
              },
              {
                i: 436715,
                n: "大余县",
              },
              {
                i: 436844,
                n: "上犹县",
              },
              {
                i: 437000,
                n: "崇义县",
              },
              {
                i: 437146,
                n: "安远县",
              },
              {
                i: 437452,
                n: "定南县",
              },
              {
                i: 437591,
                n: "全南县",
              },
              {
                i: 437702,
                n: "宁都县",
              },
              {
                i: 438048,
                n: "于都县",
              },
              {
                i: 438454,
                n: "兴国县",
              },
              {
                i: 438796,
                n: "会昌县",
              },
              {
                i: 439087,
                n: "寻乌县",
              },
              {
                i: 439279,
                n: "石城县",
              },
            ],
          },
          {
            i: 440045,
            n: "吉安市",
            c: [
              {
                i: 440046,
                n: "市辖区",
              },
              {
                i: 440047,
                n: "吉州区",
              },
              {
                i: 440186,
                n: "青原区",
              },
              {
                i: 442971,
                n: "井冈山市",
              },
              {
                i: 440323,
                n: "吉安县",
              },
              {
                i: 440678,
                n: "吉水县",
              },
              {
                i: 440971,
                n: "峡江县",
              },
              {
                i: 441072,
                n: "新干县",
              },
              {
                i: 441257,
                n: "永丰县",
              },
              {
                i: 441519,
                n: "泰和县",
              },
              {
                i: 441883,
                n: "遂川县",
              },
              {
                i: 442239,
                n: "万安县",
              },
              {
                i: 442403,
                n: "安福县",
              },
              {
                i: 442689,
                n: "永新县",
              },
            ],
          },
          {
            i: 443122,
            n: "宜春市",
            c: [
              {
                i: 443123,
                n: "市辖区",
              },
              {
                i: 443124,
                n: "袁州区",
              },
              {
                i: 444694,
                n: "丰城市",
              },
              {
                i: 445258,
                n: "樟树市",
              },
              {
                i: 445556,
                n: "高安市",
              },
              {
                i: 443526,
                n: "奉新县",
              },
              {
                i: 443735,
                n: "万载县",
              },
              {
                i: 443952,
                n: "上高县",
              },
              {
                i: 444189,
                n: "宜丰县",
              },
              {
                i: 444561,
                n: "铜鼓县",
              },
              {
                i: 768099,
                n: "靖安县",
              },
            ],
          },
          {
            i: 445939,
            n: "抚州市",
            c: [
              {
                i: 445941,
                n: "临川区",
              },
              {
                i: 447849,
                n: "东乡区",
              },
              {
                i: 446472,
                n: "南城县",
              },
              {
                i: 446654,
                n: "黎川县",
              },
              {
                i: 446797,
                n: "南丰县",
              },
              {
                i: 446998,
                n: "崇仁县",
              },
              {
                i: 447197,
                n: "乐安县",
              },
              {
                i: 447410,
                n: "宜黄县",
              },
              {
                i: 447577,
                n: "金溪县",
              },
              {
                i: 447758,
                n: "资溪县",
              },
              {
                i: 448052,
                n: "广昌县",
              },
            ],
          },
          {
            i: 448209,
            n: "上饶市",
            c: [
              {
                i: 448211,
                n: "信州区",
              },
              {
                i: 448344,
                n: "广信区",
              },
              {
                i: 448606,
                n: "广丰区",
              },
              {
                i: 451050,
                n: "德兴市",
              },
              {
                i: 448856,
                n: "玉山县",
              },
              {
                i: 449111,
                n: "铅山县",
              },
              {
                i: 449344,
                n: "横峰县",
              },
              {
                i: 449437,
                n: "弋阳县",
              },
              {
                i: 449608,
                n: "余干县",
              },
              {
                i: 450045,
                n: "鄱阳县",
              },
              {
                i: 450687,
                n: "万年县",
              },
              {
                i: 450844,
                n: "婺源县",
              },
            ],
          },
        ],
      },
      {
        i: 451186,
        n: "辽宁省",
        c: [
          {
            i: 451187,
            n: "沈阳市",
            c: [
              {
                i: 451189,
                n: "和平区",
              },
              {
                i: 451315,
                n: "沈河区",
              },
              {
                i: 451426,
                n: "大东区",
              },
              {
                i: 451550,
                n: "皇姑区",
              },
              {
                i: 451721,
                n: "铁西区",
              },
              {
                i: 452063,
                n: "浑南区",
              },
              {
                i: 452592,
                n: "于洪区",
              },
              {
                i: 452897,
                n: "辽中区",
              },
              {
                i: 451855,
                n: "苏家屯区",
              },
              {
                i: 452373,
                n: "沈北新区",
              },
              {
                i: 453604,
                n: "新民市",
              },
              {
                i: 453151,
                n: "康平县",
              },
              {
                i: 453344,
                n: "法库县",
              },
            ],
          },
          {
            i: 454017,
            n: "大连市",
            c: [
              {
                i: 454018,
                n: "市辖区",
              },
              {
                i: 454019,
                n: "中山区",
              },
              {
                i: 454079,
                n: "西岗区",
              },
              {
                i: 454132,
                n: "沙河口区",
              },
              {
                i: 454228,
                n: "甘井子区",
              },
              {
                i: 454427,
                n: "旅顺口区",
              },
              {
                i: 454535,
                n: "金州区",
              },
              {
                i: 768085,
                n: "金普新区",
              },
              {
                i: 454848,
                n: "瓦房店市",
              },
              {
                i: 455223,
                n: "普兰店市",
              },
              {
                i: 455444,
                n: "庄河市",
              },
              {
                i: 454812,
                n: "长海县",
              },
            ],
          },
          {
            i: 455742,
            n: "鞍山市",
            c: [
              {
                i: 455743,
                n: "市辖区",
              },
              {
                i: 455744,
                n: "铁东区",
              },
              {
                i: 455836,
                n: "铁西区",
              },
              {
                i: 455895,
                n: "立山区",
              },
              {
                i: 455992,
                n: "千山区",
              },
              {
                i: 456522,
                n: "海城市",
              },
              {
                i: 456118,
                n: "台安县",
              },
              {
                i: 456295,
                n: "岫岩满族自治县",
              },
            ],
          },
          {
            i: 457000,
            n: "抚顺市",
            c: [
              {
                i: 457001,
                n: "市辖区",
              },
              {
                i: 457002,
                n: "新抚区",
              },
              {
                i: 457074,
                n: "东洲区",
              },
              {
                i: 457221,
                n: "望花区",
              },
              {
                i: 457360,
                n: "顺城区",
              },
              {
                i: 457474,
                n: "抚顺县",
              },
              {
                i: 457633,
                n: "新宾满族自治县",
              },
              {
                i: 457842,
                n: "清原满族自治县",
              },
            ],
          },
          {
            i: 458067,
            n: "本溪市",
            c: [
              {
                i: 458068,
                n: "市辖区",
              },
              {
                i: 458069,
                n: "平山区",
              },
              {
                i: 458166,
                n: "溪湖区",
              },
              {
                i: 458249,
                n: "明山区",
              },
              {
                i: 458325,
                n: "南芬区",
              },
              {
                i: 458369,
                n: "本溪满族自治县",
              },
              {
                i: 458510,
                n: "桓仁满族自治县",
              },
            ],
          },
          {
            i: 458658,
            n: "丹东市",
            c: [
              {
                i: 458659,
                n: "市辖区",
              },
              {
                i: 458660,
                n: "元宝区",
              },
              {
                i: 458712,
                n: "振兴区",
              },
              {
                i: 458809,
                n: "振安区",
              },
              {
                i: 459097,
                n: "东港市",
              },
              {
                i: 459368,
                n: "凤城市",
              },
              {
                i: 458882,
                n: "宽甸满族自治县",
              },
            ],
          },
          {
            i: 459625,
            n: "锦州市",
            c: [
              {
                i: 459627,
                n: "古塔区",
              },
              {
                i: 459689,
                n: "凌河区",
              },
              {
                i: 459769,
                n: "太和区",
              },
              {
                i: 460529,
                n: "凌海市",
              },
              {
                i: 460875,
                n: "北镇市",
              },
              {
                i: 459903,
                n: "黑山县",
              },
              {
                i: 460255,
                n: "义县",
              },
            ],
          },
          {
            i: 461146,
            n: "营口市",
            c: [
              {
                i: 461147,
                n: "市辖区",
              },
              {
                i: 461148,
                n: "站前区",
              },
              {
                i: 461196,
                n: "西市区",
              },
              {
                i: 461225,
                n: "鲅鱼圈区",
              },
              {
                i: 461309,
                n: "老边区",
              },
              {
                i: 461381,
                n: "盖州市",
              },
              {
                i: 461708,
                n: "大石桥市",
              },
            ],
          },
          {
            i: 462003,
            n: "阜新市",
            c: [
              {
                i: 462004,
                n: "市辖区",
              },
              {
                i: 462005,
                n: "海州区",
              },
              {
                i: 462100,
                n: "新邱区",
              },
              {
                i: 462140,
                n: "太平区",
              },
              {
                i: 462214,
                n: "清河门区",
              },
              {
                i: 462249,
                n: "细河区",
              },
              {
                i: 462752,
                n: "彰武县",
              },
              {
                i: 462307,
                n: "阜新蒙古族自治县",
              },
            ],
          },
          {
            i: 462997,
            n: "辽阳市",
            c: [
              {
                i: 462998,
                n: "市辖区",
              },
              {
                i: 462999,
                n: "白塔区",
              },
              {
                i: 463037,
                n: "文圣区",
              },
              {
                i: 463081,
                n: "宏伟区",
              },
              {
                i: 463114,
                n: "弓长岭区",
              },
              {
                i: 463149,
                n: "太子河区",
              },
              {
                i: 463474,
                n: "灯塔市",
              },
              {
                i: 463202,
                n: "辽阳县",
              },
            ],
          },
          {
            i: 463726,
            n: "盘锦市",
            c: [
              {
                i: 463728,
                n: "双台子区",
              },
              {
                i: 463786,
                n: "兴隆台区",
              },
              {
                i: 463912,
                n: "大洼区",
              },
              {
                i: 464097,
                n: "盘山县",
              },
            ],
          },
          {
            i: 464280,
            n: "铁岭市",
            c: [
              {
                i: 464281,
                n: "市辖区",
              },
              {
                i: 464282,
                n: "银州区",
              },
              {
                i: 464386,
                n: "清河区",
              },
              {
                i: 465471,
                n: "开原市",
              },
              {
                i: 465407,
                n: "调兵山市",
              },
              {
                i: 464441,
                n: "铁岭县",
              },
              {
                i: 464677,
                n: "西丰县",
              },
              {
                i: 464878,
                n: "昌图县",
              },
            ],
          },
          {
            i: 465783,
            n: "朝阳市",
            c: [
              {
                i: 465784,
                n: "市辖区",
              },
              {
                i: 465785,
                n: "双塔区",
              },
              {
                i: 465901,
                n: "龙城区",
              },
              {
                i: 466867,
                n: "北票市",
              },
              {
                i: 467213,
                n: "凌源市",
              },
              {
                i: 465999,
                n: "朝阳县",
              },
              {
                i: 466326,
                n: "建平县",
              },
              {
                i: 466643,
                n: "喀喇沁左翼蒙古族自治县",
              },
            ],
          },
          {
            i: 467520,
            n: "葫芦岛市",
            c: [
              {
                i: 467521,
                n: "市辖区",
              },
              {
                i: 467522,
                n: "连山区",
              },
              {
                i: 467851,
                n: "龙港区",
              },
              {
                i: 467945,
                n: "南票区",
              },
              {
                i: 468679,
                n: "兴城市",
              },
              {
                i: 468035,
                n: "绥中县",
              },
              {
                i: 468363,
                n: "建昌县",
              },
            ],
          },
        ],
      },
      {
        i: 468973,
        n: "内蒙古自治区",
        c: [
          {
            i: 468974,
            n: "呼和浩特市",
            c: [
              {
                i: 468976,
                n: "新城区",
              },
              {
                i: 469065,
                n: "回民区",
              },
              {
                i: 469141,
                n: "玉泉区",
              },
              {
                i: 469254,
                n: "赛罕区",
              },
              {
                i: 470226,
                n: "武川县",
              },
              {
                i: 469803,
                n: "托克托县",
              },
              {
                i: 470111,
                n: "清水河县",
              },
              {
                i: 469942,
                n: "和林格尔县",
              },
              {
                i: 469454,
                n: "土默特左旗",
              },
            ],
          },
          {
            i: 470335,
            n: "包头市",
            c: [
              {
                i: 470337,
                n: "东河区",
              },
              {
                i: 470598,
                n: "青山区",
              },
              {
                i: 470719,
                n: "石拐区",
              },
              {
                i: 470471,
                n: "昆都仑区",
              },
              {
                i: 470771,
                n: "白云鄂博矿区",
              },
              {
                i: 470780,
                n: "九原区",
              },
              {
                i: 471242,
                n: "固阳县",
              },
              {
                i: 470917,
                n: "土默特右旗",
              },
              {
                i: 471364,
                n: "达尔罕茂明安联合旗",
              },
            ],
          },
          {
            i: 471458,
            n: "乌海市",
            c: [
              {
                i: 471459,
                n: "市辖区",
              },
              {
                i: 471460,
                n: "海勃湾区",
              },
              {
                i: 471532,
                n: "海南区",
              },
              {
                i: 471591,
                n: "乌达区",
              },
            ],
          },
          {
            i: 471644,
            n: "赤峰市",
            c: [
              {
                i: 471645,
                n: "市辖区",
              },
              {
                i: 471646,
                n: "红山区",
              },
              {
                i: 471752,
                n: "元宝山区",
              },
              {
                i: 471885,
                n: "松山区",
              },
              {
                i: 472811,
                n: "林西县",
              },
              {
                i: 473509,
                n: "宁城县",
              },
              {
                i: 472180,
                n: "阿鲁科尔沁旗",
              },
              {
                i: 472444,
                n: "巴林左旗",
              },
              {
                i: 472631,
                n: "巴林右旗",
              },
              {
                i: 472935,
                n: "克什克腾旗",
              },
              {
                i: 473080,
                n: "翁牛特旗",
              },
              {
                i: 473327,
                n: "喀喇沁旗",
              },
              {
                i: 473840,
                n: "敖汉旗",
              },
            ],
          },
          {
            i: 474093,
            n: "通辽市",
            c: [
              {
                i: 474094,
                n: "市辖区",
              },
              {
                i: 474095,
                n: "科尔沁区",
              },
              {
                i: 476672,
                n: "霍林郭勒市",
              },
              {
                i: 475528,
                n: "开鲁县",
              },
              {
                i: 474629,
                n: "科尔沁左翼中旗",
              },
              {
                i: 475197,
                n: "科尔沁左翼后旗",
              },
              {
                i: 475810,
                n: "库伦旗",
              },
              {
                i: 476012,
                n: "奈曼旗",
              },
              {
                i: 476398,
                n: "扎鲁特旗",
              },
            ],
          },
          {
            i: 476707,
            n: "鄂尔多斯市",
            c: [
              {
                i: 476708,
                n: "东胜区",
              },
              {
                i: 476813,
                n: "达拉特旗",
              },
              {
                i: 476965,
                n: "准格尔旗",
              },
              {
                i: 477154,
                n: "鄂托克前旗",
              },
              {
                i: 477237,
                n: "鄂托克旗",
              },
              {
                i: 477339,
                n: "杭锦旗",
              },
              {
                i: 477433,
                n: "乌审旗",
              },
              {
                i: 477518,
                n: "伊金霍洛旗",
              },
            ],
          },
          {
            i: 477692,
            n: "呼伦贝尔市",
            c: [
              {
                i: 477693,
                n: "市辖区",
              },
              {
                i: 477694,
                n: "海拉尔区",
              },
              {
                i: 478908,
                n: "满洲里市",
              },
              {
                i: 478972,
                n: "牙克石市",
              },
              {
                i: 479076,
                n: "扎兰屯市",
              },
              {
                i: 479441,
                n: "根河市",
              },
              {
                i: 479327,
                n: "额尔古纳市",
              },
              {
                i: 477766,
                n: "阿荣旗",
              },
              {
                i: 477986,
                n: "莫力达瓦达斡尔族自治旗",
              },
              {
                i: 478280,
                n: "鄂伦春自治旗",
              },
              {
                i: 478577,
                n: "鄂温克族自治旗",
              },
              {
                i: 478683,
                n: "陈巴尔虎旗镇",
              },
              {
                i: 478768,
                n: "新巴尔虎左旗",
              },
              {
                i: 478842,
                n: "新巴尔虎右旗",
              },
            ],
          },
          {
            i: 479482,
            n: "巴彦淖尔市",
            c: [
              {
                i: 479483,
                n: "市辖区",
              },
              {
                i: 479484,
                n: "临河区",
              },
              {
                i: 479746,
                n: "五原县",
              },
              {
                i: 479924,
                n: "磴口县",
              },
              {
                i: 480053,
                n: "乌拉特前旗",
              },
              {
                i: 480253,
                n: "乌拉特中旗",
              },
              {
                i: 480378,
                n: "乌拉特后旗",
              },
              {
                i: 480454,
                n: "杭锦后旗",
              },
            ],
          },
          {
            i: 480605,
            n: "乌兰察布市",
            c: [
              {
                i: 480606,
                n: "市辖区",
              },
              {
                i: 480607,
                n: "集宁区",
              },
              {
                i: 482145,
                n: "丰镇市",
              },
              {
                i: 480716,
                n: "卓资县",
              },
              {
                i: 480844,
                n: "化德县",
              },
              {
                i: 480950,
                n: "商都县",
              },
              {
                i: 481189,
                n: "兴和县",
              },
              {
                i: 481369,
                n: "凉城县",
              },
              {
                i: 481523,
                n: "察哈尔右翼前旗",
              },
              {
                i: 481666,
                n: "察哈尔右翼中旗",
              },
              {
                i: 481859,
                n: "察哈尔右翼后旗",
              },
              {
                i: 482000,
                n: "四子王旗",
              },
            ],
          },
          {
            i: 482281,
            n: "兴安盟",
            c: [
              {
                i: 482282,
                n: "乌兰浩特市",
              },
              {
                i: 482408,
                n: "阿尔山市",
              },
              {
                i: 483249,
                n: "突泉县",
              },
              {
                i: 482472,
                n: "科尔沁右翼前旗",
              },
              {
                i: 482781,
                n: "科尔沁右翼中旗",
              },
              {
                i: 483007,
                n: "扎赉特旗",
              },
            ],
          },
          {
            i: 483469,
            n: "锡林郭勒盟",
            c: [
              {
                i: 483470,
                n: "二连浩特市",
              },
              {
                i: 483495,
                n: "锡林浩特市",
              },
              {
                i: 484571,
                n: "多伦县",
              },
              {
                i: 483593,
                n: "阿巴嘎旗",
              },
              {
                i: 483677,
                n: "苏尼特左旗",
              },
              {
                i: 483738,
                n: "苏尼特右旗",
              },
              {
                i: 483820,
                n: "东乌珠穆沁旗",
              },
              {
                i: 483937,
                n: "西乌珠穆沁旗",
              },
              {
                i: 484071,
                n: "太仆寺旗",
              },
              {
                i: 484273,
                n: "镶黄旗",
              },
              {
                i: 484343,
                n: "正镶白旗",
              },
              {
                i: 484435,
                n: "正蓝旗",
              },
            ],
          },
          {
            i: 484647,
            n: "阿拉善盟",
            c: [
              {
                i: 484648,
                n: "阿拉善左旗",
              },
              {
                i: 484835,
                n: "阿拉善右旗",
              },
              {
                i: 484889,
                n: "额济纳旗",
              },
            ],
          },
        ],
      },
      {
        i: 484915,
        n: "宁夏回族自治区",
        c: [
          {
            i: 484916,
            n: "银川市",
            c: [
              {
                i: 484917,
                n: "市辖区",
              },
              {
                i: 484918,
                n: "兴庆区",
              },
              {
                i: 485057,
                n: "西夏区",
              },
              {
                i: 485139,
                n: "金凤区",
              },
              {
                i: 485386,
                n: "灵武市",
              },
              {
                i: 485202,
                n: "永宁县",
              },
              {
                i: 485303,
                n: "贺兰县",
              },
            ],
          },
          {
            i: 485503,
            n: "石嘴山市",
            c: [
              {
                i: 485504,
                n: "市辖区",
              },
              {
                i: 485505,
                n: "大武口区",
              },
              {
                i: 485589,
                n: "惠农区",
              },
              {
                i: 485698,
                n: "平罗县",
              },
            ],
          },
          {
            i: 485884,
            n: "吴忠市",
            c: [
              {
                i: 485885,
                n: "市辖区",
              },
              {
                i: 485934,
                n: "利通区",
              },
              {
                i: 768097,
                n: "红寺堡区",
              },
              {
                i: 486418,
                n: "青铜峡市",
              },
              {
                i: 486086,
                n: "盐池县",
              },
              {
                i: 486210,
                n: "同心县",
              },
            ],
          },
          {
            i: 486564,
            n: "固原市",
            c: [
              {
                i: 486565,
                n: "市辖区",
              },
              {
                i: 486566,
                n: "原州区",
              },
              {
                i: 486828,
                n: "西吉县",
              },
              {
                i: 487158,
                n: "隆德县",
              },
              {
                i: 487302,
                n: "泾源县",
              },
              {
                i: 487422,
                n: "彭阳县",
              },
            ],
          },
          {
            i: 487595,
            n: "中卫市",
            c: [
              {
                i: 487596,
                n: "市辖区",
              },
              {
                i: 487770,
                n: "沙坡头区",
              },
              {
                i: 487771,
                n: "中宁县",
              },
              {
                i: 487928,
                n: "海原县",
              },
            ],
          },
        ],
      },
      {
        i: 488119,
        n: "青海省",
        c: [
          {
            i: 488120,
            n: "西宁市",
            c: [
              {
                i: 488121,
                n: "城东区",
              },
              {
                i: 488195,
                n: "城中区",
              },
              {
                i: 488237,
                n: "城西区",
              },
              {
                i: 488293,
                n: "城北区",
              },
              {
                i: 488688,
                n: "湟中区",
              },
              {
                i: 489134,
                n: "湟源县",
              },
              {
                i: 488360,
                n: "大通回族土族自治县",
              },
            ],
          },
          {
            i: 489297,
            n: "海东市",
            c: [
              {
                i: 489298,
                n: "平安区",
              },
              {
                i: 489769,
                n: "乐都区",
              },
              {
                i: 489423,
                n: "民和回族土族自治县",
              },
              {
                i: 490157,
                n: "互助土族自治县",
              },
              {
                i: 490478,
                n: "化隆回族自治县",
              },
              {
                i: 490868,
                n: "循化撒拉族自治县",
              },
            ],
          },
          {
            i: 491034,
            n: "海北藏族自治州",
            c: [
              {
                i: 491180,
                n: "祁连县",
              },
              {
                i: 491234,
                n: "海晏县",
              },
              {
                i: 491270,
                n: "刚察县",
              },
              {
                i: 491035,
                n: "门源回族自治县",
              },
            ],
          },
          {
            i: 491321,
            n: "黄南藏族自治州",
            c: [
              {
                i: 491322,
                n: "同仁县",
              },
              {
                i: 491410,
                n: "尖扎县",
              },
              {
                i: 491506,
                n: "泽库县",
              },
              {
                i: 491580,
                n: "河南蒙古族自治县",
              },
            ],
          },
          {
            i: 491626,
            n: "海南藏族自治州",
            c: [
              {
                i: 491627,
                n: "共和县",
              },
              {
                i: 491758,
                n: "同德县",
              },
              {
                i: 491847,
                n: "贵德县",
              },
              {
                i: 491978,
                n: "兴海县",
              },
              {
                i: 492047,
                n: "贵南县",
              },
            ],
          },
          {
            i: 492141,
            n: "果洛藏族自治州",
            c: [
              {
                i: 492142,
                n: "玛沁县",
              },
              {
                i: 492186,
                n: "班玛县",
              },
              {
                i: 492229,
                n: "甘德县",
              },
              {
                i: 492274,
                n: "达日县",
              },
              {
                i: 492319,
                n: "久治县",
              },
              {
                i: 492349,
                n: "玛多县",
              },
            ],
          },
          {
            i: 492383,
            n: "玉树藏族自治州",
            c: [
              {
                i: 492384,
                n: "玉树市",
              },
              {
                i: 492461,
                n: "杂多县",
              },
              {
                i: 492503,
                n: "称多县",
              },
              {
                i: 492572,
                n: "治多县",
              },
              {
                i: 492599,
                n: "囊谦县",
              },
              {
                i: 492681,
                n: "曲麻莱县",
              },
            ],
          },
          {
            i: 492709,
            n: "海西蒙古族藏族自治州",
            c: [
              {
                i: 492710,
                n: "格尔木市",
              },
              {
                i: 492794,
                n: "德令哈市",
              },
              {
                i: 492880,
                n: "乌兰县",
              },
              {
                i: 492930,
                n: "都兰县",
              },
              {
                i: 493055,
                n: "天峻县",
              },
            ],
          },
        ],
      },
      {
        i: 493130,
        n: "山东省",
        c: [
          {
            i: 493131,
            n: "济南市",
            c: [
              {
                i: 493133,
                n: "历下区",
              },
              {
                i: 546759,
                n: "莱芜区",
              },
              {
                i: 493235,
                n: "市中区",
              },
              {
                i: 547613,
                n: "钢城区",
              },
              {
                i: 493460,
                n: "槐荫区",
              },
              {
                i: 493622,
                n: "天桥区",
              },
              {
                i: 493878,
                n: "历城区",
              },
              {
                i: 494604,
                n: "长清区",
              },
              {
                i: 495604,
                n: "济阳区",
              },
              {
                i: 497461,
                n: "章丘区",
              },
              {
                i: 495250,
                n: "平阴县",
              },
              {
                i: 496485,
                n: "商河县",
              },
            ],
          },
          {
            i: 498417,
            n: "青岛市",
            c: [
              {
                i: 498419,
                n: "市南区",
              },
              {
                i: 498515,
                n: "市北区",
              },
              {
                i: 498740,
                n: "黄岛区",
              },
              {
                i: 498950,
                n: "崂山区",
              },
              {
                i: 499094,
                n: "李沧区",
              },
              {
                i: 499231,
                n: "城阳区",
              },
              {
                i: 500371,
                n: "即墨区",
              },
              {
                i: 499484,
                n: "胶州市",
              },
              {
                i: 501462,
                n: "平度市",
              },
              {
                i: 504372,
                n: "莱西市",
              },
            ],
          },
          {
            i: 505283,
            n: "淄博市",
            c: [
              {
                i: 505284,
                n: "市辖区",
              },
              {
                i: 505285,
                n: "淄川区",
              },
              {
                i: 505789,
                n: "张店区",
              },
              {
                i: 506082,
                n: "博山区",
              },
              {
                i: 506426,
                n: "临淄区",
              },
              {
                i: 506913,
                n: "周村区",
              },
              {
                i: 507153,
                n: "桓台县",
              },
              {
                i: 507510,
                n: "高青县",
              },
              {
                i: 508287,
                n: "沂源县",
              },
            ],
          },
          {
            i: 508941,
            n: "枣庄市",
            c: [
              {
                i: 508942,
                n: "市辖区",
              },
              {
                i: 508943,
                n: "市中区",
              },
              {
                i: 509135,
                n: "薛城区",
              },
              {
                i: 509410,
                n: "峄城区",
              },
              {
                i: 509761,
                n: "台儿庄区",
              },
              {
                i: 509979,
                n: "山亭区",
              },
              {
                i: 510245,
                n: "滕州市",
              },
            ],
          },
          {
            i: 511483,
            n: "东营市",
            c: [
              {
                i: 511485,
                n: "东营区",
              },
              {
                i: 511751,
                n: "河口区",
              },
              {
                i: 511941,
                n: "垦利区",
              },
              {
                i: 512295,
                n: "利津县",
              },
              {
                i: 512817,
                n: "广饶县",
              },
            ],
          },
          {
            i: 513384,
            n: "烟台市",
            c: [
              {
                i: 513386,
                n: "芝罘区",
              },
              {
                i: 513542,
                n: "福山区",
              },
              {
                i: 513913,
                n: "牟平区",
              },
              {
                i: 514535,
                n: "莱山区",
              },
              {
                i: 517234,
                n: "蓬莱区",
              },
              {
                i: 514717,
                n: "龙口市",
              },
              {
                i: 515362,
                n: "莱阳市",
              },
              {
                i: 516178,
                n: "莱州市",
              },
              {
                i: 517831,
                n: "招远市",
              },
              {
                i: 518581,
                n: "栖霞市",
              },
              {
                i: 519550,
                n: "海阳市",
              },
            ],
          },
          {
            i: 520298,
            n: "潍坊市",
            c: [
              {
                i: 520299,
                n: "市辖区",
              },
              {
                i: 520300,
                n: "潍城区",
              },
              {
                i: 520577,
                n: "寒亭区",
              },
              {
                i: 520973,
                n: "坊子区",
              },
              {
                i: 521226,
                n: "奎文区",
              },
              {
                i: 523379,
                n: "青州市",
              },
              {
                i: 524481,
                n: "诸城市",
              },
              {
                i: 525851,
                n: "寿光市",
              },
              {
                i: 526877,
                n: "安丘市",
              },
              {
                i: 528289,
                n: "高密市",
              },
              {
                i: 529304,
                n: "昌邑市",
              },
              {
                i: 521514,
                n: "临朐县",
              },
              {
                i: 522470,
                n: "昌乐县",
              },
            ],
          },
          {
            i: 530139,
            n: "济宁市",
            c: [
              {
                i: 530140,
                n: "市辖区",
              },
              {
                i: 530141,
                n: "市中区",
              },
              {
                i: 530260,
                n: "任城区",
              },
              {
                i: 535438,
                n: "兖州区",
              },
              {
                i: 535030,
                n: "曲阜市",
              },
              {
                i: 535978,
                n: "邹城市",
              },
              {
                i: 530849,
                n: "微山县",
              },
              {
                i: 531407,
                n: "鱼台县",
              },
              {
                i: 531810,
                n: "金乡县",
              },
              {
                i: 532483,
                n: "嘉祥县",
              },
              {
                i: 533214,
                n: "汶上县",
              },
              {
                i: 533722,
                n: "泗水县",
              },
              {
                i: 534328,
                n: "梁山县",
              },
            ],
          },
          {
            i: 536887,
            n: "泰安市",
            c: [
              {
                i: 536888,
                n: "市辖区",
              },
              {
                i: 536889,
                n: "泰山区",
              },
              {
                i: 537101,
                n: "岱岳区",
              },
              {
                i: 539144,
                n: "新泰市",
              },
              {
                i: 540084,
                n: "肥城市",
              },
              {
                i: 537833,
                n: "宁阳县",
              },
              {
                i: 538412,
                n: "东平县",
              },
            ],
          },
          {
            i: 540733,
            n: "威海市",
            c: [
              {
                i: 540734,
                n: "市辖区",
              },
              {
                i: 540735,
                n: "环翠区",
              },
              {
                i: 541173,
                n: "文登区",
              },
              {
                i: 542091,
                n: "荣成市",
              },
              {
                i: 543067,
                n: "乳山市",
              },
            ],
          },
          {
            i: 543697,
            n: "日照市",
            c: [
              {
                i: 543698,
                n: "市辖区",
              },
              {
                i: 543699,
                n: "东港区",
              },
              {
                i: 544403,
                n: "岚山区",
              },
              {
                i: 544830,
                n: "五莲县",
              },
              {
                i: 545475,
                n: "莒县",
              },
            ],
          },
          {
            i: 547853,
            n: "临沂市",
            c: [
              {
                i: 547854,
                n: "市辖区",
              },
              {
                i: 547855,
                n: "兰山区",
              },
              {
                i: 548333,
                n: "罗庄区",
              },
              {
                i: 548487,
                n: "河东区",
              },
              {
                i: 548975,
                n: "沂南县",
              },
              {
                i: 549593,
                n: "郯城县",
              },
              {
                i: 550285,
                n: "沂水县",
              },
              {
                i: 551530,
                n: "兰陵县",
              },
              {
                i: 552608,
                n: "费县",
              },
              {
                i: 553190,
                n: "平邑县",
              },
              {
                i: 553945,
                n: "莒南县",
              },
              {
                i: 554723,
                n: "蒙阴县",
              },
              {
                i: 555199,
                n: "临沭县",
              },
            ],
          },
          {
            i: 555512,
            n: "德州市",
            c: [
              {
                i: 555513,
                n: "市辖区",
              },
              {
                i: 555514,
                n: "德城区",
              },
              {
                i: 555957,
                n: "陵城区",
              },
              {
                i: 561950,
                n: "乐陵市",
              },
              {
                i: 563056,
                n: "禹城市",
              },
              {
                i: 556961,
                n: "宁津县",
              },
              {
                i: 557829,
                n: "庆云县",
              },
              {
                i: 558230,
                n: "临邑县",
              },
              {
                i: 559099,
                n: "齐河县",
              },
              {
                i: 560128,
                n: "平原县",
              },
              {
                i: 561019,
                n: "夏津县",
              },
              {
                i: 561541,
                n: "武城县",
              },
            ],
          },
          {
            i: 564076,
            n: "聊城市",
            c: [
              {
                i: 564078,
                n: "东昌府区",
              },
              {
                i: 567125,
                n: "茌平区",
              },
              {
                i: 569965,
                n: "临清市",
              },
              {
                i: 565056,
                n: "阳谷县",
              },
              {
                i: 567961,
                n: "东阿县",
              },
              {
                i: 569317,
                n: "高唐县",
              },
              {
                i: 565949,
                n: "莘县",
              },
              {
                i: 568541,
                n: "冠县",
              },
            ],
          },
          {
            i: 570636,
            n: "滨州市",
            c: [
              {
                i: 570638,
                n: "滨城区",
              },
              {
                i: 574390,
                n: "沾化区",
              },
              {
                i: 575317,
                n: "邹平市",
              },
              {
                i: 571618,
                n: "惠民县",
              },
              {
                i: 572915,
                n: "阳信县",
              },
              {
                i: 573782,
                n: "无棣县",
              },
              {
                i: 574852,
                n: "博兴县",
              },
            ],
          },
          {
            i: 576185,
            n: "菏泽市",
            c: [
              {
                i: 576186,
                n: "市辖区",
              },
              {
                i: 576187,
                n: "牡丹区",
              },
              {
                i: 581629,
                n: "定陶区",
              },
              {
                i: 576980,
                n: "曹县",
              },
              {
                i: 578192,
                n: "单县",
              },
              {
                i: 578721,
                n: "成武县",
              },
              {
                i: 579207,
                n: "巨野县",
              },
              {
                i: 580109,
                n: "郓城县",
              },
              {
                i: 581172,
                n: "鄄城县",
              },
              {
                i: 582009,
                n: "东明县",
              },
            ],
          },
        ],
      },
      {
        i: 582414,
        n: "山西省",
        c: [
          {
            i: 582415,
            n: "太原市",
            c: [
              {
                i: 582416,
                n: "市辖区",
              },
              {
                i: 582417,
                n: "小店区",
              },
              {
                i: 582591,
                n: "迎泽区",
              },
              {
                i: 582719,
                n: "杏花岭区",
              },
              {
                i: 582877,
                n: "尖草坪区",
              },
              {
                i: 583035,
                n: "万柏林区",
              },
              {
                i: 583198,
                n: "晋源区",
              },
              {
                i: 583823,
                n: "古交市",
              },
              {
                i: 583318,
                n: "清徐县",
              },
              {
                i: 583526,
                n: "阳曲县",
              },
              {
                i: 583665,
                n: "娄烦县",
              },
            ],
          },
          {
            i: 584021,
            n: "大同市",
            c: [
              {
                i: 584023,
                n: "平城区",
              },
              {
                i: 584146,
                n: "云冈区",
              },
              {
                i: 584473,
                n: "新荣区",
              },
              {
                i: 586192,
                n: "云州区",
              },
              {
                i: 584627,
                n: "阳高县",
              },
              {
                i: 584907,
                n: "天镇县",
              },
              {
                i: 585145,
                n: "广灵县",
              },
              {
                i: 585335,
                n: "灵丘县",
              },
              {
                i: 585603,
                n: "浑源县",
              },
              {
                i: 585946,
                n: "左云县",
              },
            ],
          },
          {
            i: 586426,
            n: "阳泉市",
            c: [
              {
                i: 586427,
                n: "市辖区",
              },
              {
                i: 586428,
                n: "城区",
              },
              {
                i: 586478,
                n: "矿区",
              },
              {
                i: 586525,
                n: "郊区",
              },
              {
                i: 586729,
                n: "平定县",
              },
              {
                i: 587072,
                n: "盂县",
              },
            ],
          },
          {
            i: 587546,
            n: "长治市",
            c: [
              {
                i: 587548,
                n: "潞州区",
              },
              {
                i: 587794,
                n: "上党区",
              },
              {
                i: 588410,
                n: "屯留区",
              },
              {
                i: 591073,
                n: "潞城区",
              },
              {
                i: 588067,
                n: "襄垣县",
              },
              {
                i: 588718,
                n: "平顺县",
              },
              {
                i: 588995,
                n: "黎城县",
              },
              {
                i: 589259,
                n: "壶关县",
              },
              {
                i: 589665,
                n: "长子县",
              },
              {
                i: 590077,
                n: "武乡县",
              },
              {
                i: 590472,
                n: "沁县",
              },
              {
                i: 590798,
                n: "沁源县",
              },
            ],
          },
          {
            i: 591287,
            n: "晋城市",
            c: [
              {
                i: 591289,
                n: "城区",
              },
              {
                i: 593238,
                n: "高平市",
              },
              {
                i: 591444,
                n: "沁水县",
              },
              {
                i: 591707,
                n: "阳城县",
              },
              {
                i: 592197,
                n: "陵川县",
              },
              {
                i: 592588,
                n: "泽州县",
              },
            ],
          },
          {
            i: 593715,
            n: "朔州市",
            c: [
              {
                i: 593717,
                n: "朔城区",
              },
              {
                i: 594072,
                n: "平鲁区",
              },
              {
                i: 595393,
                n: "怀仁市",
              },
              {
                i: 594446,
                n: "山阴县",
              },
              {
                i: 594728,
                n: "应县",
              },
              {
                i: 595048,
                n: "右玉县",
              },
            ],
          },
          {
            i: 595591,
            n: "晋中市",
            c: [
              {
                i: 595593,
                n: "榆次区",
              },
              {
                i: 597368,
                n: "太谷区",
              },
              {
                i: 598375,
                n: "介休市",
              },
              {
                i: 595964,
                n: "榆社县",
              },
              {
                i: 596256,
                n: "左权县",
              },
              {
                i: 596480,
                n: "和顺县",
              },
              {
                i: 596789,
                n: "昔阳县",
              },
              {
                i: 597141,
                n: "寿阳县",
              },
              {
                i: 597590,
                n: "祁县",
              },
              {
                i: 597765,
                n: "平遥县",
              },
              {
                i: 598057,
                n: "灵石县",
              },
            ],
          },
          {
            i: 598639,
            n: "运城市",
            c: [
              {
                i: 598640,
                n: "市辖区",
              },
              {
                i: 598641,
                n: "盐湖区",
              },
              {
                i: 601646,
                n: "永济市",
              },
              {
                i: 601933,
                n: "河津市",
              },
              {
                i: 599017,
                n: "临猗县",
              },
              {
                i: 599418,
                n: "万荣县",
              },
              {
                i: 599719,
                n: "闻喜县",
              },
              {
                i: 600082,
                n: "稷山县",
              },
              {
                i: 600290,
                n: "新绛县",
              },
              {
                i: 600525,
                n: "绛县",
              },
              {
                i: 600742,
                n: "垣曲县",
              },
              {
                i: 600948,
                n: "夏县",
              },
              {
                i: 601220,
                n: "平陆县",
              },
              {
                i: 601459,
                n: "芮城县",
              },
            ],
          },
          {
            i: 602106,
            n: "忻州市",
            c: [
              {
                i: 602107,
                n: "市辖区",
              },
              {
                i: 602108,
                n: "忻府区",
              },
              {
                i: 606717,
                n: "原平市",
              },
              {
                i: 602545,
                n: "定襄县",
              },
              {
                i: 602711,
                n: "五台县",
              },
              {
                i: 603304,
                n: "代县",
              },
              {
                i: 603707,
                n: "繁峙县",
              },
              {
                i: 604125,
                n: "宁武县",
              },
              {
                i: 604612,
                n: "静乐县",
              },
              {
                i: 605008,
                n: "神池县",
              },
              {
                i: 605261,
                n: "五寨县",
              },
              {
                i: 605524,
                n: "岢岚县",
              },
              {
                i: 605739,
                n: "河曲县",
              },
              {
                i: 606094,
                n: "保德县",
              },
              {
                i: 606457,
                n: "偏关县",
              },
            ],
          },
          {
            i: 607277,
            n: "临汾市",
            c: [
              {
                i: 607278,
                n: "市辖区",
              },
              {
                i: 607279,
                n: "尧都区",
              },
              {
                i: 610234,
                n: "侯马市",
              },
              {
                i: 610350,
                n: "霍州市",
              },
              {
                i: 607733,
                n: "曲沃县",
              },
              {
                i: 607906,
                n: "翼城县",
              },
              {
                i: 608131,
                n: "襄汾县",
              },
              {
                i: 608499,
                n: "洪洞县",
              },
              {
                i: 608982,
                n: "古县",
              },
              {
                i: 609105,
                n: "安泽县",
              },
              {
                i: 609219,
                n: "浮山县",
              },
              {
                i: 609416,
                n: "吉县",
              },
              {
                i: 609505,
                n: "乡宁县",
              },
              {
                i: 609699,
                n: "大宁县",
              },
              {
                i: 609790,
                n: "隰县",
              },
              {
                i: 609899,
                n: "永和县",
              },
              {
                i: 609988,
                n: "蒲县",
              },
              {
                i: 610099,
                n: "汾西县",
              },
            ],
          },
          {
            i: 610589,
            n: "吕梁市",
            c: [
              {
                i: 610590,
                n: "市辖区",
              },
              {
                i: 610591,
                n: "离石区",
              },
              {
                i: 613229,
                n: "孝义市",
              },
              {
                i: 613645,
                n: "汾阳市",
              },
              {
                i: 610809,
                n: "文水县",
              },
              {
                i: 611025,
                n: "交城县",
              },
              {
                i: 611183,
                n: "兴县",
              },
              {
                i: 611575,
                n: "临县",
              },
              {
                i: 612241,
                n: "柳林县",
              },
              {
                i: 612518,
                n: "石楼县",
              },
              {
                i: 612663,
                n: "岚县",
              },
              {
                i: 612843,
                n: "方山县",
              },
              {
                i: 613022,
                n: "中阳县",
              },
              {
                i: 613130,
                n: "交口县",
              },
            ],
          },
        ],
      },
      {
        i: 613964,
        n: "陕西省",
        c: [
          {
            i: 613965,
            n: "西安市",
            c: [
              {
                i: 613967,
                n: "新城区",
              },
              {
                i: 614080,
                n: "碑林区",
              },
              {
                i: 614206,
                n: "莲湖区",
              },
              {
                i: 614358,
                n: "灞桥区",
              },
              {
                i: 614627,
                n: "未央区",
              },
              {
                i: 614897,
                n: "雁塔区",
              },
              {
                i: 615109,
                n: "阎良区",
              },
              {
                i: 615217,
                n: "临潼区",
              },
              {
                i: 615547,
                n: "长安区",
              },
              {
                i: 617776,
                n: "高陵区",
              },
              {
                i: 617220,
                n: "鄠邑区",
              },
              {
                i: 616267,
                n: "蓝田县",
              },
              {
                i: 616809,
                n: "周至县",
              },
            ],
          },
          {
            i: 617876,
            n: "铜川市",
            c: [
              {
                i: 617877,
                n: "市辖区",
              },
              {
                i: 617878,
                n: "王益区",
              },
              {
                i: 617945,
                n: "印台区",
              },
              {
                i: 618087,
                n: "耀州区",
              },
              {
                i: 618331,
                n: "宜君县",
              },
            ],
          },
          {
            i: 618522,
            n: "宝鸡市",
            c: [
              {
                i: 618524,
                n: "渭滨区",
              },
              {
                i: 618696,
                n: "金台区",
              },
              {
                i: 618866,
                n: "陈仓区",
              },
              {
                i: 619240,
                n: "凤翔县",
              },
              {
                i: 619497,
                n: "岐山县",
              },
              {
                i: 619671,
                n: "扶风县",
              },
              {
                i: 619873,
                n: "眉县",
              },
              {
                i: 620018,
                n: "陇县",
              },
              {
                i: 620420,
                n: "凤县",
              },
              {
                i: 620195,
                n: "千阳县",
              },
              {
                i: 620307,
                n: "麟游县",
              },
              {
                i: 620590,
                n: "太白县",
              },
            ],
          },
          {
            i: 620668,
            n: "咸阳市",
            c: [
              {
                i: 620670,
                n: "秦都区",
              },
              {
                i: 620877,
                n: "杨陵区",
              },
              {
                i: 620962,
                n: "渭城区",
              },
              {
                i: 623671,
                n: "兴平市",
              },
              {
                i: 622517,
                n: "彬州市",
              },
              {
                i: 621140,
                n: "三原县",
              },
              {
                i: 621371,
                n: "泾阳县",
              },
              {
                i: 621627,
                n: "乾县",
              },
              {
                i: 621911,
                n: "礼泉县",
              },
              {
                i: 622249,
                n: "永寿县",
              },
              {
                i: 622785,
                n: "长武县",
              },
              {
                i: 623014,
                n: "旬邑县",
              },
              {
                i: 623218,
                n: "淳化县",
              },
              {
                i: 623440,
                n: "武功县",
              },
            ],
          },
          {
            i: 623918,
            n: "渭南市",
            c: [
              {
                i: 623920,
                n: "临渭区",
              },
              {
                i: 624513,
                n: "华州区",
              },
              {
                i: 627007,
                n: "韩城市",
              },
              {
                i: 627323,
                n: "华阴市",
              },
              {
                i: 624785,
                n: "潼关县",
              },
              {
                i: 624886,
                n: "大荔县",
              },
              {
                i: 625364,
                n: "合阳县",
              },
              {
                i: 625739,
                n: "澄城县",
              },
              {
                i: 626029,
                n: "蒲城县",
              },
              {
                i: 626423,
                n: "白水县",
              },
              {
                i: 626636,
                n: "富平县",
              },
            ],
          },
          {
            i: 627544,
            n: "延安市",
            c: [
              {
                i: 627545,
                n: "市辖区",
              },
              {
                i: 627546,
                n: "宝塔区",
              },
              {
                i: 628222,
                n: "延长县",
              },
              {
                i: 628529,
                n: "延川县",
              },
              {
                i: 628895,
                n: "子长县",
              },
              {
                i: 629270,
                n: "安塞县",
              },
              {
                i: 629500,
                n: "志丹县",
              },
              {
                i: 629715,
                n: "吴起县",
              },
              {
                i: 629895,
                n: "甘泉县",
              },
              {
                i: 630024,
                n: "富县",
              },
              {
                i: 630287,
                n: "洛川县",
              },
              {
                i: 630680,
                n: "宜川县",
              },
              {
                i: 630899,
                n: "黄龙县",
              },
              {
                i: 631000,
                n: "黄陵县",
              },
            ],
          },
          {
            i: 631214,
            n: "汉中市",
            c: [
              {
                i: 631216,
                n: "汉台区",
              },
              {
                i: 631487,
                n: "南郑区",
              },
              {
                i: 632033,
                n: "城固县",
              },
              {
                i: 632468,
                n: "洋县",
              },
              {
                i: 632868,
                n: "西乡县",
              },
              {
                i: 633171,
                n: "勉县",
              },
              {
                i: 633444,
                n: "宁强县",
              },
              {
                i: 633748,
                n: "略阳县",
              },
              {
                i: 633970,
                n: "镇巴县",
              },
              {
                i: 634250,
                n: "留坝县",
              },
              {
                i: 634359,
                n: "佛坪县",
              },
            ],
          },
          {
            i: 634429,
            n: "榆林市",
            c: [
              {
                i: 634430,
                n: "市辖区",
              },
              {
                i: 634431,
                n: "榆阳区",
              },
              {
                i: 634994,
                n: "神木县",
              },
              {
                i: 635688,
                n: "府谷县",
              },
              {
                i: 636053,
                n: "横山县",
              },
              {
                i: 636439,
                n: "靖边县",
              },
              {
                i: 636681,
                n: "定边县",
              },
              {
                i: 637049,
                n: "绥德县",
              },
              {
                i: 637745,
                n: "米脂县",
              },
              {
                i: 638161,
                n: "佳县",
              },
              {
                i: 638842,
                n: "吴堡县",
              },
              {
                i: 639077,
                n: "清涧县",
              },
              {
                i: 639736,
                n: "子洲县",
              },
            ],
          },
          {
            i: 640315,
            n: "安康市",
            c: [
              {
                i: 640316,
                n: "市辖区",
              },
              {
                i: 640317,
                n: "汉滨区",
              },
              {
                i: 641282,
                n: "汉阴县",
              },
              {
                i: 641487,
                n: "石泉县",
              },
              {
                i: 641715,
                n: "宁陕县",
              },
              {
                i: 641830,
                n: "紫阳县",
              },
              {
                i: 642088,
                n: "岚皋县",
              },
              {
                i: 642300,
                n: "平利县",
              },
              {
                i: 642507,
                n: "镇坪县",
              },
              {
                i: 642597,
                n: "旬阳县",
              },
              {
                i: 642945,
                n: "白河县",
              },
            ],
          },
          {
            i: 643090,
            n: "商洛市",
            c: [
              {
                i: 643091,
                n: "市辖区",
              },
              {
                i: 643092,
                n: "商州区",
              },
              {
                i: 643551,
                n: "洛南县",
              },
              {
                i: 643960,
                n: "丹凤县",
              },
              {
                i: 644190,
                n: "商南县",
              },
              {
                i: 644386,
                n: "山阳县",
              },
              {
                i: 644743,
                n: "镇安县",
              },
              {
                i: 644983,
                n: "柞水县",
              },
            ],
          },
        ],
      },
      {
        i: 645121,
        n: "上海市",
        c: [
          {
            i: 768110,
            n: "上海市",
            c: [
              {
                i: 645123,
                n: "黄浦区",
              },
              {
                i: 650332,
                n: "崇明区",
              },
              {
                i: 645254,
                n: "卢湾区",
              },
              {
                i: 645334,
                n: "徐汇区",
              },
              {
                i: 645660,
                n: "长宁区",
              },
              {
                i: 645853,
                n: "静安区",
              },
              {
                i: 645933,
                n: "普陀区",
              },
              {
                i: 646172,
                n: "闸北区",
              },
              {
                i: 646390,
                n: "虹口区",
              },
              {
                i: 646648,
                n: "杨浦区",
              },
              {
                i: 646964,
                n: "闵行区",
              },
              {
                i: 647452,
                n: "宝山区",
              },
              {
                i: 647835,
                n: "嘉定区",
              },
              {
                i: 648114,
                n: "浦东新区",
              },
              {
                i: 648952,
                n: "金山区",
              },
              {
                i: 649162,
                n: "松江区",
              },
              {
                i: 649430,
                n: "青浦区",
              },
              {
                i: 649695,
                n: "南汇区",
              },
              {
                i: 649970,
                n: "奉贤区",
              },
            ],
          },
        ],
      },
      {
        i: 650698,
        n: "四川省",
        c: [
          {
            i: 650699,
            n: "成都市",
            c: [
              {
                i: 650701,
                n: "锦江区",
              },
              {
                i: 650777,
                n: "青羊区",
              },
              {
                i: 650873,
                n: "金牛区",
              },
              {
                i: 651003,
                n: "武侯区",
              },
              {
                i: 651151,
                n: "成华区",
              },
              {
                i: 651266,
                n: "龙泉驿区",
              },
              {
                i: 651413,
                n: "青白江区",
              },
              {
                i: 651545,
                n: "新都区",
              },
              {
                i: 651881,
                n: "温江区",
              },
              {
                i: 652265,
                n: "双流区",
              },
              {
                i: 652560,
                n: "郫都区",
              },
              {
                i: 653176,
                n: "新津区",
              },
              {
                i: 653295,
                n: "都江堰市",
              },
              {
                i: 653563,
                n: "彭州市",
              },
              {
                i: 653947,
                n: "邛崃市",
              },
              {
                i: 654233,
                n: "崇州市",
              },
              {
                i: 701223,
                n: "简阳市",
              },
              {
                i: 652794,
                n: "大邑县",
              },
              {
                i: 652013,
                n: "金堂县",
              },
              {
                i: 653031,
                n: "蒲江县",
              },
            ],
          },
          {
            i: 654512,
            n: "自贡市",
            c: [
              {
                i: 654513,
                n: "市辖区",
              },
              {
                i: 654514,
                n: "自流井区",
              },
              {
                i: 654640,
                n: "贡井区",
              },
              {
                i: 654834,
                n: "大安区",
              },
              {
                i: 655047,
                n: "沿滩区",
              },
              {
                i: 655245,
                n: "荣县",
              },
              {
                i: 655787,
                n: "富顺县",
              },
            ],
          },
          {
            i: 656346,
            n: "攀枝花市",
            c: [
              {
                i: 656347,
                n: "市辖区",
              },
              {
                i: 656348,
                n: "东区",
              },
              {
                i: 656429,
                n: "西区",
              },
              {
                i: 656481,
                n: "仁和区",
              },
              {
                i: 656595,
                n: "米易县",
              },
              {
                i: 656708,
                n: "盐边县",
              },
            ],
          },
          {
            i: 656896,
            n: "泸州市",
            c: [
              {
                i: 656897,
                n: "市辖区",
              },
              {
                i: 656898,
                n: "江阳区",
              },
              {
                i: 657161,
                n: "纳溪区",
              },
              {
                i: 657437,
                n: "龙马潭区",
              },
              {
                i: 657542,
                n: "泸县",
              },
              {
                i: 657855,
                n: "合江县",
              },
              {
                i: 658420,
                n: "叙永县",
              },
              {
                i: 658710,
                n: "古蔺县",
              },
            ],
          },
          {
            i: 659022,
            n: "德阳市",
            c: [
              {
                i: 659024,
                n: "旌阳区",
              },
              {
                i: 660272,
                n: "罗江区",
              },
              {
                i: 660461,
                n: "广汉市",
              },
              {
                i: 660784,
                n: "什邡市",
              },
              {
                i: 661090,
                n: "绵竹市",
              },
              {
                i: 659347,
                n: "中江县",
              },
            ],
          },
          {
            i: 661421,
            n: "绵阳市",
            c: [
              {
                i: 661423,
                n: "涪城区",
              },
              {
                i: 661692,
                n: "游仙区",
              },
              {
                i: 663652,
                n: "安州区",
              },
              {
                i: 664944,
                n: "江油市",
              },
              {
                i: 662029,
                n: "三台县",
              },
              {
                i: 663123,
                n: "盐亭县",
              },
              {
                i: 663970,
                n: "梓潼县",
              },
              {
                i: 664659,
                n: "平武县",
              },
              {
                i: 664344,
                n: "北川羌族自治县",
              },
            ],
          },
          {
            i: 665565,
            n: "广元市",
            c: [
              {
                i: 665567,
                n: "利州区",
              },
              {
                i: 665839,
                n: "昭化区",
              },
              {
                i: 666089,
                n: "朝天区",
              },
              {
                i: 666334,
                n: "旺苍县",
              },
              {
                i: 666755,
                n: "青川县",
              },
              {
                i: 667079,
                n: "剑阁县",
              },
              {
                i: 667719,
                n: "苍溪县",
              },
            ],
          },
          {
            i: 668542,
            n: "遂宁市",
            c: [
              {
                i: 668543,
                n: "市辖区",
              },
              {
                i: 668544,
                n: "船山区",
              },
              {
                i: 668851,
                n: "安居区",
              },
              {
                i: 669397,
                n: "蓬溪县",
              },
              {
                i: 669953,
                n: "射洪县",
              },
              {
                i: 670612,
                n: "大英县",
              },
            ],
          },
          {
            i: 670954,
            n: "内江市",
            c: [
              {
                i: 670956,
                n: "市中区",
              },
              {
                i: 671201,
                n: "东兴区",
              },
              {
                i: 672976,
                n: "隆昌市",
              },
              {
                i: 671712,
                n: "威远县",
              },
              {
                i: 672104,
                n: "资中县",
              },
            ],
          },
          {
            i: 673404,
            n: "乐山市",
            c: [
              {
                i: 673405,
                n: "市辖区",
              },
              {
                i: 673406,
                n: "市中区",
              },
              {
                i: 673741,
                n: "沙湾区",
              },
              {
                i: 673923,
                n: "五通桥区",
              },
              {
                i: 674108,
                n: "金口河区",
              },
              {
                i: 675814,
                n: "峨眉山市",
              },
              {
                i: 674160,
                n: "犍为县",
              },
              {
                i: 674573,
                n: "井研县",
              },
              {
                i: 674919,
                n: "夹江县",
              },
              {
                i: 675197,
                n: "沐川县",
              },
              {
                i: 675429,
                n: "峨边彝族自治县",
              },
              {
                i: 675585,
                n: "马边彝族自治县",
              },
            ],
          },
          {
            i: 676108,
            n: "南充市",
            c: [
              {
                i: 676109,
                n: "市辖区",
              },
              {
                i: 676110,
                n: "顺庆区",
              },
              {
                i: 676437,
                n: "高坪区",
              },
              {
                i: 676869,
                n: "嘉陵区",
              },
              {
                i: 681689,
                n: "阆中市",
              },
              {
                i: 677487,
                n: "南部县",
              },
              {
                i: 678660,
                n: "营山县",
              },
              {
                i: 679388,
                n: "蓬安县",
              },
              {
                i: 680051,
                n: "仪陇县",
              },
              {
                i: 681028,
                n: "西充县",
              },
            ],
          },
          {
            i: 682226,
            n: "眉山市",
            c: [
              {
                i: 682227,
                n: "市辖区",
              },
              {
                i: 682228,
                n: "东坡区",
              },
              {
                i: 683999,
                n: "彭山区",
              },
              {
                i: 682796,
                n: "仁寿县",
              },
              {
                i: 684217,
                n: "洪雅县",
              },
              {
                i: 684512,
                n: "丹棱县",
              },
              {
                i: 684657,
                n: "青神县",
              },
            ],
          },
          {
            i: 684831,
            n: "宜宾市",
            c: [
              {
                i: 684833,
                n: "翠屏区",
              },
              {
                i: 685200,
                n: "叙州区",
              },
              {
                i: 685807,
                n: "南溪区",
              },
              {
                i: 686057,
                n: "江安县",
              },
              {
                i: 686399,
                n: "长宁县",
              },
              {
                i: 686717,
                n: "高县",
              },
              {
                i: 687050,
                n: "珙县",
              },
              {
                i: 687346,
                n: "筠连县",
              },
              {
                i: 687622,
                n: "兴文县",
              },
              {
                i: 687981,
                n: "屏山县",
              },
            ],
          },
          {
            i: 688272,
            n: "广安市",
            c: [
              {
                i: 688273,
                n: "市辖区",
              },
              {
                i: 688274,
                n: "广安区",
              },
              {
                i: 768086,
                n: "前锋区",
              },
              {
                i: 691264,
                n: "华蓥市",
              },
              {
                i: 689213,
                n: "岳池县",
              },
              {
                i: 690123,
                n: "武胜县",
              },
              {
                i: 690697,
                n: "邻水县",
              },
            ],
          },
          {
            i: 691410,
            n: "达州市",
            c: [
              {
                i: 691411,
                n: "市辖区",
              },
              {
                i: 691412,
                n: "通川区",
              },
              {
                i: 691573,
                n: "达川区",
              },
              {
                i: 694416,
                n: "万源市",
              },
              {
                i: 692498,
                n: "宣汉县",
              },
              {
                i: 693100,
                n: "开江县",
              },
              {
                i: 693335,
                n: "大竹县",
              },
              {
                i: 693809,
                n: "渠县",
              },
            ],
          },
          {
            i: 694865,
            n: "雅安市",
            c: [
              {
                i: 694866,
                n: "市辖区",
              },
              {
                i: 694867,
                n: "雨城区",
              },
              {
                i: 695098,
                n: "名山区",
              },
              {
                i: 695321,
                n: "荥经县",
              },
              {
                i: 695452,
                n: "汉源县",
              },
              {
                i: 695754,
                n: "石棉县",
              },
              {
                i: 695875,
                n: "天全县",
              },
              {
                i: 696035,
                n: "芦山县",
              },
              {
                i: 696091,
                n: "宝兴县",
              },
            ],
          },
          {
            i: 696157,
            n: "巴中市",
            c: [
              {
                i: 696158,
                n: "市辖区",
              },
              {
                i: 696159,
                n: "巴州区",
              },
              {
                i: 768088,
                n: "恩阳区",
              },
              {
                i: 697101,
                n: "通江县",
              },
              {
                i: 697712,
                n: "南江县",
              },
              {
                i: 698369,
                n: "平昌县",
              },
            ],
          },
          {
            i: 698940,
            n: "资阳市",
            c: [
              {
                i: 698941,
                n: "市辖区",
              },
              {
                i: 698942,
                n: "雁江区",
              },
              {
                i: 699494,
                n: "安岳县",
              },
              {
                i: 700575,
                n: "乐至县",
              },
            ],
          },
          {
            i: 702109,
            n: "阿坝藏族羌族自治州",
            c: [
              {
                i: 702110,
                n: "汶川县",
              },
              {
                i: 702248,
                n: "理县",
              },
              {
                i: 702348,
                n: "茂县",
              },
              {
                i: 702523,
                n: "松潘县",
              },
              {
                i: 702699,
                n: "九寨沟县",
              },
              {
                i: 702849,
                n: "金川县",
              },
              {
                i: 702982,
                n: "小金县",
              },
              {
                i: 703140,
                n: "黑水县",
              },
              {
                i: 703284,
                n: "马尔康县",
              },
              {
                i: 703408,
                n: "壤塘县",
              },
              {
                i: 703482,
                n: "阿坝县",
              },
              {
                i: 703592,
                n: "若尔盖县",
              },
              {
                i: 703714,
                n: "红原县",
              },
            ],
          },
          {
            i: 703762,
            n: "甘孜藏族自治州",
            c: [
              {
                i: 703763,
                n: "康定市",
              },
              {
                i: 704029,
                n: "泸定县",
              },
              {
                i: 704104,
                n: "丹巴县",
              },
              {
                i: 704302,
                n: "九龙县",
              },
              {
                i: 704450,
                n: "雅江县",
              },
              {
                i: 704582,
                n: "道孚县",
              },
              {
                i: 704765,
                n: "炉霍县",
              },
              {
                i: 704864,
                n: "甘孜县",
              },
              {
                i: 705107,
                n: "新龙县",
              },
              {
                i: 705223,
                n: "德格县",
              },
              {
                i: 705424,
                n: "白玉县",
              },
              {
                i: 705598,
                n: "石渠县",
              },
              {
                i: 705788,
                n: "色达县",
              },
              {
                i: 705873,
                n: "理塘县",
              },
              {
                i: 706113,
                n: "巴塘县",
              },
              {
                i: 706256,
                n: "乡城县",
              },
              {
                i: 706323,
                n: "稻城县",
              },
              {
                i: 706461,
                n: "得荣县",
              },
            ],
          },
          {
            i: 706605,
            n: "凉山彝族自治州",
            c: [
              {
                i: 706606,
                n: "西昌市",
              },
              {
                i: 706906,
                n: "木里藏族自治县",
              },
              {
                i: 707049,
                n: "盐源县",
              },
              {
                i: 707331,
                n: "德昌县",
              },
              {
                i: 707497,
                n: "会理县",
              },
              {
                i: 707861,
                n: "会东县",
              },
              {
                i: 708239,
                n: "宁南县",
              },
              {
                i: 708392,
                n: "普格县",
              },
              {
                i: 708585,
                n: "布拖县",
              },
              {
                i: 708807,
                n: "金阳县",
              },
              {
                i: 709020,
                n: "昭觉县",
              },
              {
                i: 709340,
                n: "喜德县",
              },
              {
                i: 709537,
                n: "冕宁县",
              },
              {
                i: 709808,
                n: "越西县",
              },
              {
                i: 710143,
                n: "甘洛县",
              },
              {
                i: 710400,
                n: "美姑县",
              },
              {
                i: 710730,
                n: "雷波县",
              },
            ],
          },
        ],
      },
      {
        i: 711069,
        n: "天津市",
        c: [
          {
            i: 768111,
            n: "天津市",
            c: [
              {
                i: 711071,
                n: "和平区",
              },
              {
                i: 715035,
                n: "宁河区",
              },
              {
                i: 711143,
                n: "河东区",
              },
              {
                i: 715361,
                n: "静海区",
              },
              {
                i: 711301,
                n: "河西区",
              },
              {
                i: 711551,
                n: "南开区",
              },
              {
                i: 711820,
                n: "河北区",
              },
              {
                i: 711929,
                n: "红桥区",
              },
              {
                i: 715805,
                n: "蓟州区",
              },
              {
                i: 712109,
                n: "塘沽区",
              },
              {
                i: 712258,
                n: "汉沽区",
              },
              {
                i: 712371,
                n: "大港区",
              },
              {
                i: 712538,
                n: "东丽区",
              },
              {
                i: 712719,
                n: "西青区",
              },
              {
                i: 712948,
                n: "津南区",
              },
              {
                i: 713171,
                n: "北辰区",
              },
              {
                i: 713409,
                n: "武清区",
              },
              {
                i: 714206,
                n: "宝坻区",
              },
              {
                i: 768098,
                n: "滨海新区",
              },
            ],
          },
        ],
      },
      {
        i: 716798,
        n: "西藏自治区",
        c: [
          {
            i: 716799,
            n: "拉萨市",
            c: [
              {
                i: 716800,
                n: "城关区",
              },
              {
                i: 717061,
                n: "达孜区",
              },
              {
                i: 717018,
                n: "堆龙德庆区",
              },
              {
                i: 716852,
                n: "林周县",
              },
              {
                i: 716912,
                n: "当雄县",
              },
              {
                i: 716950,
                n: "尼木县",
              },
              {
                i: 716994,
                n: "曲水县",
              },
              {
                i: 717089,
                n: "墨竹工卡县",
              },
            ],
          },
          {
            i: 719300,
            n: "日喀则市",
            c: [
              {
                i: 719301,
                n: "桑珠孜区",
              },
              {
                i: 719494,
                n: "南木林县",
              },
              {
                i: 719664,
                n: "江孜县",
              },
              {
                i: 719843,
                n: "定日县",
              },
              {
                i: 720039,
                n: "萨迦县",
              },
              {
                i: 720181,
                n: "拉孜县",
              },
              {
                i: 720298,
                n: "昂仁县",
              },
              {
                i: 720507,
                n: "谢通门县",
              },
              {
                i: 720626,
                n: "白朗县",
              },
              {
                i: 720752,
                n: "仁布县",
              },
              {
                i: 720841,
                n: "康马县",
              },
              {
                i: 720899,
                n: "定结县",
              },
              {
                i: 720991,
                n: "仲巴县",
              },
              {
                i: 721064,
                n: "亚东县",
              },
              {
                i: 721097,
                n: "吉隆县",
              },
              {
                i: 721146,
                n: "聂拉木县",
              },
              {
                i: 721199,
                n: "萨嘎县",
              },
              {
                i: 721246,
                n: "岗巴县",
              },
            ],
          },
          {
            i: 717141,
            n: "昌都市",
            c: [
              {
                i: 717142,
                n: "卡若区",
              },
              {
                i: 717375,
                n: "江达县",
              },
              {
                i: 717483,
                n: "贡觉县",
              },
              {
                i: 717653,
                n: "类乌齐县",
              },
              {
                i: 717769,
                n: "丁青县",
              },
              {
                i: 717848,
                n: "察亚县",
              },
              {
                i: 718015,
                n: "八宿县",
              },
              {
                i: 718156,
                n: "左贡县",
              },
              {
                i: 718328,
                n: "芒康县",
              },
              {
                i: 718405,
                n: "洛隆县",
              },
              {
                i: 718493,
                n: "边坝县",
              },
            ],
          },
          {
            i: 722882,
            n: "林芝市",
            c: [
              {
                i: 722883,
                n: "巴宜区",
              },
              {
                i: 722967,
                n: "工布江达县",
              },
              {
                i: 723066,
                n: "米林县",
              },
              {
                i: 723146,
                n: "墨脱县",
              },
              {
                i: 723205,
                n: "波密县",
              },
              {
                i: 723306,
                n: "察隅县",
              },
              {
                i: 723409,
                n: "朗县",
              },
            ],
          },
          {
            i: 718610,
            n: "山南市",
            c: [
              {
                i: 718611,
                n: "乃东区",
              },
              {
                i: 718669,
                n: "扎囊县",
              },
              {
                i: 718740,
                n: "贡嘎县",
              },
              {
                i: 718792,
                n: "桑日县",
              },
              {
                i: 718841,
                n: "琼结县",
              },
              {
                i: 718867,
                n: "曲松县",
              },
              {
                i: 718894,
                n: "措美县",
              },
              {
                i: 718915,
                n: "洛扎县",
              },
              {
                i: 718949,
                n: "加查县",
              },
              {
                i: 719045,
                n: "隆子县",
              },
              {
                i: 719143,
                n: "错那县",
              },
              {
                i: 719179,
                n: "浪卡子县",
              },
            ],
          },
          {
            i: 721282,
            n: "那曲市",
            c: [
              {
                i: 721283,
                n: "那曲县",
              },
              {
                i: 721452,
                n: "嘉黎县",
              },
              {
                i: 721585,
                n: "比如县",
              },
              {
                i: 721792,
                n: "聂荣县",
              },
              {
                i: 721961,
                n: "安多县",
              },
              {
                i: 722054,
                n: "申扎县",
              },
              {
                i: 722136,
                n: "索县",
              },
              {
                i: 722279,
                n: "班戈县",
              },
              {
                i: 722385,
                n: "巴青县",
              },
              {
                i: 722558,
                n: "尼玛县",
              },
              {
                i: 768089,
                n: "双湖县",
              },
            ],
          },
          {
            i: 722694,
            n: "阿里地区",
            c: [
              {
                i: 722695,
                n: "普兰县",
              },
              {
                i: 722709,
                n: "札达县",
              },
              {
                i: 722731,
                n: "噶尔县",
              },
              {
                i: 722751,
                n: "日土县",
              },
              {
                i: 722771,
                n: "革吉县",
              },
              {
                i: 722797,
                n: "改则县",
              },
              {
                i: 722855,
                n: "措勤县",
              },
            ],
          },
        ],
      },
      {
        i: 723476,
        n: "新疆维吾尔自治区",
        c: [
          {
            i: 723477,
            n: "乌鲁木齐市",
            c: [
              {
                i: 723478,
                n: "市辖区",
              },
              {
                i: 723785,
                n: "新市区",
              },
              {
                i: 723479,
                n: "天山区",
              },
              {
                i: 723625,
                n: "沙依巴克区",
              },
              {
                i: 723909,
                n: "水磨沟区",
              },
              {
                i: 723985,
                n: "头屯河区",
              },
              {
                i: 724077,
                n: "达坂城区",
              },
              {
                i: 724118,
                n: "米东区",
              },
              {
                i: 724151,
                n: "乌鲁木齐县",
              },
            ],
          },
          {
            i: 724220,
            n: "克拉玛依市",
            c: [
              {
                i: 724221,
                n: "市辖区",
              },
              {
                i: 724222,
                n: "独山子区",
              },
              {
                i: 724241,
                n: "克拉玛依区",
              },
              {
                i: 724346,
                n: "白碱滩区",
              },
              {
                i: 724367,
                n: "乌尔禾区",
              },
            ],
          },
          {
            i: 724388,
            n: "吐鲁番市",
            c: [
              {
                i: 724389,
                n: "高昌区",
              },
              {
                i: 724492,
                n: "鄯善县",
              },
              {
                i: 724589,
                n: "托克逊县",
              },
            ],
          },
          {
            i: 724652,
            n: "哈密市",
            c: [
              {
                i: 724653,
                n: "伊州区",
              },
              {
                i: 724983,
                n: "伊吾县",
              },
              {
                i: 724893,
                n: "巴里坤哈萨克自治县",
              },
            ],
          },
          {
            i: 728067,
            n: "阿克苏地区",
            c: [
              {
                i: 728068,
                n: "阿克苏市",
              },
              {
                i: 728544,
                n: "库车市",
              },
              {
                i: 728352,
                n: "温宿县",
              },
              {
                i: 728837,
                n: "沙雅县",
              },
              {
                i: 729023,
                n: "新和县",
              },
              {
                i: 729169,
                n: "拜城县",
              },
              {
                i: 729371,
                n: "乌什县",
              },
              {
                i: 729508,
                n: "阿瓦提县",
              },
              {
                i: 729713,
                n: "柯坪县",
              },
            ],
          },
          {
            i: 730130,
            n: "喀什地区",
            c: [
              {
                i: 730131,
                n: "喀什市",
              },
              {
                i: 730300,
                n: "疏附县",
              },
              {
                i: 730499,
                n: "疏勒县",
              },
              {
                i: 730762,
                n: "英吉沙县",
              },
              {
                i: 730955,
                n: "泽普县",
              },
              {
                i: 731129,
                n: "莎车县",
              },
              {
                i: 731690,
                n: "叶城县",
              },
              {
                i: 732037,
                n: "麦盖提县",
              },
              {
                i: 732233,
                n: "岳普湖县",
              },
              {
                i: 732348,
                n: "伽师县",
              },
              {
                i: 732684,
                n: "巴楚县",
              },
              {
                i: 732926,
                n: "塔什库尔干塔吉克自治县",
              },
            ],
          },
          {
            i: 732988,
            n: "和田地区",
            c: [
              {
                i: 732989,
                n: "和田市",
              },
              {
                i: 733143,
                n: "和田县",
              },
              {
                i: 733367,
                n: "墨玉县",
              },
              {
                i: 733779,
                n: "皮山县",
              },
              {
                i: 733987,
                n: "洛浦县",
              },
              {
                i: 734214,
                n: "策勒县",
              },
              {
                i: 734362,
                n: "于田县",
              },
              {
                i: 734559,
                n: "民丰县",
              },
            ],
          },
          {
            i: 735987,
            n: "塔城地区",
            c: [
              {
                i: 735988,
                n: "塔城市",
              },
              {
                i: 736205,
                n: "乌苏市",
              },
              {
                i: 736589,
                n: "额敏县",
              },
              {
                i: 736855,
                n: "沙湾县",
              },
              {
                i: 737377,
                n: "托里县",
              },
              {
                i: 737473,
                n: "裕民县",
              },
              {
                i: 737554,
                n: "和布克赛尔蒙古自治县",
              },
            ],
          },
          {
            i: 737663,
            n: "阿勒泰地区",
            c: [
              {
                i: 737664,
                n: "阿勒泰市",
              },
              {
                i: 737830,
                n: "布尔津县",
              },
              {
                i: 737907,
                n: "富蕴县",
              },
              {
                i: 738000,
                n: "福海县",
              },
              {
                i: 738171,
                n: "哈巴河县",
              },
              {
                i: 738315,
                n: "青河县",
              },
              {
                i: 738382,
                n: "吉木乃县",
              },
            ],
          },
          {
            i: 725030,
            n: "昌吉回族自治州",
            c: [
              {
                i: 725031,
                n: "昌吉市",
              },
              {
                i: 725217,
                n: "阜康市",
              },
              {
                i: 725387,
                n: "米泉市",
              },
              {
                i: 725496,
                n: "呼图壁县",
              },
              {
                i: 725695,
                n: "玛纳斯县",
              },
              {
                i: 726058,
                n: "奇台县",
              },
              {
                i: 726248,
                n: "吉木萨尔县",
              },
              {
                i: 726472,
                n: "木垒哈萨克自治县",
              },
            ],
          },
          {
            i: 726556,
            n: "博尔塔拉蒙古自治州",
            c: [
              {
                i: 726557,
                n: "博乐市",
              },
              {
                i: 768090,
                n: "阿拉山口市",
              },
              {
                i: 726834,
                n: "精河县",
              },
              {
                i: 726977,
                n: "温泉县",
              },
            ],
          },
          {
            i: 727104,
            n: "巴音郭楞蒙古自治州",
            c: [
              {
                i: 727105,
                n: "库尔勒市",
              },
              {
                i: 727355,
                n: "轮台县",
              },
              {
                i: 727442,
                n: "尉犁县",
              },
              {
                i: 727581,
                n: "若羌县",
              },
              {
                i: 727625,
                n: "且末县",
              },
              {
                i: 727797,
                n: "和静县",
              },
              {
                i: 727957,
                n: "和硕县",
              },
              {
                i: 728018,
                n: "博湖县",
              },
              {
                i: 727704,
                n: "焉耆回族自治县",
              },
            ],
          },
          {
            i: 729754,
            n: "克孜勒苏柯尔克孜自治州",
            c: [
              {
                i: 729755,
                n: "阿图什市",
              },
              {
                i: 729883,
                n: "阿克陶县",
              },
              {
                i: 730031,
                n: "阿合奇县",
              },
              {
                i: 730068,
                n: "乌恰县",
              },
            ],
          },
          {
            i: 734603,
            n: "伊犁哈萨克自治州",
            c: [
              {
                i: 734604,
                n: "伊宁市",
              },
              {
                i: 734753,
                n: "奎屯市",
              },
              {
                i: 768091,
                n: "霍尔果斯市",
              },
              {
                i: 734822,
                n: "伊宁县",
              },
              {
                i: 735153,
                n: "霍城县",
              },
              {
                i: 735377,
                n: "巩留县",
              },
              {
                i: 735496,
                n: "新源县",
              },
              {
                i: 735646,
                n: "昭苏县",
              },
              {
                i: 735793,
                n: "特克斯县",
              },
              {
                i: 735877,
                n: "尼勒克县",
              },
              {
                i: 735010,
                n: "察布查尔锡伯自治县",
              },
            ],
          },
          {
            i: 738443,
            n: "省直辖行政单位",
            c: [
              {
                i: 738444,
                n: "石河子市",
              },
              {
                i: 738609,
                n: "阿拉尔市",
              },
              {
                i: 738828,
                n: "图木舒克市",
              },
              {
                i: 738962,
                n: "五家渠市",
              },
              {
                i: 768092,
                n: "北屯市",
              },
              {
                i: 768093,
                n: "铁门关市",
              },
              {
                i: 768094,
                n: "双河市",
              },
              {
                i: 768095,
                n: "可克达拉市",
              },
            ],
          },
        ],
      },
      {
        i: 739032,
        n: "云南省",
        c: [
          {
            i: 739033,
            n: "昆明市",
            c: [
              {
                i: 739035,
                n: "五华区",
              },
              {
                i: 739151,
                n: "盘龙区",
              },
              {
                i: 739225,
                n: "官渡区",
              },
              {
                i: 739334,
                n: "西山区",
              },
              {
                i: 739440,
                n: "东川区",
              },
              {
                i: 739608,
                n: "呈贡区",
              },
              {
                i: 739681,
                n: "晋宁区",
              },
              {
                i: 740673,
                n: "安宁市",
              },
              {
                i: 739824,
                n: "富民县",
              },
              {
                i: 739907,
                n: "宜良县",
              },
              {
                i: 740155,
                n: "嵩明县",
              },
              {
                i: 740054,
                n: "石林彝族自治县",
              },
              {
                i: 740272,
                n: "禄劝彝族苗族自治县",
              },
              {
                i: 740483,
                n: "寻甸回族彝族自治县",
              },
            ],
          },
          {
            i: 740775,
            n: "曲靖市",
            c: [
              {
                i: 740777,
                n: "麒麟区",
              },
              {
                i: 741989,
                n: "沾益区",
              },
              {
                i: 740908,
                n: "马龙区",
              },
              {
                i: 742120,
                n: "宣威市",
              },
              {
                i: 740983,
                n: "陆良县",
              },
              {
                i: 741134,
                n: "师宗县",
              },
              {
                i: 741252,
                n: "罗平县",
              },
              {
                i: 741420,
                n: "富源县",
              },
              {
                i: 741591,
                n: "会泽县",
              },
            ],
          },
          {
            i: 742502,
            n: "玉溪市",
            c: [
              {
                i: 742504,
                n: "红塔区",
              },
              {
                i: 742597,
                n: "江川区",
              },
              {
                i: 742677,
                n: "澄江市",
              },
              {
                i: 742724,
                n: "通海县",
              },
              {
                i: 742805,
                n: "华宁县",
              },
              {
                i: 742889,
                n: "易门县",
              },
              {
                i: 742953,
                n: "峨山彝族自治县",
              },
              {
                i: 743040,
                n: "新平彝族傣族自治县",
              },
              {
                i: 743175,
                n: "元江哈尼族彝族傣族自治县",
              },
            ],
          },
          {
            i: 743265,
            n: "保山市",
            c: [
              {
                i: 743266,
                n: "市辖区",
              },
              {
                i: 743267,
                n: "隆阳区",
              },
              {
                i: 743751,
                n: "腾冲市",
              },
              {
                i: 743600,
                n: "施甸县",
              },
              {
                i: 743991,
                n: "龙陵县",
              },
              {
                i: 744123,
                n: "昌宁县",
              },
            ],
          },
          {
            i: 744263,
            n: "昭通市",
            c: [
              {
                i: 744264,
                n: "市辖区",
              },
              {
                i: 744265,
                n: "昭阳区",
              },
              {
                i: 744464,
                n: "鲁甸县",
              },
              {
                i: 744561,
                n: "巧家县",
              },
              {
                i: 744761,
                n: "盐津县",
              },
              {
                i: 744858,
                n: "大关县",
              },
              {
                i: 744946,
                n: "永善县",
              },
              {
                i: 745099,
                n: "绥江县",
              },
              {
                i: 745140,
                n: "镇雄县",
              },
              {
                i: 745413,
                n: "彝良县",
              },
              {
                i: 745566,
                n: "威信县",
              },
              {
                i: 745664,
                n: "水富县",
              },
            ],
          },
          {
            i: 745693,
            n: "丽江市",
            c: [
              {
                i: 745695,
                n: "古城区",
              },
              {
                i: 745875,
                n: "永胜县",
              },
              {
                i: 746038,
                n: "华坪县",
              },
              {
                i: 745758,
                n: "玉龙纳西族自治县",
              },
              {
                i: 746107,
                n: "宁蒗彝族自治县",
              },
            ],
          },
          {
            i: 746214,
            n: "普洱市",
            c: [
              {
                i: 746216,
                n: "思茅区",
              },
              {
                i: 746296,
                n: "宁洱哈尼族彝族自治县",
              },
              {
                i: 746395,
                n: "墨江哈尼族自治县",
              },
              {
                i: 746579,
                n: "景东彝族自治县",
              },
              {
                i: 746763,
                n: "景谷傣族彝族自治县",
              },
              {
                i: 746909,
                n: "镇沅彝族哈尼族拉祜族自治县",
              },
              {
                i: 747030,
                n: "江城哈尼族彝族自治县",
              },
              {
                i: 747097,
                n: "孟连傣族拉祜族佤族自治县",
              },
              {
                i: 747148,
                n: "澜沧拉祜族自治县",
              },
              {
                i: 747330,
                n: "西盟佤族自治县",
              },
            ],
          },
          {
            i: 747377,
            n: "临沧市",
            c: [
              {
                i: 747378,
                n: "市辖区",
              },
              {
                i: 747379,
                n: "临翔区",
              },
              {
                i: 747492,
                n: "凤庆县",
              },
              {
                i: 747693,
                n: "云县",
              },
              {
                i: 747900,
                n: "永德县",
              },
              {
                i: 748032,
                n: "镇康县",
              },
              {
                i: 748113,
                n: "双江县",
              },
              {
                i: 748201,
                n: "耿马县",
              },
              {
                i: 748307,
                n: "沧源县",
              },
            ],
          },
          {
            i: 748416,
            n: "楚雄彝族自治州",
            c: [
              {
                i: 748417,
                n: "楚雄市",
              },
              {
                i: 749446,
                n: "禄丰市",
              },
              {
                i: 748585,
                n: "双柏县",
              },
              {
                i: 748678,
                n: "牟定县",
              },
              {
                i: 748775,
                n: "南华县",
              },
              {
                i: 748914,
                n: "姚安县",
              },
              {
                i: 749002,
                n: "大姚县",
              },
              {
                i: 749144,
                n: "永仁县",
              },
              {
                i: 749215,
                n: "元谋县",
              },
              {
                i: 749304,
                n: "武定县",
              },
            ],
          },
          {
            i: 749624,
            n: "红河哈尼族彝族自治州",
            c: [
              {
                i: 749625,
                n: "个旧市",
              },
              {
                i: 749750,
                n: "开远市",
              },
              {
                i: 749832,
                n: "蒙自市",
              },
              {
                i: 750324,
                n: "弥勒市",
              },
              {
                i: 750032,
                n: "建水县",
              },
              {
                i: 750199,
                n: "石屏县",
              },
              {
                i: 750478,
                n: "泸西县",
              },
              {
                i: 750568,
                n: "元阳县",
              },
              {
                i: 750720,
                n: "红河县",
              },
              {
                i: 750937,
                n: "绿春县",
              },
              {
                i: 749944,
                n: "屏边苗族自治县",
              },
              {
                i: 750825,
                n: "金平苗族瑶族傣族自治县",
              },
              {
                i: 751030,
                n: "河口瑶族自治县",
              },
            ],
          },
          {
            i: 751071,
            n: "文山壮族苗族自治州",
            c: [
              {
                i: 751072,
                n: "文山市",
              },
              {
                i: 751225,
                n: "砚山县",
              },
              {
                i: 751342,
                n: "西畴县",
              },
              {
                i: 751424,
                n: "麻栗坡县",
              },
              {
                i: 751534,
                n: "马关县",
              },
              {
                i: 751674,
                n: "丘北县",
              },
              {
                i: 751786,
                n: "广南县",
              },
              {
                i: 751981,
                n: "富宁县",
              },
            ],
          },
          {
            i: 752142,
            n: "西双版纳傣族自治州",
            c: [
              {
                i: 752143,
                n: "景洪市",
              },
              {
                i: 752280,
                n: "勐海县",
              },
              {
                i: 752386,
                n: "勐腊县",
              },
            ],
          },
          {
            i: 752477,
            n: "大理白族自治州",
            c: [
              {
                i: 752478,
                n: "大理市",
              },
              {
                i: 752696,
                n: "祥云县",
              },
              {
                i: 752843,
                n: "宾川县",
              },
              {
                i: 752945,
                n: "弥渡县",
              },
              {
                i: 753226,
                n: "永平县",
              },
              {
                i: 753307,
                n: "云龙县",
              },
              {
                i: 753405,
                n: "洱源县",
              },
              {
                i: 753505,
                n: "剑川县",
              },
              {
                i: 753609,
                n: "鹤庆县",
              },
              {
                i: 752620,
                n: "漾濞彝族自治县",
              },
              {
                i: 753043,
                n: "南涧彝族自治县",
              },
              {
                i: 753132,
                n: "巍山彝族回族自治县",
              },
            ],
          },
          {
            i: 753733,
            n: "德宏傣族景颇族自治州",
            c: [
              {
                i: 753734,
                n: "瑞丽市",
              },
              {
                i: 753789,
                n: "芒市",
              },
              {
                i: 753889,
                n: "梁河县",
              },
              {
                i: 753965,
                n: "盈江县",
              },
              {
                i: 754081,
                n: "陇川县",
              },
            ],
          },
          {
            i: 754163,
            n: "怒江傈僳族自治州",
            c: [
              {
                i: 754164,
                n: "泸水市",
              },
              {
                i: 754249,
                n: "福贡县",
              },
              {
                i: 754315,
                n: "贡山独龙族怒族自治县",
              },
              {
                i: 754349,
                n: "兰坪白族普米族自治县",
              },
            ],
          },
          {
            i: 754465,
            n: "迪庆藏族自治州",
            c: [
              {
                i: 754466,
                n: "香格里拉市",
              },
              {
                i: 754541,
                n: "德钦县",
              },
              {
                i: 754592,
                n: "维西傈僳族自治县",
              },
            ],
          },
        ],
      },
      {
        i: 18047,
        n: "浙江省",
        c: [
          {
            i: 18048,
            n: "杭州市",
            c: [
              {
                i: 18050,
                n: "上城区",
              },
              {
                i: 18320,
                n: "拱墅区",
              },
              {
                i: 18417,
                n: "西湖区",
              },
              {
                i: 18612,
                n: "滨江区",
              },
              {
                i: 18651,
                n: "萧山区",
              },
              {
                i: 19236,
                n: "余杭区",
              },
              {
                i: 21275,
                n: "富阳区",
              },
              {
                i: 21935,
                n: "临安区",
              },
              {
                i: 768118,
                n: "临平区",
              },
              {
                i: 768117,
                n: "钱塘区",
              },
              {
                i: 20717,
                n: "建德市",
              },
              {
                i: 19574,
                n: "桐庐县",
              },
              {
                i: 19784,
                n: "淳安县",
              },
            ],
          },
          {
            i: 22636,
            n: "宁波市",
            c: [
              {
                i: 22638,
                n: "海曙区",
              },
              {
                i: 22801,
                n: "江北区",
              },
              {
                i: 22963,
                n: "北仑区",
              },
              {
                i: 23237,
                n: "镇海区",
              },
              {
                i: 23330,
                n: "鄞州区",
              },
              {
                i: 25496,
                n: "奉化区",
              },
              {
                i: 24810,
                n: "余姚市",
              },
              {
                i: 25130,
                n: "慈溪市",
              },
              {
                i: 23841,
                n: "象山县",
              },
              {
                i: 24372,
                n: "宁海县",
              },
            ],
          },
          {
            i: 25884,
            n: "温州市",
            c: [
              {
                i: 25886,
                n: "鹿城区",
              },
              {
                i: 26198,
                n: "龙湾区",
              },
              {
                i: 26357,
                n: "瓯海区",
              },
              {
                i: 26636,
                n: "洞头区",
              },
              {
                i: 29977,
                n: "瑞安市",
              },
              {
                i: 30964,
                n: "乐清市",
              },
              {
                i: 28459,
                n: "龙港市",
              },
              {
                i: 26736,
                n: "永嘉县",
              },
              {
                i: 27684,
                n: "平阳县",
              },
              {
                i: 28323,
                n: "苍南县",
              },
              {
                i: 29213,
                n: "文成县",
              },
              {
                i: 29639,
                n: "泰顺县",
              },
            ],
          },
          {
            i: 31894,
            n: "嘉兴市",
            c: [
              {
                i: 31895,
                n: "市辖区",
              },
              {
                i: 31896,
                n: "南湖区",
              },
              {
                i: 32055,
                n: "秀洲区",
              },
              {
                i: 32557,
                n: "海宁市",
              },
              {
                i: 32793,
                n: "平湖市",
              },
              {
                i: 32984,
                n: "桐乡市",
              },
              {
                i: 32222,
                n: "嘉善县",
              },
              {
                i: 32421,
                n: "海盐县",
              },
            ],
          },
          {
            i: 33214,
            n: "湖州市",
            c: [
              {
                i: 33215,
                n: "市辖区",
              },
              {
                i: 33216,
                n: "吴兴区",
              },
              {
                i: 33532,
                n: "南浔区",
              },
              {
                i: 33791,
                n: "德清县",
              },
              {
                i: 33997,
                n: "长兴县",
              },
              {
                i: 34295,
                n: "安吉县",
              },
            ],
          },
          {
            i: 34575,
            n: "绍兴市",
            c: [
              {
                i: 34576,
                n: "市辖区",
              },
              {
                i: 34577,
                n: "越城区",
              },
              {
                i: 35006,
                n: "柯桥区",
              },
              {
                i: 36442,
                n: "上虞区",
              },
              {
                i: 35888,
                n: "诸暨市",
              },
              {
                i: 36905,
                n: "嵊州市",
              },
              {
                i: 35439,
                n: "新昌县",
              },
            ],
          },
          {
            i: 38035,
            n: "金华市",
            c: [
              {
                i: 38036,
                n: "市辖区",
              },
              {
                i: 38037,
                n: "婺城区",
              },
              {
                i: 38759,
                n: "金东区",
              },
              {
                i: 40690,
                n: "兰溪市",
              },
              {
                i: 41378,
                n: "义乌市",
              },
              {
                i: 42195,
                n: "东阳市",
              },
              {
                i: 42605,
                n: "永康市",
              },
              {
                i: 39278,
                n: "武义县",
              },
              {
                i: 39853,
                n: "浦江县",
              },
              {
                i: 40298,
                n: "磐安县",
              },
            ],
          },
          {
            i: 43349,
            n: "衢州市",
            c: [
              {
                i: 43350,
                n: "市辖区",
              },
              {
                i: 43351,
                n: "柯城区",
              },
              {
                i: 43700,
                n: "衢江区",
              },
              {
                i: 45528,
                n: "江山市",
              },
              {
                i: 44235,
                n: "常山县",
              },
              {
                i: 44599,
                n: "开化县",
              },
              {
                i: 45072,
                n: "龙游县",
              },
            ],
          },
          {
            i: 46108,
            n: "舟山市",
            c: [
              {
                i: 46109,
                n: "市辖区",
              },
              {
                i: 46110,
                n: "定海区",
              },
              {
                i: 46275,
                n: "普陀区",
              },
              {
                i: 46492,
                n: "岱山县",
              },
              {
                i: 46596,
                n: "嵊泗县",
              },
            ],
          },
          {
            i: 46652,
            n: "台州市",
            c: [
              {
                i: 46654,
                n: "椒江区",
              },
              {
                i: 46967,
                n: "黄岩区",
              },
              {
                i: 47555,
                n: "路桥区",
              },
              {
                i: 50083,
                n: "温岭市",
              },
              {
                i: 51022,
                n: "临海市",
              },
              {
                i: 47866,
                n: "玉环市",
              },
              {
                i: 48179,
                n: "三门县",
              },
              {
                i: 48714,
                n: "天台县",
              },
              {
                i: 49339,
                n: "仙居县",
              },
            ],
          },
          {
            i: 52064,
            n: "丽水市",
            c: [
              {
                i: 52065,
                n: "市辖区",
              },
              {
                i: 52066,
                n: "莲都区",
              },
              {
                i: 55370,
                n: "龙泉市",
              },
              {
                i: 52479,
                n: "青田县",
              },
              {
                i: 52972,
                n: "缙云县",
              },
              {
                i: 53645,
                n: "遂昌县",
              },
              {
                i: 54063,
                n: "松阳县",
              },
              {
                i: 54496,
                n: "云和县",
              },
              {
                i: 54687,
                n: "庆元县",
              },
              {
                i: 55058,
                n: "景宁畲族自治县",
              },
            ],
          },
        ],
      },
      {
        i: 754685,
        n: "重庆市",
        c: [
          {
            i: 768112,
            n: "重庆市",
            c: [
              {
                i: 754687,
                n: "万州区",
              },
              {
                i: 759737,
                n: "綦江区",
              },
              {
                i: 755371,
                n: "涪陵区",
              },
              {
                i: 760118,
                n: "潼南区",
              },
              {
                i: 755834,
                n: "渝中区",
              },
              {
                i: 760445,
                n: "铜梁区",
              },
              {
                i: 755956,
                n: "大渡口区",
              },
              {
                i: 761090,
                n: "大足区",
              },
              {
                i: 756038,
                n: "江北区",
              },
              {
                i: 761407,
                n: "荣昌区",
              },
              {
                i: 756173,
                n: "沙坪坝区",
              },
              {
                i: 761678,
                n: "璧山区",
              },
              {
                i: 756401,
                n: "九龙坡区",
              },
              {
                i: 761877,
                n: "梁平区",
              },
              {
                i: 756614,
                n: "南岸区",
              },
              {
                i: 756770,
                n: "北碚区",
              },
              {
                i: 756966,
                n: "万盛区",
              },
              {
                i: 757061,
                n: "双桥区",
              },
              {
                i: 763196,
                n: "武隆区",
              },
              {
                i: 757087,
                n: "渝北区",
              },
              {
                i: 757448,
                n: "巴南区",
              },
              {
                i: 763828,
                n: "开州区",
              },
              {
                i: 757752,
                n: "黔江区",
              },
              {
                i: 758005,
                n: "长寿区",
              },
              {
                i: 758271,
                n: "江津区",
              },
              {
                i: 758565,
                n: "合川区",
              },
              {
                i: 759167,
                n: "永川区",
              },
              {
                i: 759445,
                n: "南川区",
              },
              {
                i: 768103,
                n: "两江新区",
              },
              {
                i: 768104,
                n: "高新区",
              },
              {
                i: 762253,
                n: "城口县",
              },
              {
                i: 762481,
                n: "丰都县",
              },
              {
                i: 762867,
                n: "垫江县",
              },
              {
                i: 763436,
                n: "忠县",
              },
              {
                i: 764375,
                n: "云阳县",
              },
              {
                i: 765053,
                n: "奉节县",
              },
              {
                i: 765470,
                n: "巫山县",
              },
              {
                i: 765842,
                n: "巫溪县",
              },
              {
                i: 766248,
                n: "石柱土家族自治县",
              },
              {
                i: 766522,
                n: "秀山土家族苗族自治县",
              },
              {
                i: 766818,
                n: "酉阳土家族苗族自治县",
              },
              {
                i: 767136,
                n: "彭水苗族土家族自治县",
              },
            ],
          },
        ],
      },
    ],
  },
];
export default regionSeatLibs;
